export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = {
    [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
    [SubKey in K]?: Maybe<T[SubKey]>;
};
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
    [SubKey in K]: Maybe<T[SubKey]>;
};
export type MakeEmpty<
    T extends { [key: string]: unknown },
    K extends keyof T,
> = { [_ in K]?: never };
export type Incremental<T> =
    | T
    | {
          [P in keyof T]?: P extends ' $fragmentName' | '__typename'
              ? T[P]
              : never;
      };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
    ID: { input: string; output: string };
    String: { input: string; output: string };
    Boolean: { input: boolean; output: boolean };
    Int: { input: number; output: number };
    Float: { input: number; output: number };
    /** Date custom scalar type */
    DateTime: { input: Date; output: Date };
    /** JSON scalar */
    Json: { input: unknown; output: unknown };
};

/** Result for addFriendship */
export type AddFriendshipResult = CoinsResultSuccess | ResultError;

export type AgeFilter = {
    gt?: InputMaybe<Scalars['Int']['input']>;
    gte?: InputMaybe<Scalars['Int']['input']>;
    lt?: InputMaybe<Scalars['Int']['input']>;
    lte?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate for own conversations */
export type AggregateConversationsResult = {
    __typename: 'AggregateConversationsResult';
    _sum?: Maybe<ConversationProfileAggregate>;
};

export type AllEnum = {
    __typename: 'AllEnum';
    PeriodUnit: Array<PeriodUnit>;
    PeriodUnitOffer: Array<PeriodUnitOffer>;
};

/** Avatar is a feature and not available for all projects */
export type Avatar = {
    __typename: 'Avatar';
    /** cuid */
    avatarId: Scalars['String']['output'];
    gender: Gender;
    name?: Maybe<Scalars['String']['output']>;
    /** relative image path */
    path: Scalars['String']['output'];
    /** translations for avatars, not filtered if no login */
    translations: Array<Translation>;
};

/** Avatar is a feature and not available for all projects */
export type AvatarPathArgs = {
    relative?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Avatar is a feature and not available for all projects */
export type AvatarWhereInput = {
    gender?: InputMaybe<EnumGenderFilter>;
};

export type BankData = {
    __typename: 'BankData';
    bank?: Maybe<Scalars['String']['output']>;
    beneficiary: Scalars['String']['output'];
    bic: Scalars['String']['output'];
    iban: Scalars['String']['output'];
};

export type BatchPayload = {
    __typename: 'BatchPayload';
    count: Scalars['Int']['output'];
};

export type BlockProfileInput = {
    /** this will be nonNullable in future releases */
    complainType?: InputMaybe<ComplainTypeWhereUniqueInput>;
    profileId: Scalars['String']['input'];
};

export const BlockType = {
    Blocked: 'Blocked',
    Hidden: 'Hidden',
    None: 'None',
} as const;

export type BlockType = (typeof BlockType)[keyof typeof BlockType];
export type Blocked = {
    __typename: 'Blocked';
    /** identifier cuid */
    blockedId: Scalars['String']['output'];
    createdAt: Scalars['DateTime']['output'];
    /** other [Profile]({{Types.Profile}}) node */
    other: Profile;
    /** profileId from other Profile */
    otherId: Scalars['String']['output'];
};

export type BlockedOrderByInput = {
    /** cuid of Blocked */
    blockedId?: InputMaybe<SortOrder>;
    /** DateTime profile was blocked */
    createdAt?: InputMaybe<SortOrder>;
    /** profileId of blocked Profile */
    otherId?: InputMaybe<SortOrder>;
    /** own profileId */
    selfId?: InputMaybe<SortOrder>;
};

export type BlockedWhereInput = {
    /** combine search filter with AND */
    AND?: InputMaybe<Array<BlockedWhereInput>>;
    /** combine search filter with NOT */
    NOT?: InputMaybe<Array<BlockedWhereInput>>;
    /** combine search filter with OR */
    OR?: InputMaybe<Array<BlockedWhereInput>>;
    /** identifier cuid */
    blockedId?: InputMaybe<StringFilter>;
    /** DateTime Blocked was created */
    createdAt?: InputMaybe<DateTimeFilter>;
    /** Profile node from other Profile */
    other?: InputMaybe<ProfileWhereInput>;
    /** profileId from other Profile */
    otherId?: InputMaybe<StringFilter>;
};

export type BlockedWhereUniqueInput = {
    /** combine unique index: own profileId and other profileId */
    selfId_otherId: SelfIdOtherIdCompoundUniqueInput;
};

export type BoolFilter = {
    equals?: InputMaybe<Scalars['Boolean']['input']>;
    not?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BoolNullableFilter = {
    equals?: InputMaybe<Scalars['Boolean']['input']>;
    not?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ChangeFriendshipInput = {
    /** cuid other Profile */
    otherId: Scalars['String']['input'];
    /** only Accepted or Declined */
    status: FriendshipStatus;
};

export type ChangePictureResult = Error | Picture;

export type CoinsHistory = {
    __typename: 'CoinsHistory';
    /** description of action */
    action: Scalars['String']['output'];
    /** amount of coins changed by this action */
    coins: Scalars['Int']['output'];
    /** identifier cuid */
    coinsHistoryId: Scalars['String']['output'];
    /** DateTime coins changed */
    createdAt: Scalars['DateTime']['output'];
    /** own User node */
    user: User;
    /** own userId */
    userId: Scalars['String']['output'];
};

/** Union of ResultError and CoinsResultSuccess */
export type CoinsResult = CoinsResultSuccess | ResultError;

/** Result after spend/receive coins */
export type CoinsResultSuccess = {
    __typename: 'CoinsResultSuccess';
    /** current amount of coins */
    coins: Scalars['Int']['output'];
    /** increased coins in this request */
    increasedCoins?: Maybe<Scalars['Int']['output']>;
    /** spent coins in this request */
    spentCoins?: Maybe<Scalars['Int']['output']>;
};

export type ComplainType = {
    __typename: 'ComplainType';
    /** identifier cuid */
    complainTypeId: Scalars['String']['output'];
    /** unique name */
    name: Scalars['String']['output'];
    /** List of Translation nodes, filtered by user language */
    translations: Array<Translation>;
    type: ComplainTypeType;
};

export type ComplainTypeCreateOneWithoutUserComplainInput = {
    connect: ComplainTypeWhereUniqueInput;
};

export const ComplainTypeType = {
    Conversation: 'Conversation',
    Image: 'Image',
    Message: 'Message',
    Picture: 'Picture',
    Profile: 'Profile',
} as const;

export type ComplainTypeType =
    (typeof ComplainTypeType)[keyof typeof ComplainTypeType];
export type ComplainTypeWhereUniqueInput = {
    /** identifier cuid */
    complainTypeId?: InputMaybe<Scalars['String']['input']>;
    /** unique name */
    name?: InputMaybe<Scalars['String']['input']>;
};

export type Config = {
    __typename: 'Config';
    /** amount of coins user gets after activation */
    activateBonus: Scalars['Int']['output'];
    /** all costs */
    cost: Cost;
    /** amount of coins user gets after login per day */
    dailyLoginBonus: Scalars['Int']['output'];
    /** amount of coins user gets for the first flirtText */
    firstFlirtTextBonus: Scalars['Int']['output'];
    /** amount of coins user gets after uploading first image */
    firstImageBonus: Scalars['Int']['output'];
    /** amount of coins user gets after providing mobile number */
    mobileNumberBonus: Scalars['Int']['output'];
    /** amount of coins user gets after provide additional information */
    profileFlagsBonus: Scalars['Int']['output'];
};

export type ContactSupportInput = {
    category?: SupportCategory;
    email: Scalars['String']['input'];
    subject: Scalars['String']['input'];
    text: Scalars['String']['input'];
};

export type Conversation = {
    __typename: 'Conversation';
    /** conversation is a blind chat */
    blind: Scalars['Boolean']['output'];
    /** identifier no cuid!, build from all participants */
    conversationId: Scalars['String']['output'];
    /** no costs for this conversation */
    free: Scalars['Boolean']['output'];
    /** DateTime of last action in conversation */
    lastAction?: Maybe<Scalars['DateTime']['output']>;
    /** Message node of last message wrote */
    lastMessage?: Maybe<Message>;
    /** cuid of last message in conversation */
    lastMessageId?: Maybe<Scalars['String']['output']>;
    /** cost per message for this conversation */
    messageCost: Scalars['Int']['output'];
    /** length of one message, cost = ceil(text.length/messageLength) */
    messageLength: Scalars['Int']['output'];
    /** list of messages, max take = (-)10 */
    messages: Array<Message>;
    /** list of conversationProfile, a conversation can have X >= 2 participants include own Profile */
    profiles: Array<ConversationProfile>;
    /** support dialog, no answer possible */
    support: Scalars['Boolean']['output'];
};

export type ConversationMessagesArgs = {
    cursor?: InputMaybe<MessageWhereUniqueInput>;
    orderBy?: InputMaybe<MessageOrderByInput>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<MessageWhereInput>;
};

export type ConversationProfilesArgs = {
    where?: InputMaybe<ConversationProfileWhereInput>;
};

/** unique identifier */
export type ConversationIdProfileIdCompoundUniqueInput = {
    conversationId: Scalars['String']['input'];
    profileId: Scalars['String']['input'];
};

export type ConversationOrderByInput = {
    /** conversationId is not a cuid, for sorting by DateTime use lastAction */
    conversationId?: InputMaybe<SortOrder>;
    lastAction?: InputMaybe<SortOrder>;
};

export type ConversationProfile = ConversationProfileInterface & {
    __typename: 'ConversationProfile';
    /** Conversation node */
    conversation: Conversation;
    /** identifier of Conversation node, no cuid! */
    conversationId: Scalars['String']['output'];
    /** identifier cuid */
    conversationProfileId: Scalars['String']['output'];
    /** number of free messages left */
    freeMessages: Scalars['Int']['output'];
    /** number of sent gifts */
    giftsSend: Scalars['Int']['output'];
    /** number of unread gifts */
    giftsUnread: Scalars['Int']['output'];
    /** number of sent messages, MessageType = Message | PredefinedMessage */
    messagesSend: Scalars['Int']['output'];
    /** number of unread messages, MessageType = Message | PredefinedMessage */
    messagesUnread: Scalars['Int']['output'];
    /** number of sent pictures */
    picturesSend: Scalars['Int']['output'];
    /** number of unread pictures */
    picturesUnread: Scalars['Int']['output'];
    /** number of sent pokes */
    pokesSend: Scalars['Int']['output'];
    /** number of unread pokes */
    pokesUnread: Scalars['Int']['output'];
    /** Profile node */
    profile: Profile;
    /** cuid of Profile node */
    profileId: Scalars['String']['output'];
    /** sum of all sent */
    send: Scalars['Int']['output'];
    /** sum of all unread */
    unread: Scalars['Int']['output'];
};

/** node for using ConversationProfileInterface */
export type ConversationProfileAggregate = ConversationProfileInterface & {
    __typename: 'ConversationProfileAggregate';
    /** number of free messages left */
    freeMessages: Scalars['Int']['output'];
    /** number of sent gifts */
    giftsSend: Scalars['Int']['output'];
    /** number of unread gifts */
    giftsUnread: Scalars['Int']['output'];
    /** number of sent messages, MessageType = Message | PredefinedMessage */
    messagesSend: Scalars['Int']['output'];
    /** number of unread messages, MessageType = Message | PredefinedMessage */
    messagesUnread: Scalars['Int']['output'];
    /** number of sent pictures */
    picturesSend: Scalars['Int']['output'];
    /** number of unread pictures */
    picturesUnread: Scalars['Int']['output'];
    /** number of sent pokes */
    pokesSend: Scalars['Int']['output'];
    /** number of unread pokes */
    pokesUnread: Scalars['Int']['output'];
    /** sum of all sent */
    send: Scalars['Int']['output'];
    /** sum of all unread */
    unread: Scalars['Int']['output'];
};

/** choose which fields should be aggregate */
export type ConversationProfileCountAggregateInputType = {
    _all?: InputMaybe<Scalars['Boolean']['input']>;
    freeMessages?: InputMaybe<Scalars['Boolean']['input']>;
    giftsSend?: InputMaybe<Scalars['Boolean']['input']>;
    giftsUnread?: InputMaybe<Scalars['Boolean']['input']>;
    messagesSend?: InputMaybe<Scalars['Boolean']['input']>;
    messagesUnread?: InputMaybe<Scalars['Boolean']['input']>;
    picturesSend?: InputMaybe<Scalars['Boolean']['input']>;
    picturesUnread?: InputMaybe<Scalars['Boolean']['input']>;
    pokesSend?: InputMaybe<Scalars['Boolean']['input']>;
    pokesUnread?: InputMaybe<Scalars['Boolean']['input']>;
    send?: InputMaybe<Scalars['Boolean']['input']>;
    unread?: InputMaybe<Scalars['Boolean']['input']>;
};

export const ConversationProfileDistinctFieldEnum = {
    Blocked: 'blocked',
    ConversationId: 'conversationId',
    ConversationProfileId: 'conversationProfileId',
    CreatedAt: 'createdAt',
    FreeMessages: 'freeMessages',
    GiftsSend: 'giftsSend',
    GiftsUnread: 'giftsUnread',
    MessagesSend: 'messagesSend',
    MessagesUnread: 'messagesUnread',
    PicturesSend: 'picturesSend',
    PicturesUnread: 'picturesUnread',
    PokesSend: 'pokesSend',
    PokesUnread: 'pokesUnread',
    ProfileId: 'profileId',
    Send: 'send',
    Unread: 'unread',
    UpdatedAt: 'updatedAt',
} as const;

export type ConversationProfileDistinctFieldEnum =
    (typeof ConversationProfileDistinctFieldEnum)[keyof typeof ConversationProfileDistinctFieldEnum];
export type ConversationProfileInterface = {
    /** number of free messages left */
    freeMessages: Scalars['Int']['output'];
    /** number of sent gifts */
    giftsSend: Scalars['Int']['output'];
    /** number of unread gifts */
    giftsUnread: Scalars['Int']['output'];
    /** number of sent messages, MessageType = Message | PredefinedMessage */
    messagesSend: Scalars['Int']['output'];
    /** number of unread messages, MessageType = Message | PredefinedMessage */
    messagesUnread: Scalars['Int']['output'];
    /** number of sent pictures */
    picturesSend: Scalars['Int']['output'];
    /** number of unread pictures */
    picturesUnread: Scalars['Int']['output'];
    /** number of sent pokes */
    pokesSend: Scalars['Int']['output'];
    /** number of unread pokes */
    pokesUnread: Scalars['Int']['output'];
    /** sum of all sent */
    send: Scalars['Int']['output'];
    /** sum of all unread */
    unread: Scalars['Int']['output'];
};

export type ConversationProfileListRelationFilter = {
    every?: InputMaybe<ConversationProfileWhereInput>;
    none?: InputMaybe<ConversationProfileWhereInput>;
    some?: InputMaybe<ConversationProfileWhereInput>;
};

export type ConversationProfileOrderByInput = {
    blocked?: InputMaybe<SortOrder>;
    conversationId?: InputMaybe<SortOrder>;
    conversationProfileId?: InputMaybe<SortOrder>;
    createdAt?: InputMaybe<SortOrder>;
    freeMessages?: InputMaybe<SortOrder>;
    giftsSend?: InputMaybe<SortOrder>;
    giftsUnread?: InputMaybe<SortOrder>;
    messagesSend?: InputMaybe<SortOrder>;
    messagesUnread?: InputMaybe<SortOrder>;
    picturesSend?: InputMaybe<SortOrder>;
    picturesUnread?: InputMaybe<SortOrder>;
    pokesSend?: InputMaybe<SortOrder>;
    pokesUnread?: InputMaybe<SortOrder>;
    profileId?: InputMaybe<SortOrder>;
    send?: InputMaybe<SortOrder>;
    unread?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

/** choose which fields should be aggregate */
export type ConversationProfileSumAggregateInputType = {
    freeMessages?: InputMaybe<Scalars['Boolean']['input']>;
    giftsSend?: InputMaybe<Scalars['Boolean']['input']>;
    giftsUnread?: InputMaybe<Scalars['Boolean']['input']>;
    messagesSend?: InputMaybe<Scalars['Boolean']['input']>;
    messagesUnread?: InputMaybe<Scalars['Boolean']['input']>;
    picturesSend?: InputMaybe<Scalars['Boolean']['input']>;
    picturesUnread?: InputMaybe<Scalars['Boolean']['input']>;
    pokesSend?: InputMaybe<Scalars['Boolean']['input']>;
    pokesUnread?: InputMaybe<Scalars['Boolean']['input']>;
    send?: InputMaybe<Scalars['Boolean']['input']>;
    unread?: InputMaybe<Scalars['Boolean']['input']>;
};

/** filter for ConversationProfile node */
export type ConversationProfileWhereInput = {
    blocked?: InputMaybe<BoolNullableFilter>;
    conversationId?: InputMaybe<StringFilter>;
    createdAt?: InputMaybe<DateTimeFilter>;
    giftsUnread?: InputMaybe<IntNullableFilter>;
    hidden?: InputMaybe<BoolNullableFilter>;
    messagesUnread?: InputMaybe<IntNullableFilter>;
    picturesUnread?: InputMaybe<IntNullableFilter>;
    pokesUnread?: InputMaybe<IntNullableFilter>;
    profileId?: InputMaybe<StringFilter>;
    send?: InputMaybe<IntNullableFilter>;
    unread?: InputMaybe<IntNullableFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
};

export type ConversationProfileWhereUniqueInput = {
    conversationId_profileId: ConversationIdProfileIdCompoundUniqueInput;
};

export type ConversationWhereInput = {
    /** combine search filter with AND */
    AND?: InputMaybe<Array<ConversationWhereInput>>;
    /** combine search filter with NOT */
    NOT?: InputMaybe<Array<ConversationWhereInput>>;
    /** combine search filter with OR */
    OR?: InputMaybe<Array<ConversationWhereInput>>;
    blind?: InputMaybe<BoolNullableFilter>;
    conversationId?: InputMaybe<StringFilter>;
    free?: InputMaybe<BoolNullableFilter>;
    lastAction?: InputMaybe<DateTimeNullableFilter>;
    lastMessageId?: InputMaybe<StringNullableFilter>;
    messages?: InputMaybe<MessageListRelationFilter>;
    profiles?: InputMaybe<ConversationProfileListRelationFilter>;
    support?: InputMaybe<BoolNullableFilter>;
};

/** unique identifiers for one conversation */
export type ConversationWhereUniqueInput = {
    conversationId?: InputMaybe<Scalars['String']['input']>;
    receivers?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

/** cost and additional information per type */
export type Cost = {
    __typename: 'Cost';
    eyeCatcher?: Maybe<CostNode>;
    friendship: CostNode;
    match?: Maybe<CostNode>;
    message: MessageCost;
    picture?: Maybe<CostNode>;
    poke: PokeCost;
    /**
     * **[PredefinedMessage]({{Types.PredefinedMessage}}) is
     *             a feature and not available for all projects**
     */
    predefinedMessage?: Maybe<CostNode>;
};

export type CostNode = {
    __typename: 'CostNode';
    cost: Scalars['Int']['output'];
};

export type Coupon = {
    __typename: 'Coupon';
    /** unique */
    code: Scalars['String']['output'];
};

export type CouponWhereUniqueInput = {
    /** unique identifier */
    code: Scalars['String']['input'];
};

/** **DailySong is a feature and not available for all projects** */
export type DailySong = {
    __typename: 'DailySong';
    dailySongId: Scalars['String']['output'];
    name: Scalars['String']['output'];
    /** youtube video link */
    path: Scalars['String']['output'];
};

export type DateTimeFilter = {
    gt?: InputMaybe<Scalars['DateTime']['input']>;
    gte?: InputMaybe<Scalars['DateTime']['input']>;
    lt?: InputMaybe<Scalars['DateTime']['input']>;
    lte?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DateTimeNullableFilter = {
    gt?: InputMaybe<Scalars['DateTime']['input']>;
    gte?: InputMaybe<Scalars['DateTime']['input']>;
    lt?: InputMaybe<Scalars['DateTime']['input']>;
    lte?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DeactivatedPush = {
    __typename: 'DeactivatedPush';
    /** cuid */
    deactivatedPushId: Scalars['String']['output'];
    /** PushSetting node */
    setting: PushSetting;
};

export type DeactivatedPushChangeInput = {
    deactivate: Scalars['Boolean']['input'];
    setting: PushSetting;
};

export type DeactivatedPushCreateWithoutUserInput = {
    id?: InputMaybe<Scalars['String']['input']>;
    setting?: InputMaybe<PushSetting>;
};

export const DeactivatedPushDistinctFieldEnum = {
    DeactivatedPushId: 'deactivatedPushId',
    Setting: 'setting',
    UserId: 'userId',
} as const;

export type DeactivatedPushDistinctFieldEnum =
    (typeof DeactivatedPushDistinctFieldEnum)[keyof typeof DeactivatedPushDistinctFieldEnum];
export type DeactivatedPushOrderByInput = {
    deactivatedPushId?: InputMaybe<SortOrder>;
    setting?: InputMaybe<SortOrder>;
};

export type DeactivatedPushScalarWhereInput = {
    deactivatedPushId?: InputMaybe<StringFilter>;
    setting?: InputMaybe<EnumPushSettingFilter>;
    userId?: InputMaybe<StringFilter>;
};

export type DeactivatedPushUpdateManyWithoutUserInput = {
    create?: InputMaybe<Array<DeactivatedPushCreateWithoutUserInput>>;
    delete?: InputMaybe<Array<DeactivatedPushWhereUniqueInput>>;
    deleteMany?: InputMaybe<Array<DeactivatedPushScalarWhereInput>>;
};

export type DeactivatedPushWhereInput = {
    deactivatedPushId?: InputMaybe<StringFilter>;
    setting?: InputMaybe<EnumPushSettingFilter>;
};

/** unique identifier */
export type DeactivatedPushWhereUniqueInput = {
    userId_setting: UserIdSettingCompoundUniqueInput;
};

export type DeleteAccountInput = {
    deleteHash: Scalars['String']['input'];
};

export type DeleteAccountResult = ResultError | ResultSuccess;

export type DeleteGalleryImageInput = {
    imageId: Scalars['String']['input'];
};

export type EnumBlockTypeNullableFilter = {
    equals?: InputMaybe<BlockType>;
    in?: InputMaybe<Array<InputMaybe<BlockType>>>;
    not?: InputMaybe<BlockType>;
    notIn?: InputMaybe<Array<InputMaybe<BlockType>>>;
};

export type EnumFriendshipStatusFilter = {
    equals?: InputMaybe<FriendshipStatus>;
    in?: InputMaybe<Array<InputMaybe<FriendshipStatus>>>;
    not?: InputMaybe<FriendshipStatus>;
    notIn?: InputMaybe<Array<InputMaybe<FriendshipStatus>>>;
};

export type EnumGenderFilter = {
    equals?: InputMaybe<Gender>;
    in?: InputMaybe<Array<InputMaybe<Gender>>>;
    not?: InputMaybe<Gender>;
    notIn?: InputMaybe<Array<InputMaybe<Gender>>>;
};

export type EnumMatchTypeFilter = {
    equals?: InputMaybe<MatchType>;
    in?: InputMaybe<Array<InputMaybe<MatchType>>>;
    not?: InputMaybe<MatchType>;
    notIn?: InputMaybe<Array<InputMaybe<MatchType>>>;
};

export type EnumMessageTypeFilter = {
    equals?: InputMaybe<MessageType>;
    in?: InputMaybe<Array<InputMaybe<MessageType>>>;
    not?: InputMaybe<MessageType>;
    notIn?: InputMaybe<Array<InputMaybe<MessageType>>>;
};

export type EnumNotificationTypeFilter = {
    equals?: InputMaybe<NotificationType>;
    in?: InputMaybe<Array<InputMaybe<NotificationType>>>;
    not?: InputMaybe<NotificationType>;
    notIn?: InputMaybe<Array<InputMaybe<NotificationType>>>;
};

export type EnumPushSettingFilter = {
    equals?: InputMaybe<PushSetting>;
    in?: InputMaybe<Array<InputMaybe<PushSetting>>>;
    not?: InputMaybe<PushSetting>;
    notIn?: InputMaybe<Array<InputMaybe<PushSetting>>>;
};

export type EnumSupportTicketStatusFilter = {
    equals?: InputMaybe<SupportTicketStatus>;
    in?: InputMaybe<Array<InputMaybe<SupportTicketStatus>>>;
    not?: InputMaybe<SupportTicketStatus>;
    notIn?: InputMaybe<Array<InputMaybe<SupportTicketStatus>>>;
};

export type Error = {
    __typename: 'Error';
    errorCode: Scalars['Int']['output'];
    errorMessage: ErrorCodes;
};

export const ErrorCodes = {
    Age: 'AGE',
    AgeLength: 'AGE_LENGTH',
    CoinsFailure: 'COINS_FAILURE',
    CoinsMissing: 'COINS_MISSING',
    ConversationNotFound: 'CONVERSATION_NOT_FOUND',
    CountryInvalid: 'COUNTRY_INVALID',
    CountryNotExists: 'COUNTRY_NOT_EXISTS',
    CouponInvalid: 'COUPON_INVALID',
    CouponRedeemed: 'COUPON_REDEEMED',
    Default: 'DEFAULT',
    EmailAlreadySet: 'EMAIL_ALREADY_SET',
    EmailExists: 'EMAIL_EXISTS',
    EmailInvalid: 'EMAIL_INVALID',
    FlirttextMaxChars: 'FLIRTTEXT_MAX_CHARS',
    InputIncorrect: 'INPUT_INCORRECT',
    LanguageExists: 'LANGUAGE_EXISTS',
    LoginInvalid: 'LOGIN_INVALID',
    LoginUserBlocked: 'LOGIN_USER_BLOCKED',
    LoginUserDeleted: 'LOGIN_USER_DELETED',
    MainImageNotFound: 'MAIN_IMAGE_NOT_FOUND',
    MatchBuyMore: 'MATCH_BUY_MORE',
    MatchLimit: 'MATCH_LIMIT',
    MatchLimitBuyMore: 'MATCH_LIMIT_BUY_MORE',
    MatchNotActive: 'MATCH_NOT_ACTIVE',
    MatchNotFound: 'MATCH_NOT_FOUND',
    MobilenumberAlreadySet: 'MOBILENUMBER_ALREADY_SET',
    MobilenumberExists: 'MOBILENUMBER_EXISTS',
    MobilenumberInvalid: 'MOBILENUMBER_INVALID',
    PasswordMaxChars: 'PASSWORD_MAX_CHARS',
    PasswordMinChars: 'PASSWORD_MIN_CHARS',
    PictureNotFound: 'PICTURE_NOT_FOUND',
    PictureNotVerified: 'PICTURE_NOT_VERIFIED',
    PostcodeInvalid: 'POSTCODE_INVALID',
    PostcodeNotExists: 'POSTCODE_NOT_EXISTS',
    ProfileNotFound: 'PROFILE_NOT_FOUND',
    ProviderInvalid: 'PROVIDER_INVALID',
    StatusFailure: 'STATUS_FAILURE',
    Timezone: 'TIMEZONE',
    TownInvalid: 'TOWN_INVALID',
    TownNotExists: 'TOWN_NOT_EXISTS',
    TransactionCallbackCaptureFailed: 'TRANSACTION_CALLBACK_CAPTURE_FAILED',
    TransactionCallbackCorruptedData: 'TRANSACTION_CALLBACK_CORRUPTED_DATA',
    TransactionCallbackFailed: 'TRANSACTION_CALLBACK_FAILED',
    TransactionCallbackInvalidData: 'TRANSACTION_CALLBACK_INVALID_DATA',
    TransactionCallbackWrongAmount: 'TRANSACTION_CALLBACK_WRONG_AMOUNT',
    TransactionCreateFailed: 'TRANSACTION_CREATE_FAILED',
    TransactionLimitReached: 'TRANSACTION_LIMIT_REACHED',
    TransactionOfferInactive: 'TRANSACTION_OFFER_INACTIVE',
    TransactionOfferInvalid: 'TRANSACTION_OFFER_INVALID',
    TransactionOfferPremiumActive: 'TRANSACTION_OFFER_PREMIUM_ACTIVE',
    TransactionProjectMismatch: 'TRANSACTION_PROJECT_MISMATCH',
    UsernameExists: 'USERNAME_EXISTS',
    UsernameInvalid: 'USERNAME_INVALID',
    UsernameMaxChars: 'USERNAME_MAX_CHARS',
    UsernameMinChars: 'USERNAME_MIN_CHARS',
    UsernameMissing: 'USERNAME_MISSING',
} as const;

export type ErrorCodes = (typeof ErrorCodes)[keyof typeof ErrorCodes];
export type EyeCatcher = {
    __typename: 'EyeCatcher';
    /** cuid */
    eyeCatcherId: Scalars['String']['output'];
    /** Image node */
    image: Image;
    /** cuid of Image node */
    imageId: Scalars['String']['output'];
    /** Profile node */
    profile: Profile;
    /** cuid of Profile node */
    profileId: Scalars['String']['output'];
};

export type EyeCatcherCreateInput = {
    image: ImageCreateOneWithoutEyeCatcherInput;
};

export type EyeCatcherWhereInput = {
    AND?: InputMaybe<Array<InputMaybe<EyeCatcherWhereInput>>>;
    NOT?: InputMaybe<Array<InputMaybe<EyeCatcherWhereInput>>>;
    OR?: InputMaybe<Array<InputMaybe<EyeCatcherWhereInput>>>;
    profile?: InputMaybe<ProfileWhereInput>;
};

export type EyeCatcherWhereUniqueInput = {
    eyeCatcherId: Scalars['String']['input'];
};

export type Favorite = {
    __typename: 'Favorite';
    createdAt: Scalars['DateTime']['output'];
    favoriteId: Scalars['String']['output'];
    /** other Profile node */
    other: Profile;
    /** profileId (cuid) of other Profile */
    otherId: Scalars['String']['output'];
};

export type FavoriteOrderByInput = {
    createdAt?: InputMaybe<SortOrder>;
    favoriteId?: InputMaybe<SortOrder>;
    otherId?: InputMaybe<SortOrder>;
    selfId?: InputMaybe<SortOrder>;
};

export type FavoriteWhereInput = {
    createdAt?: InputMaybe<DateTimeFilter>;
    favoriteId?: InputMaybe<StringFilter>;
    other?: InputMaybe<ProfileWhereInput>;
    otherId?: InputMaybe<StringFilter>;
};

/** unique identifier */
export type FavoriteWhereUniqueInput = {
    selfId_otherId: SelfIdOtherIdCompoundUniqueInput;
};

export type Flag = {
    __typename: 'Flag';
    flagId: Scalars['String']['output'];
    flagValues: Array<FlagValue>;
    gender: FlagGender;
    max?: Maybe<Scalars['Int']['output']>;
    maxLength: Scalars['Int']['output'];
    min?: Maybe<Scalars['Int']['output']>;
    minLength: Scalars['Int']['output'];
    name: Scalars['String']['output'];
    numberStep?: Maybe<Scalars['String']['output']>;
    regEx?: Maybe<Scalars['String']['output']>;
    translations: Array<Translation>;
    type: FlagType;
};

export type FlagCreateNestedOneWithoutProfileFlagsInput = {
    connect: FlagWhereUniqueInput;
};

export const FlagGender = {
    All: 'All',
    Divers: 'Divers',
    Female: 'Female',
    Male: 'Male',
} as const;

export type FlagGender = (typeof FlagGender)[keyof typeof FlagGender];
export const FlagType = {
    InputNumber: 'InputNumber',
    InputString: 'InputString',
    Select: 'Select',
} as const;

export type FlagType = (typeof FlagType)[keyof typeof FlagType];
export type FlagValue = {
    __typename: 'FlagValue';
    flagId: Scalars['String']['output'];
    flagValueId: Scalars['String']['output'];
    translations: Array<Translation>;
};

export type FlagValueCreateNestedOneWithoutProfileFlagsInput = {
    connect: FlagValueWhereUniqueInput;
};

export type FlagValueWhereUniqueInput = {
    flagValueId: Scalars['String']['input'];
};

export type FlagWhereUniqueInput = {
    flagId: Scalars['String']['input'];
};

export type FloatFilter = {
    equals?: InputMaybe<Scalars['Float']['input']>;
    gt?: InputMaybe<Scalars['Float']['input']>;
    gte?: InputMaybe<Scalars['Float']['input']>;
    in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
    lt?: InputMaybe<Scalars['Float']['input']>;
    lte?: InputMaybe<Scalars['Float']['input']>;
    not?: InputMaybe<Scalars['Float']['input']>;
    notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export type ForgottenPasswordInput = {
    email?: InputMaybe<Scalars['String']['input']>;
    username?: InputMaybe<Scalars['String']['input']>;
};

export type Friendship = {
    __typename: 'Friendship';
    /** cuid */
    friendshipId: Scalars['String']['output'];
    /** other Profile node */
    other: Profile;
    /** cuid of other Profile */
    otherId: Scalars['String']['output'];
    status: FriendshipStatus;
    updatedAt: Scalars['DateTime']['output'];
};

export type FriendshipOrderByInput = {
    createdAt?: InputMaybe<SortOrder>;
    friendshipId?: InputMaybe<SortOrder>;
    status?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export const FriendshipStatus = {
    Accepted: 'Accepted',
    Declined: 'Declined',
    Pending: 'Pending',
    Sent: 'Sent',
} as const;

export type FriendshipStatus =
    (typeof FriendshipStatus)[keyof typeof FriendshipStatus];
export type FriendshipWhereInput = {
    createdAt?: InputMaybe<DateTimeFilter>;
    friendshipId?: InputMaybe<StringFilter>;
    otherId?: InputMaybe<StringFilter>;
    selfId?: InputMaybe<StringFilter>;
    status?: InputMaybe<EnumFriendshipStatusFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
};

export type FriendshipWhereUniqueInput = {
    selfId_otherId: SelfIdOtherIdCompoundUniqueInput;
};

export const Gender = {
    Divers: 'Divers',
    Female: 'Female',
    Male: 'Male',
} as const;

export type Gender = (typeof Gender)[keyof typeof Gender];
export type Geolocation = {
    __typename: 'Geolocation';
    community?: Maybe<Scalars['String']['output']>;
    country: Scalars['String']['output'];
    /** cuid */
    geolocationId: Scalars['String']['output'];
    iso: Scalars['String']['output'];
    latitude: Scalars['String']['output'];
    location: Scalars['String']['output'];
    longitude: Scalars['String']['output'];
    postcode: Scalars['String']['output'];
    province?: Maybe<Scalars['String']['output']>;
    state?: Maybe<Scalars['String']['output']>;
};

export const GeolocationDistinctFieldEnum = {
    Iso: 'iso',
    Postcode: 'postcode',
    Province: 'province',
    State: 'state',
} as const;

export type GeolocationDistinctFieldEnum =
    (typeof GeolocationDistinctFieldEnum)[keyof typeof GeolocationDistinctFieldEnum];
export type GeolocationOrderByInput = {
    community?: InputMaybe<SortOrder>;
    country?: InputMaybe<SortOrder>;
    geolocationId?: InputMaybe<SortOrder>;
    latitude?: InputMaybe<SortOrder>;
    location?: InputMaybe<SortOrder>;
    longitude?: InputMaybe<SortOrder>;
    postcode?: InputMaybe<SortOrder>;
    province?: InputMaybe<SortOrder>;
    state?: InputMaybe<SortOrder>;
};

export type GeolocationWhereInput = {
    AND?: InputMaybe<Array<InputMaybe<GeolocationWhereInput>>>;
    NOT?: InputMaybe<Array<InputMaybe<GeolocationWhereInput>>>;
    OR?: InputMaybe<Array<InputMaybe<GeolocationWhereInput>>>;
    community?: InputMaybe<StringNullableFilter>;
    country?: InputMaybe<StringFilter>;
    geolocationId?: InputMaybe<StringFilter>;
    /** upperCase ISO String e.g. "DE" */
    iso?: InputMaybe<StringFilter>;
    location?: InputMaybe<StringFilter>;
    postcode?: InputMaybe<StringFilter>;
    province?: InputMaybe<StringNullableFilter>;
    state?: InputMaybe<StringNullableFilter>;
};

export type GeolocationWhereUniqueInput = {
    geolocationId: Scalars['String']['input'];
};

export type Gift = {
    __typename: 'Gift';
    cost: Scalars['Int']['output'];
    /** cuid */
    giftId: Scalars['String']['output'];
    name: Scalars['String']['output'];
    /** relative theme image path */
    path: Scalars['String']['output'];
    /** translations if user login filtered by user.languageCode */
    translations: Array<Translation>;
};

export type GiftPathArgs = {
    relative?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GiftCategory = {
    __typename: 'GiftCategory';
    /** cuid */
    giftCategoryId: Scalars['String']['output'];
    gifts: Array<Gift>;
    name: Scalars['String']['output'];
    /** translations if user login filtered by user.languageCode */
    translations: Array<Translation>;
};

export type GiftCategoryOrderByInput = {
    name: SortOrder;
};

export type GiftCategoryWhereInput = {
    giftCategoryId?: InputMaybe<Scalars['String']['input']>;
    name?: InputMaybe<Scalars['String']['input']>;
};

export type GiftCategoryWhereUniqueInput = {
    giftCategoryId: Scalars['String']['input'];
};

/** user receivers for new conversation or conversation to answer */
export type GiftInput = {
    conversation?: InputMaybe<ConversationWhereUniqueInput>;
    gift: GiftWhereUniqueInput;
    receivers?: InputMaybe<Array<ProfileWhereUniqueInput>>;
    text?: InputMaybe<Scalars['String']['input']>;
};

export type GiftWhereInput = {
    categoryId: Scalars['String']['input'];
};

export type GiftWhereUniqueInput = {
    giftId: Scalars['String']['input'];
};

export type Image = {
    __typename: 'Image';
    /** cuid */
    imageId: Scalars['String']['output'];
    /** main image of Profile */
    main: Scalars['Boolean']['output'];
    /** absolute image path */
    path: Scalars['String']['output'];
    /** image is private, only visible (path) if Accepted Friendship */
    private: Scalars['Boolean']['output'];
    /** Profile node */
    profile: Profile;
    /** cuid of Profile */
    profileId: Scalars['String']['output'];
    userChanged: Scalars['DateTime']['output'];
    /** all images have to be verified by adminUser */
    verified: Scalars['Boolean']['output'];
};

export type ImagePathArgs = {
    relative?: InputMaybe<Scalars['Boolean']['input']>;
    size?: InputMaybe<Scalars['Int']['input']>;
};

export type ImageCreateOneWithoutEyeCatcherInput = {
    connect?: InputMaybe<ImageWhereUniqueInput>;
};

export const ImageDistinctFieldEnum = {
    Fsk18: 'fsk18',
    ImageId: 'imageId',
    Main: 'main',
    Path: 'path',
    Private: 'private',
    ProfileId: 'profileId',
    UserChanged: 'userChanged',
    Verified: 'verified',
} as const;

export type ImageDistinctFieldEnum =
    (typeof ImageDistinctFieldEnum)[keyof typeof ImageDistinctFieldEnum];
export type ImageListRelationFilter = {
    every?: InputMaybe<ImageWhereInput>;
    none?: InputMaybe<ImageWhereInput>;
    some?: InputMaybe<ImageWhereInput>;
};

export type ImageOrderByInput = {
    fsk18?: InputMaybe<SortOrder>;
    imageId?: InputMaybe<SortOrder>;
    main?: InputMaybe<SortOrder>;
    path?: InputMaybe<SortOrder>;
    private?: InputMaybe<SortOrder>;
    profileId?: InputMaybe<SortOrder>;
    userChanged?: InputMaybe<SortOrder>;
    verified?: InputMaybe<SortOrder>;
};

export type ImageWhereInput = {
    imageId?: InputMaybe<StringFilter>;
    main?: InputMaybe<BoolFilter>;
    path?: InputMaybe<StringFilter>;
    private?: InputMaybe<BoolFilter>;
    profileId?: InputMaybe<StringFilter>;
    userChanged?: InputMaybe<DateTimeFilter>;
};

export type ImageWhereUniqueInput = {
    imageId?: InputMaybe<Scalars['String']['input']>;
    path?: InputMaybe<Scalars['String']['input']>;
};

export type IntFilter = {
    equals?: InputMaybe<Scalars['Int']['input']>;
    gt?: InputMaybe<Scalars['Int']['input']>;
    gte?: InputMaybe<Scalars['Int']['input']>;
    in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
    lt?: InputMaybe<Scalars['Int']['input']>;
    lte?: InputMaybe<Scalars['Int']['input']>;
    not?: InputMaybe<Scalars['Int']['input']>;
    notIn?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export type IntNullableFilter = {
    equals?: InputMaybe<Scalars['Int']['input']>;
    gt?: InputMaybe<Scalars['Int']['input']>;
    gte?: InputMaybe<Scalars['Int']['input']>;
    in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
    lt?: InputMaybe<Scalars['Int']['input']>;
    lte?: InputMaybe<Scalars['Int']['input']>;
    not?: InputMaybe<Scalars['Int']['input']>;
    notIn?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export type Interest = {
    __typename: 'Interest';
    /** @deprecated use category queries, no circular reference */
    category: InterestCategory;
    /** cuid of InterestCategory */
    categoryId: Scalars['String']['output'];
    /** optional css class use by font */
    class?: Maybe<Scalars['String']['output']>;
    /** cuid */
    interestId: Scalars['String']['output'];
    name: Scalars['String']['output'];
    /** optional relative image path */
    path?: Maybe<Scalars['String']['output']>;
    /** translations if user login filtered by user.languageCode */
    translations: Array<Translation>;
};

export type InterestCategory = {
    __typename: 'InterestCategory';
    /** cuid */
    interestCategoryId: Scalars['String']['output'];
    interests: Array<Interest>;
    name: Scalars['String']['output'];
    /** translations if user login filtered by user.languageCode */
    translations: Array<Translation>;
};

export type InterestCategoryWhereUniqueInput = {
    interestCategoryId: Scalars['String']['input'];
};

export const InterestDistinctFieldEnum = {
    CategoryId: 'categoryId',
    Class: 'class',
    InterestId: 'interestId',
    Name: 'name',
} as const;

export type InterestDistinctFieldEnum =
    (typeof InterestDistinctFieldEnum)[keyof typeof InterestDistinctFieldEnum];
export type InterestWhereInput = {
    categoryId: Scalars['String']['input'];
};

export type InterestWhereUniqueInput = {
    interestId: Scalars['String']['input'];
};

export type Language = {
    __typename: 'Language';
    /** unique identifier */
    code: Scalars['String']['output'];
    name: Scalars['String']['output'];
};

export type Lead = {
    __typename: 'Lead';
    /** cuid */
    leadId: Scalars['String']['output'];
    name: Scalars['String']['output'];
};

export type LeadCreateOneWithoutUserLeadInput = {
    connect?: InputMaybe<LeadWhereUniqueInput>;
};

export type LeadWhereUniqueInput = {
    leadId?: InputMaybe<Scalars['String']['input']>;
    name?: InputMaybe<Scalars['String']['input']>;
};

/**
 * [likeProfile]({{Mutations.likeProfile}})
 *     is a feature and not available for all projects
 */
export type LikeProfileInput = {
    /** cuid of Profile */
    profileId: Scalars['String']['input'];
};

export type LocationInput = {
    accuracy: Scalars['String']['input'];
    city?: InputMaybe<Scalars['String']['input']>;
    community: Scalars['String']['input'];
    community_code: Scalars['String']['input'];
    country: Scalars['String']['input'];
    county: Scalars['String']['input'];
    county_code: Scalars['String']['input'];
    id: Scalars['String']['input'];
    latitude?: InputMaybe<Scalars['String']['input']>;
    longitude?: InputMaybe<Scalars['String']['input']>;
    postcode: Scalars['String']['input'];
    state: Scalars['String']['input'];
    state_code: Scalars['String']['input'];
    state_code_dc: Scalars['String']['input'];
};

export type LoginInput = {
    client?: InputMaybe<Scalars['String']['input']>;
    clientVersion?: InputMaybe<Scalars['String']['input']>;
    password: Scalars['String']['input'];
    timezone?: InputMaybe<Scalars['String']['input']>;
    /** Username or email */
    username: Scalars['String']['input'];
};

export type LoginMd5Input = {
    client?: InputMaybe<Scalars['String']['input']>;
    clientVersion?: InputMaybe<Scalars['String']['input']>;
    md5: Scalars['String']['input'];
    timezone?: InputMaybe<Scalars['String']['input']>;
    /** Username or email */
    username: Scalars['String']['input'];
};

export type LoginResult = LoginResultSuccess | ResultError;

export type LoginResultSuccess = {
    __typename: 'LoginResultSuccess';
    coins: Scalars['Int']['output'];
    cost: Cost;
    deactivatedPushes: Array<Maybe<DeactivatedPush>>;
    freePokes: Scalars['Int']['output'];
    myProfile: MyProfile;
    role: UserRole;
    token: Scalars['String']['output'];
    user: User;
    userId: Scalars['String']['output'];
};

export type LoginStreak = {
    __typename: 'LoginStreak';
    /** coins given after the user has reached the maximum streak */
    afterCapCoins: Scalars['Int']['output'];
    /** days of the streak */
    days: Array<LoginStreakDay>;
    /** coins given for the first day of the streak */
    defaultCoins: Scalars['Int']['output'];
};

/** Login streak day */
export type LoginStreakDay = {
    __typename: 'LoginStreakDay';
    /** coins given for the day */
    coins: Scalars['Int']['output'];
    /** day of the streak */
    day: Scalars['Int']['output'];
    /** description of the day */
    description?: Maybe<Scalars['String']['output']>;
};

export type LoginTokenInput = {
    timezone?: InputMaybe<Scalars['String']['input']>;
    token: Scalars['String']['input'];
};

export type Match = {
    __typename: 'Match';
    matchId: Scalars['String']['output'];
    owner: Profile;
    ownerId: Scalars['String']['output'];
    playedAt?: Maybe<Scalars['DateTime']['output']>;
    profile: Profile;
    profileId: Scalars['String']['output'];
    type: MatchType;
};

export type MatchConfigResult = Error | MatchConfigResultSuccess;

export type MatchConfigResultSuccess = {
    __typename: 'MatchConfigResultSuccess';
    buyMore: Scalars['Boolean']['output'];
    cost: Scalars['Int']['output'];
    freeMessages: Scalars['Int']['output'];
    limit: Scalars['Int']['output'];
    played: Scalars['Int']['output'];
};

export type MatchFilter = {
    __typename: 'MatchFilter';
    /** min age of profile */
    ageFrom: Scalars['Int']['output'];
    /** max age of profile */
    ageTo: Scalars['Int']['output'];
    /** identifier cuid */
    matchFilterId: Scalars['String']['output'];
    /** radius in km */
    radius?: Maybe<Scalars['Int']['output']>;
    /** DateTime from last update */
    updatedAt: Scalars['DateTime']['output'];
    /** own userId (cuid) */
    userId: Scalars['String']['output'];
};

/** Result for MatchFilter */
export type MatchFilterResult = Error | MatchFilter;

export type MatchFilterUpdateInput = {
    /** min age of profile */
    ageFrom?: InputMaybe<Scalars['Int']['input']>;
    /** max age of profile */
    ageTo?: InputMaybe<Scalars['Int']['input']>;
    /** radius in km */
    radius?: InputMaybe<Scalars['Int']['input']>;
};

export type MatchOrderByWithRelationInput = {
    matchId?: InputMaybe<SortOrder>;
    playedAt?: InputMaybe<SortOrder>;
};

export const MatchType = {
    Default: 'default',
    No: 'no',
    Skip: 'skip',
    Yes: 'yes',
} as const;

export type MatchType = (typeof MatchType)[keyof typeof MatchType];
export type MatchWhereInput = {
    cost?: InputMaybe<IntFilter>;
    matchId?: InputMaybe<Scalars['String']['input']>;
    playedAt?: InputMaybe<DateTimeNullableFilter>;
    profileId?: InputMaybe<Scalars['String']['input']>;
    type?: InputMaybe<EnumMatchTypeFilter>;
};

export type MatchWhereUniqueInput = {
    matchId: Scalars['String']['input'];
};

export type Message = {
    __typename: 'Message';
    /** if own message cost of message */
    coins: Scalars['Int']['output'];
    /** Conversation node */
    conversation: Conversation;
    /** cuid of Conversation */
    conversationId: Scalars['String']['output'];
    createdAt: Scalars['DateTime']['output'];
    /** Gift node */
    gift?: Maybe<Gift>;
    /** cuid of Gift */
    giftId?: Maybe<Scalars['String']['output']>;
    /** cuid */
    messageId: Scalars['String']['output'];
    model: MessageType;
    /** relative image path for Gift/Picture/PredefinedMessage */
    path?: Maybe<Scalars['String']['output']>;
    /** Picture node */
    picture?: Maybe<Picture>;
    /** cuid of Picture */
    pictureId?: Maybe<Scalars['String']['output']>;
    /** sender Profile node */
    sender: Profile;
    /** cuid of sender Profile */
    senderId: Scalars['String']['output'];
    /** for PredefinedMessage: translated text for user.languageCode */
    text?: Maybe<Scalars['String']['output']>;
    updatedAt: Scalars['DateTime']['output'];
};

export type MessageCost = {
    __typename: 'MessageCost';
    cost: Scalars['Int']['output'];
    length: Scalars['Int']['output'];
};

export const MessageDistinctFieldEnum = {
    ConversationId: 'conversationId',
    GiftId: 'giftId',
    Model: 'model',
    PictureId: 'pictureId',
    SenderId: 'senderId',
} as const;

export type MessageDistinctFieldEnum =
    (typeof MessageDistinctFieldEnum)[keyof typeof MessageDistinctFieldEnum];
/** user receivers for new conversation or conversation to answer */
export type MessageInput = {
    conversation?: InputMaybe<ConversationWhereUniqueInput>;
    receivers?: InputMaybe<Array<ProfileWhereUniqueInput>>;
    text: Scalars['String']['input'];
};

export type MessageListRelationFilter = {
    every?: InputMaybe<MessageWhereInput>;
    none?: InputMaybe<MessageWhereInput>;
    some?: InputMaybe<MessageWhereInput>;
};

export type MessageOrderByInput = {
    createdAt?: InputMaybe<SortOrder>;
    messageId?: InputMaybe<SortOrder>;
    model?: InputMaybe<SortOrder>;
    text?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export const MessageType = {
    Gift: 'Gift',
    Match: 'Match',
    Message: 'Message',
    Picture: 'Picture',
    Poke: 'Poke',
    PredefinedMessage: 'PredefinedMessage',
} as const;

export type MessageType = (typeof MessageType)[keyof typeof MessageType];
export type MessageWhereInput = {
    AND?: InputMaybe<Array<InputMaybe<MessageWhereInput>>>;
    NOT?: InputMaybe<Array<InputMaybe<MessageWhereInput>>>;
    OR?: InputMaybe<Array<InputMaybe<MessageWhereInput>>>;
    conversation?: InputMaybe<ConversationWhereInput>;
    conversationId?: InputMaybe<StringFilter>;
    giftId?: InputMaybe<StringNullableFilter>;
    messageId?: InputMaybe<StringFilter>;
    model?: InputMaybe<EnumMessageTypeFilter>;
    pictureId?: InputMaybe<StringNullableFilter>;
    sender?: InputMaybe<ProfileWhereInput>;
    senderId?: InputMaybe<StringFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
};

export type MessageWhereUniqueInput = {
    messageId: Scalars['String']['input'];
};

export type MobileNumberInput = {
    /** internationales Format „00491712345678“ */
    mobileNumber: Scalars['String']['input'];
};

export type MobileNumberValidationInput = {
    /** Code for mobile number validation */
    mobileNumberValidation: Scalars['String']['input'];
};

export type Mutation = {
    __typename: 'Mutation';
    /** deactivate all pushes */
    activateAllDeactivatedPush: BatchPayload;
    /** add a Profile to own favorites */
    addFavorite?: Maybe<Favorite>;
    /** add a new Friendship */
    addFriendship?: Maybe<AddFriendshipResult>;
    appleLogin: SocialLoginResult;
    /** block one Profile */
    blockProfile?: Maybe<ResultSuccess>;
    buyMoreMatches: NextMatchResult;
    changeMatchFilter: MatchFilterResult;
    /** activate/deactivate one DeactivatedPush */
    changeOneDeactivatedPush: DeactivatedPush;
    /** Decline or accept own Friendship */
    changeStatusFriendship?: Maybe<ResultSuccess>;
    commitTransaction?: Maybe<TransactionResult>;
    contactSupport: ResultSuccess;
    createOneEyeCatcher: CoinsResult;
    createOneUserComplain: UserComplain;
    createOneVoting: Voting;
    createTransaction?: Maybe<TransactionResult>;
    deleteAccount: DeleteAccountResult;
    /** allow all pushes */
    deleteAllDeactivatedPush: BatchPayload;
    /** delete own Image */
    deleteGalleryImage?: Maybe<ResultSuccess>;
    facebookLogin: SocialLoginResult;
    forgottenPassword: ResultSuccess;
    googleLogin: SocialLoginResult;
    /** hide/unhidden a conversation, hiding will be removed if a new action occurs */
    hideConversation?: Maybe<ResultSuccess>;
    /** like a [Profile]({{Types.Profile}}), likeProfile is a feature and not available for all projects */
    likeProfile?: Maybe<ResultSuccess>;
    login: LoginResult;
    loginByMD5: LoginResult;
    loginByToken: LoginResult;
    mobileNumberValidation: Result;
    /**
     * answer an [OptionPoll]({{Types.OptionPoll}}),
     *             **OptionPoll is a feature and not available for all projects**
     */
    optionPollAnswer?: Maybe<ProfileOptionPoll>;
    /** mutation to read a conversation */
    readConversation?: Maybe<ResultSuccess>;
    readManyNotification?: Maybe<BatchPayload>;
    readSupportMessage: SupportMessage;
    /** redeem a coupon to get coins */
    redeemCoupon?: Maybe<CoinsResult>;
    register: RegisterResult;
    registerC4F: RegisterResult;
    registerDirect: RegisterResult;
    registerShort: RegisterResult;
    /** remove a Profile from own favorites */
    removeFavorite?: Maybe<Favorite>;
    /** cancel own Friendship */
    removeFriendship?: Maybe<ResultSuccess>;
    resetPassword: ResetPasswordResult;
    sendGift?: Maybe<SendMessageResult>;
    sendMatch: SendMatchResult;
    sendMessage?: Maybe<SendMessageResult>;
    sendPicture?: Maybe<SendMessageResult>;
    sendPoke?: Maybe<SendMessageResult>;
    /**
     * send a [PredefinedMessage]({{Types.PredefinedMessage}}),
     *             **[PredefinedMessage]({{Types.PredefinedMessage}}) is a feature and not available for all projects**
     */
    sendPredefinedMessage: SendMessageResult;
    sendSupportMessage: SupportMessage;
    unbindSocial: Social;
    /** unblock one Profile, throws UserInputError if params are missing. */
    unblockProfile?: Maybe<ResultSuccess>;
    updateEmail: ValidateResult;
    /** set own Image to private */
    updateGalleryImage?: Maybe<ResultSuccess>;
    updateMobileNumber: ValidateResult;
    updateMyProfile?: Maybe<UpdateMyProfileResult>;
    updateOneUser: User;
    updatePicture: ChangePictureResult;
    /** change own Image to main */
    updateProfileImage?: Maybe<ResultSuccess>;
    updatePushToken: UpdateTokenResultSuccess;
    /** upload a new image wo own Profile */
    uploadGalleryImage?: Maybe<Image>;
    uploadPicture: UploadPictureResult;
    validateEmail: ValidateResult;
    validateMobileNumber: ValidateResult;
    validateUsername: ValidateResult;
    verifyEmail: ResultSuccess;
    visitProfile?: Maybe<VisitProfileResult>;
};

export type MutationAddFavoriteArgs = {
    data: ProfileWhereUniqueInput;
};

export type MutationAddFriendshipArgs = {
    data: ProfileWhereUniqueInput;
};

export type MutationAppleLoginArgs = {
    data: SocialLoginInput;
};

export type MutationBlockProfileArgs = {
    data: BlockProfileInput;
};

export type MutationChangeMatchFilterArgs = {
    data: MatchFilterUpdateInput;
};

export type MutationChangeOneDeactivatedPushArgs = {
    data: DeactivatedPushChangeInput;
};

export type MutationChangeStatusFriendshipArgs = {
    data: ChangeFriendshipInput;
};

export type MutationCommitTransactionArgs = {
    data: TransactionWhereUniqueInput;
};

export type MutationContactSupportArgs = {
    data?: InputMaybe<ContactSupportInput>;
};

export type MutationCreateOneEyeCatcherArgs = {
    data: EyeCatcherCreateInput;
};

export type MutationCreateOneUserComplainArgs = {
    data: UserComplainCreateInput;
};

export type MutationCreateOneVotingArgs = {
    data: VotingCreateInput;
};

export type MutationCreateTransactionArgs = {
    data: TransactionInput;
};

export type MutationDeleteAccountArgs = {
    data: DeleteAccountInput;
};

export type MutationDeleteGalleryImageArgs = {
    data: DeleteGalleryImageInput;
};

export type MutationFacebookLoginArgs = {
    data: SocialLoginInput;
};

export type MutationForgottenPasswordArgs = {
    data: ForgottenPasswordInput;
};

export type MutationGoogleLoginArgs = {
    data: SocialLoginInput;
};

export type MutationHideConversationArgs = {
    conversationId: Scalars['String']['input'];
    hide?: Scalars['Boolean']['input'];
};

export type MutationLikeProfileArgs = {
    data: LikeProfileInput;
};

export type MutationLoginArgs = {
    data: LoginInput;
};

export type MutationLoginByMd5Args = {
    data: LoginMd5Input;
};

export type MutationLoginByTokenArgs = {
    data: LoginTokenInput;
};

export type MutationMobileNumberValidationArgs = {
    data: MobileNumberValidationInput;
};

export type MutationOptionPollAnswerArgs = {
    data: OptionPollAnswerInput;
};

export type MutationReadConversationArgs = {
    conversationId?: InputMaybe<Scalars['String']['input']>;
};

export type MutationReadManyNotificationArgs = {
    where?: InputMaybe<Array<InputMaybe<NotificationWhereUniqueInput>>>;
};

export type MutationReadSupportMessageArgs = {
    where?: InputMaybe<SupportMessageWhereUniqueInput>;
};

export type MutationRedeemCouponArgs = {
    data: CouponWhereUniqueInput;
};

export type MutationRegisterArgs = {
    data: RegisterInput;
};

export type MutationRegisterC4FArgs = {
    data: RegisterC4FInput;
};

export type MutationRegisterDirectArgs = {
    data: RegisterDirectInput;
};

export type MutationRegisterShortArgs = {
    data: RegisterShortInput;
};

export type MutationRemoveFavoriteArgs = {
    data: FavoriteWhereUniqueInput;
};

export type MutationRemoveFriendshipArgs = {
    data: RemoveFriendshipInput;
};

export type MutationResetPasswordArgs = {
    data: ResetPasswordInput;
};

export type MutationSendGiftArgs = {
    data: GiftInput;
};

export type MutationSendMatchArgs = {
    type: MatchType;
    where: MatchWhereUniqueInput;
};

export type MutationSendMessageArgs = {
    data: MessageInput;
};

export type MutationSendPictureArgs = {
    data: PictureInput;
};

export type MutationSendPokeArgs = {
    data: PokeInput;
};

export type MutationSendPredefinedMessageArgs = {
    data: PredefinedMessageInput;
};

export type MutationSendSupportMessageArgs = {
    data?: InputMaybe<SupportMessageCreateInput>;
};

export type MutationUnbindSocialArgs = {
    where: SocialWhereUniqueInput;
};

export type MutationUnblockProfileArgs = {
    data: MyBlockedWhereUniqueInput;
};

export type MutationUpdateEmailArgs = {
    data: ValidateEmailInput;
};

export type MutationUpdateGalleryImageArgs = {
    data: UpdateGalleryImageInput;
};

export type MutationUpdateMobileNumberArgs = {
    data: ValidateMobileNumberInput;
};

export type MutationUpdateMyProfileArgs = {
    data: UpdateMyProfileInput;
};

export type MutationUpdateOneUserArgs = {
    data: UserUpdateInput;
};

export type MutationUpdatePictureArgs = {
    data: PictureUpdateInput;
    where: PictureWhereUniqueInput;
};

export type MutationUpdateProfileImageArgs = {
    data: UpdateProfileImageInput;
};

export type MutationUpdatePushTokenArgs = {
    data: UpdateTokenInput;
};

export type MutationUploadGalleryImageArgs = {
    data: UploadGalleryImageInput;
};

export type MutationUploadPictureArgs = {
    data: UploadPictureInput;
};

export type MutationValidateEmailArgs = {
    data: ValidateEmailInput;
};

export type MutationValidateMobileNumberArgs = {
    data: ValidateMobileNumberInput;
};

export type MutationValidateUsernameArgs = {
    data: ValidateUsernameInput;
};

export type MutationVerifyEmailArgs = {
    data: VerifyEmailInput;
};

export type MutationVisitProfileArgs = {
    data: ProfileWhereUniqueInput;
};

/** combine unique index for Blocked: blockedId -> cuid or profileId from other Profile */
export type MyBlockedWhereUniqueInput = {
    /** cuid of Blocked */
    blockedId?: InputMaybe<Scalars['String']['input']>;
    /** profileId of other Profile */
    profileId?: InputMaybe<Scalars['String']['input']>;
};

export type MyProfile = ProfileI & {
    __typename: 'MyProfile';
    /** Profile accept Picture */
    acceptPicture: Scalars['Boolean']['output'];
    /** Profile age, if profile incomplete 0 */
    age: Scalars['Int']['output'];
    /** Avatar is a feature and not available for all projects */
    avatar?: Maybe<Avatar>;
    /** relative image path to avatar image, Avatar is a feature and not available for all projects */
    avatarPath?: Maybe<Scalars['String']['output']>;
    birthDate?: Maybe<Scalars['String']['output']>;
    /** own Profile is completed */
    completed: Scalars['Boolean']['output'];
    conversationProfiles: Array<ConversationProfile>;
    country: Scalars['String']['output'];
    county: Scalars['String']['output'];
    /**
     * translated string of [ProfileText]({{Types.ProfileText}}),
     *                 languageCode from login user
     *                 **[ProfileText]({{Types.ProfileText}}) is a feature and not available for all projects**
     */
    defaultText?: Maybe<Scalars['String']['output']>;
    flirtText: Scalars['String']['output'];
    /** list of own Friendship */
    friends: Array<Friendship>;
    furtherInformation?: Maybe<Scalars['String']['output']>;
    gender: Gender;
    images: Array<Image>;
    languageCode: Scalars['String']['output'];
    /** list of own Favorite */
    myFavorites: Array<Favorite>;
    premiumStatus: Array<ProfileStatus>;
    profileFlags: Array<ProfileFlag>;
    /** cuid */
    profileId: Scalars['String']['output'];
    profileInterests: Array<ProfileInterest>;
    profileName: Scalars['String']['output'];
    receivedPictures: Array<Picture>;
    searches: Gender;
    shownLocation: Scalars['String']['output'];
    /** support profile */
    support: Scalars['Boolean']['output'];
    /** Theme node to display at some views */
    theme?: Maybe<Theme>;
    /** unique identifier for Theme node */
    themeName?: Maybe<Scalars['String']['output']>;
    user: User;
    zodiacSign?: Maybe<Scalars['String']['output']>;
};

export type MyProfileAvatarPathArgs = {
    relative?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MyProfileConversationProfilesArgs = {
    cursor?: InputMaybe<ConversationProfileWhereUniqueInput>;
    orderBy?: InputMaybe<ConversationProfileOrderByInput>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ConversationProfileWhereInput>;
};

export type MyProfileFriendsArgs = {
    cursor?: InputMaybe<FriendshipWhereUniqueInput>;
    orderBy?: InputMaybe<FriendshipOrderByInput>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<FriendshipWhereInput>;
};

export type MyProfileImagesArgs = {
    cursor?: InputMaybe<ImageWhereUniqueInput>;
    distinct?: InputMaybe<ImageDistinctFieldEnum>;
    orderBy?: InputMaybe<Array<InputMaybe<ImageOrderByInput>>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ImageWhereInput>;
};

export type MyProfileMyFavoritesArgs = {
    cursor?: InputMaybe<FavoriteWhereUniqueInput>;
    orderBy?: InputMaybe<FavoriteOrderByInput>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<FavoriteWhereInput>;
};

export type MyProfileReceivedPicturesArgs = {
    cursor?: InputMaybe<PictureWhereUniqueInput>;
    orderBy?: InputMaybe<PictureOrderByInput>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<PictureWhereInput>;
};

/** Result for getNext */
export type NextMatchResult = Error | NextMatchResultSuccess;

export type NextMatchResultSuccess = {
    __typename: 'NextMatchResultSuccess';
    matches: Array<Match>;
};

export type Notification = {
    __typename: 'Notification';
    createdAt: Scalars['DateTime']['output'];
    /** cuid */
    notificationId: Scalars['String']['output'];
    /** Profile node */
    profile?: Maybe<Profile>;
    /** cuid of Profile */
    profileId?: Maybe<Scalars['String']['output']>;
    read: Scalars['Boolean']['output'];
    /** SupportMessage -> supportTicketId, [Poke, Gift] -> conversationId, Friendship -> friendshipId, CoinsAdded -> coinsChanged string from number */
    target?: Maybe<Scalars['String']['output']>;
    type: NotificationType;
    updatedAt: Scalars['DateTime']['output'];
};

export const NotificationDistinctFieldEnum = {
    CreatedAt: 'createdAt',
    NotificationId: 'notificationId',
    Read: 'read',
    Type: 'type',
    UpdatedAt: 'updatedAt',
    UserId: 'userId',
} as const;

export type NotificationDistinctFieldEnum =
    (typeof NotificationDistinctFieldEnum)[keyof typeof NotificationDistinctFieldEnum];
export const NotificationFriendshipType = {
    FriendshipAccept: 'FriendshipAccept',
    FriendshipDecline: 'FriendshipDecline',
    FriendshipDelete: 'FriendshipDelete',
    FriendshipRequest: 'FriendshipRequest',
} as const;

export type NotificationFriendshipType =
    (typeof NotificationFriendshipType)[keyof typeof NotificationFriendshipType];
export const NotificationImageType = {
    ImageDeleted: 'ImageDeleted',
    ImagePrivate: 'ImagePrivate',
    ImageVerified: 'ImageVerified',
} as const;

export type NotificationImageType =
    (typeof NotificationImageType)[keyof typeof NotificationImageType];
export const NotificationMessageType = {
    Message: 'Message',
    PredefinedMessage: 'PredefinedMessage',
} as const;

export type NotificationMessageType =
    (typeof NotificationMessageType)[keyof typeof NotificationMessageType];
export type NotificationOrderByInput = {
    notificationId?: InputMaybe<SortOrder>;
    read?: InputMaybe<SortOrder>;
    type?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export const NotificationPaymentType = {
    PaymentFailed: 'PaymentFailed',
    PaymentSuccess: 'PaymentSuccess',
} as const;

export type NotificationPaymentType =
    (typeof NotificationPaymentType)[keyof typeof NotificationPaymentType];
/** you received coins */
export type NotificationSubscriptionCoinsAddedPayload = {
    __typename: 'NotificationSubscriptionCoinsAddedPayload';
    coinsChanged: Scalars['Int']['output'];
    totalCoins: Scalars['Int']['output'];
    type: NotificationType;
};

/** new Friendship */
export type NotificationSubscriptionFriendshipPayload = {
    __typename: 'NotificationSubscriptionFriendshipPayload';
    friendshipId: Scalars['String']['output'];
    friendshipType: NotificationFriendshipType;
    /** cuid other Profile */
    senderId: Scalars['String']['output'];
    senderName: Scalars['String']['output'];
    type: NotificationType;
};

/** new gift */
export type NotificationSubscriptionGiftPayload = {
    __typename: 'NotificationSubscriptionGiftPayload';
    conversationId: Scalars['String']['output'];
    giftId: Scalars['String']['output'];
    /** cuid other Profile */
    senderId: Scalars['String']['output'];
    senderName: Scalars['String']['output'];
    text: Scalars['String']['output'];
    type: NotificationType;
};

/** set Image: ImageDeleted or ImagePrivate by Admin */
export type NotificationSubscriptionImagePayload = {
    __typename: 'NotificationSubscriptionImagePayload';
    /** cuid Image */
    imageId: Scalars['String']['output'];
    imageType: NotificationImageType;
    type: NotificationType;
};

/** sb likes you */
export type NotificationSubscriptionLikePayload = {
    __typename: 'NotificationSubscriptionLikePayload';
    /** cuid other Profile */
    otherProfileId: Scalars['String']['output'];
    type: NotificationType;
};

/** a new Match */
export type NotificationSubscriptionMatchPayload = {
    __typename: 'NotificationSubscriptionMatchPayload';
    /** cuid Match */
    matchId: Scalars['String']['output'];
    /** cuid other Profile */
    otherProfileId: Scalars['String']['output'];
    otherProfileName: Scalars['String']['output'];
    type: NotificationType;
};

/** new message */
export type NotificationSubscriptionMessagePayload = {
    __typename: 'NotificationSubscriptionMessagePayload';
    conversationId: Scalars['String']['output'];
    messageType: NotificationMessageType;
    /** cuid other Profile */
    senderId: Scalars['String']['output'];
    senderName: Scalars['String']['output'];
    text: Scalars['String']['output'];
    type: NotificationType;
};

export type NotificationSubscriptionPayload =
    | NotificationSubscriptionCoinsAddedPayload
    | NotificationSubscriptionFriendshipPayload
    | NotificationSubscriptionGiftPayload
    | NotificationSubscriptionImagePayload
    | NotificationSubscriptionLikePayload
    | NotificationSubscriptionMatchPayload
    | NotificationSubscriptionMessagePayload
    | NotificationSubscriptionPaymentPayload
    | NotificationSubscriptionPicturePayload
    | NotificationSubscriptionPokePayload
    | NotificationSubscriptionProfileTextChangedPayload
    | NotificationSubscriptionSupportMessagePayload
    | NotificationSubscriptionVisitPayload;

/** PaymentSuccess|PaymentFailed */
export type NotificationSubscriptionPaymentPayload = {
    __typename: 'NotificationSubscriptionPaymentPayload';
    coins: Scalars['Int']['output'];
    paymentType: NotificationPaymentType;
    /** payment provider (e.g. payPal) */
    provider: Scalars['String']['output'];
    /** cuid Transaction */
    transactionId: Scalars['String']['output'];
    type: NotificationType;
};

/** new picture */
export type NotificationSubscriptionPicturePayload = {
    __typename: 'NotificationSubscriptionPicturePayload';
    conversationId: Scalars['String']['output'];
    pictureId: Scalars['String']['output'];
    /** cuid other Profile */
    senderId: Scalars['String']['output'];
    senderName: Scalars['String']['output'];
    type: NotificationType;
};

/** new poke */
export type NotificationSubscriptionPokePayload = {
    __typename: 'NotificationSubscriptionPokePayload';
    conversationId: Scalars['String']['output'];
    /** cuid other Profile */
    senderId: Scalars['String']['output'];
    senderName: Scalars['String']['output'];
    type: NotificationType;
};

/** admin changed your flirtText */
export type NotificationSubscriptionProfileTextChangedPayload = {
    __typename: 'NotificationSubscriptionProfileTextChangedPayload';
    type: NotificationType;
};

/** send for new support message */
export type NotificationSubscriptionSupportMessagePayload = {
    __typename: 'NotificationSubscriptionSupportMessagePayload';
    /** cuid SupportMessage */
    supportMessageId: Scalars['String']['output'];
    /** cuid SupportTicket */
    supportTicketId: Scalars['String']['output'];
    text: Scalars['String']['output'];
    type: NotificationType;
};

/** new visit */
export type NotificationSubscriptionVisitPayload = {
    __typename: 'NotificationSubscriptionVisitPayload';
    /** cuid other Profile */
    senderId: Scalars['String']['output'];
    senderName: Scalars['String']['output'];
    type: NotificationType;
};

export const NotificationType = {
    CoinsAdded: 'CoinsAdded',
    FriendshipAccept: 'FriendshipAccept',
    FriendshipDecline: 'FriendshipDecline',
    FriendshipDelete: 'FriendshipDelete',
    FriendshipRequest: 'FriendshipRequest',
    Gift: 'Gift',
    ImageDeleted: 'ImageDeleted',
    ImagePrivate: 'ImagePrivate',
    ImageVerified: 'ImageVerified',
    Like: 'Like',
    Match: 'Match',
    Message: 'Message',
    PaymentFailed: 'PaymentFailed',
    PaymentSuccess: 'PaymentSuccess',
    Picture: 'Picture',
    Poke: 'Poke',
    PredefinedMessage: 'PredefinedMessage',
    ProfileTextChanged: 'ProfileTextChanged',
    SupportMessage: 'SupportMessage',
    Visit: 'Visit',
} as const;

export type NotificationType =
    (typeof NotificationType)[keyof typeof NotificationType];
export type NotificationWhereInput = {
    AND?: InputMaybe<Array<InputMaybe<NotificationWhereInput>>>;
    NOT?: InputMaybe<Array<InputMaybe<NotificationWhereInput>>>;
    OR?: InputMaybe<Array<InputMaybe<NotificationWhereInput>>>;
    notificationId?: InputMaybe<StringFilter>;
    read?: InputMaybe<BoolFilter>;
    type?: InputMaybe<EnumNotificationTypeFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
};

export type NotificationWhereUniqueInput = {
    notificationId: Scalars['String']['input'];
};

export type Offer = {
    __typename: 'Offer';
    bonus: Scalars['Int']['output'];
    coins: Scalars['Int']['output'];
    cost: Scalars['Float']['output'];
    currency: Scalars['String']['output'];
    extra: Scalars['String']['output'];
    name: Scalars['String']['output'];
    /** cuid */
    offerId: Scalars['String']['output'];
    periodUnit: PeriodUnitOffer;
    profileStatus?: Maybe<ProfileStatus>;
    /** Provider node */
    provider: Provider;
    /** unique identifier for Provider */
    providerName: Scalars['String']['output'];
    statusPeriod: Scalars['Int']['output'];
};

export const OfferDistinctFieldEnum = {
    Active: 'active',
    Bonus: 'bonus',
    Coins: 'coins',
    Cost: 'cost',
    Currency: 'currency',
    Extra: 'extra',
    Limit: 'limit',
    Name: 'name',
    OfferId: 'offerId',
    ProviderName: 'providerName',
} as const;

export type OfferDistinctFieldEnum =
    (typeof OfferDistinctFieldEnum)[keyof typeof OfferDistinctFieldEnum];
export type OfferListRelationFilter = {
    every?: InputMaybe<OfferWhereInput>;
    none?: InputMaybe<OfferWhereInput>;
    some?: InputMaybe<OfferWhereInput>;
};

export type OfferOrderByInput = {
    active?: InputMaybe<SortOrder>;
    bonus?: InputMaybe<SortOrder>;
    coins?: InputMaybe<SortOrder>;
    cost?: InputMaybe<SortOrder>;
    currency?: InputMaybe<SortOrder>;
    extra?: InputMaybe<SortOrder>;
    limit?: InputMaybe<SortOrder>;
    name?: InputMaybe<SortOrder>;
    offerId?: InputMaybe<SortOrder>;
    providerName?: InputMaybe<SortOrder>;
};

export type OfferWhereInput = {
    AND?: InputMaybe<Array<InputMaybe<OfferWhereInput>>>;
    NOT?: InputMaybe<Array<InputMaybe<OfferWhereInput>>>;
    OR?: InputMaybe<Array<InputMaybe<OfferWhereInput>>>;
    bonus?: InputMaybe<IntFilter>;
    coins?: InputMaybe<IntFilter>;
    cost?: InputMaybe<FloatFilter>;
    currency?: InputMaybe<StringFilter>;
    extra?: InputMaybe<StringFilter>;
    name?: InputMaybe<StringFilter>;
    offerId?: InputMaybe<StringFilter>;
    provider?: InputMaybe<ProviderWhereInput>;
    providerName?: InputMaybe<StringFilter>;
};

export type OfferWhereUniqueInput = {
    offerId: Scalars['String']['input'];
};

export const OperatingSystem = {
    Android: 'ANDROID',
    Ios: 'IOS',
    Web: 'WEB',
} as const;

export type OperatingSystem =
    (typeof OperatingSystem)[keyof typeof OperatingSystem];
/**
 * **[OptionPoll]({{Types.OptionPoll}}) is a feature
 *     and not available for all projects**
 */
export type OptionPoll = {
    __typename: 'OptionPoll';
    /** list of all answers */
    answers: Array<OptionPollAnswer>;
    languageCode: Scalars['String']['output'];
    /** if user had answered node of [ProfileOptionPoll]({{Types.ProfileOptionPoll}}) */
    myAnswer?: Maybe<ProfileOptionPoll>;
    name: Scalars['String']['output'];
    /** cuid */
    optionPollId: Scalars['String']['output'];
    position: Scalars['Int']['output'];
    /** translated text */
    text: Scalars['String']['output'];
};

export type OptionPollAnswer = {
    __typename: 'OptionPollAnswer';
    languageCode: Scalars['String']['output'];
    /** cuid */
    optionPollAnswerId: Scalars['String']['output'];
    /** cuid of OptionPoll */
    optionPollId: Scalars['String']['output'];
    /** optional relative image path */
    path?: Maybe<Scalars['String']['output']>;
    text: Scalars['String']['output'];
    /** number of votes in % */
    votes: Scalars['String']['output'];
};

/**
 * **[OptionPoll]({{Types.OptionPoll}}) is a
 *         feature and not available for all projects**
 */
export type OptionPollAnswerInput = {
    optionPollAnswerId: Scalars['String']['input'];
    optionPollId: Scalars['String']['input'];
};

export const PeriodUnit = {
    Days: 'days',
    Hours: 'hours',
    Minutes: 'minutes',
    Months: 'months',
    Weeks: 'weeks',
} as const;

export type PeriodUnit = (typeof PeriodUnit)[keyof typeof PeriodUnit];
export const PeriodUnitOffer = {
    Days: 'days',
    Months: 'months',
    Weeks: 'weeks',
} as const;

export type PeriodUnitOffer =
    (typeof PeriodUnitOffer)[keyof typeof PeriodUnitOffer];
export type Picture = {
    __typename: 'Picture';
    fsk18: Scalars['Boolean']['output'];
    hidden: Scalars['Boolean']['output'];
    owner: Profile;
    ownerId: Scalars['String']['output'];
    /** relative image path */
    path: Scalars['String']['output'];
    /** cuid */
    pictureId: Scalars['String']['output'];
    verified: Scalars['Boolean']['output'];
};

export type PicturePathArgs = {
    relative?: InputMaybe<Scalars['Boolean']['input']>;
    size?: InputMaybe<Scalars['Int']['input']>;
};

/** user receivers for new conversation or conversation to answer */
export type PictureInput = {
    conversation?: InputMaybe<ConversationWhereUniqueInput>;
    picture: PictureWhereUniqueInput;
    receivers?: InputMaybe<Array<ProfileWhereUniqueInput>>;
    text?: InputMaybe<Scalars['String']['input']>;
};

export type PictureOrderByInput = {
    pictureId: SortOrder;
};

export type PictureUpdateInput = {
    deleted?: InputMaybe<Scalars['Boolean']['input']>;
    hidden?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PictureWhereInput = {
    AND?: InputMaybe<Array<InputMaybe<PictureWhereInput>>>;
    Message?: InputMaybe<MessageListRelationFilter>;
    NOT?: InputMaybe<Array<InputMaybe<PictureWhereInput>>>;
    OR?: InputMaybe<Array<InputMaybe<PictureWhereInput>>>;
    fsk18?: InputMaybe<BoolFilter>;
    hidden?: InputMaybe<BoolFilter>;
    owner?: InputMaybe<ProfileWhereInput>;
    ownerId?: InputMaybe<StringFilter>;
    path?: InputMaybe<StringFilter>;
    pictureId?: InputMaybe<StringFilter>;
};

export type PictureWhereUniqueInput = {
    pictureId: Scalars['String']['input'];
};

export type PokeCost = {
    __typename: 'PokeCost';
    cost: Scalars['Int']['output'];
    free?: Maybe<Scalars['Int']['output']>;
};

/** user receivers for new conversation or conversation to answer */
export type PokeInput = {
    conversation?: InputMaybe<ConversationWhereUniqueInput>;
    receivers?: InputMaybe<Array<ProfileWhereUniqueInput>>;
};

/**
 * **[PredefinedMessage]({{Types.PredefinedMessage}}) is
 *             a feature and not available for all projects**
 */
export type PredefinedMessage = {
    __typename: 'PredefinedMessage';
    /** optional relative image path */
    path?: Maybe<Scalars['String']['output']>;
    /** cuid */
    predefinedMessageId: Scalars['String']['output'];
    /** translations for login user languageCode */
    translations: Array<Translation>;
};

/**
 * for a new conversation use receivers, to answer use conversationId
 *     **[PredefinedMessage]({{Types.PredefinedMessage}}) is a feature and not available for all projects**
 */
export type PredefinedMessageInput = {
    conversation?: InputMaybe<ConversationWhereUniqueInput>;
    /** cuid of PredefinedMessage */
    predefinedMessageId: Scalars['String']['input'];
    receivers?: InputMaybe<Array<ProfileWhereUniqueInput>>;
};

export type Profile = ProfileI & {
    __typename: 'Profile';
    /** Profile accept Picture */
    acceptPicture: Scalars['Boolean']['output'];
    /** Profile age, if profile incomplete 0 */
    age: Scalars['Int']['output'];
    /** Avatar is a feature and not available for all projects */
    avatar?: Maybe<Avatar>;
    /** relative image path to avatar image, Avatar is a feature and not available for all projects */
    avatarPath?: Maybe<Scalars['String']['output']>;
    /** is on my blocked list */
    blocked: Scalars['Boolean']['output'];
    country: Scalars['String']['output'];
    county: Scalars['String']['output'];
    /**
     * translated string of [ProfileText]({{Types.ProfileText}}),
     *                 languageCode from login user
     *                 **[ProfileText]({{Types.ProfileText}}) is a feature and not available for all projects**
     */
    defaultText?: Maybe<Scalars['String']['output']>;
    /** is on my favorite list */
    favorite: Scalars['Boolean']['output'];
    flirtText: Scalars['String']['output'];
    /** status of Friendship */
    friendshipStatus?: Maybe<Scalars['String']['output']>;
    furtherInformation?: Maybe<Scalars['String']['output']>;
    gender: Gender;
    images: Array<Image>;
    languageCode: Scalars['String']['output'];
    premiumStatus: Array<ProfileStatus>;
    profileFlags: Array<ProfileFlag>;
    /** cuid */
    profileId: Scalars['String']['output'];
    profileInterests: Array<ProfileInterest>;
    profileName: Scalars['String']['output'];
    searches: Gender;
    shownLocation: Scalars['String']['output'];
    /** support profile */
    support: Scalars['Boolean']['output'];
    /** Theme node to display at some views */
    theme?: Maybe<Theme>;
    /** unique identifier for Theme node */
    themeName?: Maybe<Scalars['String']['output']>;
    zodiacSign?: Maybe<Scalars['String']['output']>;
};

export type ProfileAvatarPathArgs = {
    relative?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProfileImagesArgs = {
    cursor?: InputMaybe<ImageWhereUniqueInput>;
    distinct?: InputMaybe<ImageDistinctFieldEnum>;
    orderBy?: InputMaybe<Array<InputMaybe<ImageOrderByInput>>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ImageWhereInput>;
};

export type ProfileCreateOneWithoutUserComplainInput = {
    connect: ProfileWhereUniqueInput;
};

export type ProfileCreateOneWithoutVotingInput = {
    connect?: InputMaybe<ProfileWhereUniqueInput>;
};

export type ProfileFlag = {
    __typename: 'ProfileFlag';
    flag: Flag;
    flagId: Scalars['String']['output'];
    flagValue?: Maybe<FlagValue>;
    flagValueId?: Maybe<Scalars['String']['output']>;
    profileFlagId: Scalars['String']['output'];
    profileId: Scalars['String']['output'];
    value?: Maybe<Scalars['String']['output']>;
};

export type ProfileFlagCreateWithoutProfileInput = {
    flag: FlagCreateNestedOneWithoutProfileFlagsInput;
    flagValue?: InputMaybe<FlagValueCreateNestedOneWithoutProfileFlagsInput>;
    value?: InputMaybe<Scalars['String']['input']>;
};

export const ProfileFlagDistinctFieldEnum = {
    CreatedAt: 'createdAt',
    FlagId: 'flagId',
    ProfileFlagId: 'profileFlagId',
    ProfileId: 'profileId',
} as const;

export type ProfileFlagDistinctFieldEnum =
    (typeof ProfileFlagDistinctFieldEnum)[keyof typeof ProfileFlagDistinctFieldEnum];
export type ProfileFlagListRelationFilter = {
    every?: InputMaybe<ProfileFlagWhereOnlyScalarInput>;
    none?: InputMaybe<ProfileFlagWhereOnlyScalarInput>;
    some?: InputMaybe<ProfileFlagWhereOnlyScalarInput>;
};

export type ProfileFlagOrderByInput = {
    createdAt?: InputMaybe<SortOrder>;
    flagId?: InputMaybe<SortOrder>;
    profileFlagId?: InputMaybe<SortOrder>;
    profileId?: InputMaybe<SortOrder>;
};

export type ProfileFlagScalarWhereInput = {
    flagId?: InputMaybe<StringFilter>;
    profileFlagId?: InputMaybe<StringFilter>;
    profileId?: InputMaybe<StringFilter>;
};

export type ProfileFlagUpdateManyWithoutProfileInput = {
    delete?: InputMaybe<Array<InputMaybe<ProfileFlagWhereUniqueInput>>>;
    deleteMany?: InputMaybe<Array<InputMaybe<ProfileFlagScalarWhereInput>>>;
};

export type ProfileFlagUpdateManyWithoutProfileNestedInput = {
    create?: InputMaybe<Array<ProfileFlagCreateWithoutProfileInput>>;
    delete?: InputMaybe<Array<ProfileFlagWhereUniqueInput>>;
    update?: InputMaybe<
        Array<ProfileFlagUpdateWithWhereUniqueWithoutProfileInput>
    >;
};

export type ProfileFlagUpdateWithWhereUniqueWithoutProfileInput = {
    data: ProfileFlagUpdateWithoutProfileInput;
    where: ProfileFlagWhereUniqueInput;
};

export type ProfileFlagUpdateWithoutProfileInput = {
    flagValue?: InputMaybe<FlagValueCreateNestedOneWithoutProfileFlagsInput>;
    value?: InputMaybe<Scalars['String']['input']>;
};

export type ProfileFlagWhereInput = {
    flagId?: InputMaybe<StringFilter>;
    profile?: InputMaybe<ProfileWhereInput>;
    profileFlagId?: InputMaybe<StringFilter>;
    profileId?: InputMaybe<StringFilter>;
};

export type ProfileFlagWhereOnlyScalarInput = {
    flagId?: InputMaybe<StringFilter>;
    profileFlagId?: InputMaybe<StringFilter>;
    profileId?: InputMaybe<StringFilter>;
};

export type ProfileFlagWhereUniqueInput = {
    profileFlagId: Scalars['String']['input'];
};

export type ProfileI = {
    /** Profile accept Picture */
    acceptPicture: Scalars['Boolean']['output'];
    /** Profile age, if profile incomplete 0 */
    age: Scalars['Int']['output'];
    country: Scalars['String']['output'];
    county: Scalars['String']['output'];
    flirtText: Scalars['String']['output'];
    furtherInformation?: Maybe<Scalars['String']['output']>;
    gender: Gender;
    images: Array<Image>;
    languageCode: Scalars['String']['output'];
    premiumStatus: Array<ProfileStatus>;
    profileFlags: Array<ProfileFlag>;
    /** cuid */
    profileId: Scalars['String']['output'];
    profileInterests: Array<ProfileInterest>;
    profileName: Scalars['String']['output'];
    searches: Gender;
    shownLocation: Scalars['String']['output'];
    /** support profile */
    support: Scalars['Boolean']['output'];
    /** Theme node to display at some views */
    theme?: Maybe<Theme>;
    /** unique identifier for Theme node */
    themeName?: Maybe<Scalars['String']['output']>;
    zodiacSign?: Maybe<Scalars['String']['output']>;
};

export type ProfileIImagesArgs = {
    cursor?: InputMaybe<ImageWhereUniqueInput>;
    distinct?: InputMaybe<ImageDistinctFieldEnum>;
    orderBy?: InputMaybe<Array<InputMaybe<ImageOrderByInput>>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ImageWhereInput>;
};

export type ProfileInterest = {
    __typename: 'ProfileInterest';
    /** Interest node */
    interest: Interest;
    /** unique identifier for Interest */
    interestName: Scalars['String']['output'];
    /**
     * Profile node
     * @deprecated Use profile queries instead, no circular references
     */
    profile: Profile;
    /** cuid of Profile */
    profileId: Scalars['String']['output'];
    /** cuid */
    profileInterestId: Scalars['String']['output'];
};

export type ProfileInterestListRelationFilter = {
    every?: InputMaybe<ProfileInterestWhereInput>;
    none?: InputMaybe<ProfileInterestWhereInput>;
    some?: InputMaybe<ProfileInterestWhereInput>;
};

export type ProfileInterestWhereInput = {
    AND?: InputMaybe<Array<InputMaybe<ProfileInterestWhereInput>>>;
    NOT?: InputMaybe<Array<InputMaybe<ProfileInterestWhereInput>>>;
    OR?: InputMaybe<Array<InputMaybe<ProfileInterestWhereInput>>>;
    interest?: InputMaybe<InterestWhereInput>;
    interestId?: InputMaybe<StringFilter>;
    profileInterestId?: InputMaybe<StringFilter>;
};

export type ProfileOptionPoll = {
    __typename: 'ProfileOptionPoll';
    createdAt: Scalars['DateTime']['output'];
    /** cuid of OptionPollAnswer */
    optionPollAnswerId: Scalars['String']['output'];
    /** cuid of OptionPoll */
    optionPollId: Scalars['String']['output'];
    /** cuid of Profile */
    profileId: Scalars['String']['output'];
    /** cuid */
    profileOptionPollId: Scalars['String']['output'];
};

export type ProfileOrderByInput = {
    birthDate?: InputMaybe<SortOrder>;
    flirtText?: InputMaybe<SortOrder>;
    gender?: InputMaybe<SortOrder>;
    profileName?: InputMaybe<SortOrder>;
    searches?: InputMaybe<SortOrder>;
    shownLocation?: InputMaybe<SortOrder>;
};

export const ProfileStatus = {
    Premium: 'Premium',
} as const;

export type ProfileStatus = (typeof ProfileStatus)[keyof typeof ProfileStatus];
export type ProfileText = {
    __typename: 'ProfileText';
    /** cuid */
    profileTextId: Scalars['String']['output'];
    translations: Array<Translation>;
};

export type ProfileWhereInput = {
    AND?: InputMaybe<Array<InputMaybe<ProfileWhereInput>>>;
    NOT?: InputMaybe<Array<InputMaybe<ProfileWhereInput>>>;
    OR?: InputMaybe<Array<InputMaybe<ProfileWhereInput>>>;
    acceptPicture?: InputMaybe<BoolFilter>;
    country?: InputMaybe<StringNullableFilter>;
    county?: InputMaybe<StringNullableFilter>;
    flirtText?: InputMaybe<StringNullableFilter>;
    furtherInformation?: InputMaybe<StringNullableFilter>;
    gender?: InputMaybe<EnumGenderFilter>;
    images?: InputMaybe<ImageListRelationFilter>;
    languageCode?: InputMaybe<StringNullableFilter>;
    profileId?: InputMaybe<StringFilter>;
    profileInterests?: InputMaybe<ProfileInterestListRelationFilter>;
    profileName?: InputMaybe<StringFilter>;
    searches?: InputMaybe<EnumGenderFilter>;
    shownLocation?: InputMaybe<StringNullableFilter>;
    themeName?: InputMaybe<StringNullableFilter>;
};

export type ProfileWhereInputExtended = {
    AND?: InputMaybe<Array<InputMaybe<ProfileWhereInput>>>;
    NOT?: InputMaybe<Array<InputMaybe<ProfileWhereInput>>>;
    OR?: InputMaybe<Array<InputMaybe<ProfileWhereInput>>>;
    acceptPicture?: InputMaybe<BoolFilter>;
    age?: InputMaybe<AgeFilter>;
    country?: InputMaybe<StringNullableFilter>;
    county?: InputMaybe<StringNullableFilter>;
    flirtText?: InputMaybe<StringNullableFilter>;
    furtherInformation?: InputMaybe<StringNullableFilter>;
    gender?: InputMaybe<EnumGenderFilter>;
    images?: InputMaybe<ImageListRelationFilter>;
    languageCode?: InputMaybe<StringNullableFilter>;
    online?: InputMaybe<Scalars['Boolean']['input']>;
    profileId?: InputMaybe<StringFilter>;
    profileInterests?: InputMaybe<ProfileInterestListRelationFilter>;
    profileName?: InputMaybe<StringFilter>;
    searches?: InputMaybe<EnumGenderFilter>;
    shownLocation?: InputMaybe<StringNullableFilter>;
    themeName?: InputMaybe<StringNullableFilter>;
};

export type ProfileWhereUniqueInput = {
    profileId: Scalars['String']['input'];
};

export type Provider = {
    __typename: 'Provider';
    currency: Scalars['String']['output'];
    description?: Maybe<Scalars['String']['output']>;
    logo: Scalars['String']['output'];
    name: Scalars['String']['output'];
    offers: Array<Offer>;
    /** cuid */
    providerId: Scalars['String']['output'];
    title: Scalars['String']['output'];
};

export type ProviderOffersArgs = {
    cursor?: InputMaybe<OfferWhereUniqueInput>;
    distinct?: InputMaybe<OfferDistinctFieldEnum>;
    orderBy?: InputMaybe<OfferOrderByInput>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<OfferWhereInput>;
};

export type ProviderOrderByInput = {
    active?: InputMaybe<SortOrder>;
    currency?: InputMaybe<SortOrder>;
    description?: InputMaybe<SortOrder>;
    hidden?: InputMaybe<SortOrder>;
    limitTransaction?: InputMaybe<SortOrder>;
    logo?: InputMaybe<SortOrder>;
    name?: InputMaybe<SortOrder>;
    providerId?: InputMaybe<SortOrder>;
    title?: InputMaybe<SortOrder>;
};

export type ProviderWhereInput = {
    AND?: InputMaybe<Array<InputMaybe<ProviderWhereInput>>>;
    NOT?: InputMaybe<Array<InputMaybe<ProviderWhereInput>>>;
    OR?: InputMaybe<Array<InputMaybe<ProviderWhereInput>>>;
    currency?: InputMaybe<StringFilter>;
    description?: InputMaybe<StringNullableFilter>;
    hidden?: InputMaybe<BoolFilter>;
    name?: InputMaybe<StringFilter>;
    offers?: InputMaybe<OfferListRelationFilter>;
    os?: InputMaybe<OperatingSystem>;
    providerId?: InputMaybe<StringFilter>;
};

export type ProviderWhereUniqueInput = {
    name?: InputMaybe<Scalars['String']['input']>;
    providerId?: InputMaybe<Scalars['String']['input']>;
};

export const PushSetting = {
    Friendship: 'Friendship',
    Gift: 'Gift',
    Message: 'Message',
    Picture: 'Picture',
    Poke: 'Poke',
    SystemMessage: 'SystemMessage',
    Visit: 'Visit',
} as const;

export type PushSetting = (typeof PushSetting)[keyof typeof PushSetting];
export type Query = {
    __typename: 'Query';
    /** aggregate own conversations, e.g. get amount of all unread */
    aggregateConversations?: Maybe<AggregateConversationsResult>;
    coins?: Maybe<Scalars['Int']['output']>;
    /** get cost and bonus coins */
    config: Config;
    /** get a list of [Avatar]({{Types.Avatar}}), Avatar is a feature and not available for all projects */
    findManyAvatar: Array<Avatar>;
    /** get list of all blocked Profile */
    findManyBlocked: Array<Blocked>;
    /** get count of all blocked Profile, use for pagination */
    findManyBlockedCount: Scalars['Int']['output'];
    /** get ComplainType list, translations are filtered by user language */
    findManyComplainType: Array<ComplainType>;
    /** get list of conversation node for login user. Max take = (-)10, default orderBy lastAction desc */
    findManyConversation: Array<Conversation>;
    /** get count of user conversations */
    findManyConversationCount: Scalars['Int']['output'];
    /** get list of own ConversationProfile node */
    findManyConversationProfile: Array<ConversationProfile>;
    /**
     * get list of [DailySong]({{Types.DailySong}}),
     *             **DailySong is a feature and not available for all projects**
     */
    findManyDailySong: Array<DailySong>;
    /** get list of own DeactivatedPush node */
    findManyDeactivatedPush: Array<DeactivatedPush>;
    findManyEyeCatcher: Array<EyeCatcher>;
    findManyEyeCatcherCount: Scalars['Int']['output'];
    /** get list of Favorite node for login user */
    findManyFavorite: Array<Favorite>;
    /** get count of own Favorite */
    findManyFavoriteCount: Scalars['Int']['output'];
    findManyFlag: Array<Flag>;
    /** list of own Friendship node */
    findManyFriendship: Array<Friendship>;
    /** count of own Friendship */
    findManyFriendshipCount: Scalars['Int']['output'];
    findManyGeolocation: Array<Geolocation>;
    findManyGeolocationCount: Scalars['Int']['output'];
    /** get list of Gift node */
    findManyGift: Array<Gift>;
    /** get list of GiftCategory node */
    findManyGiftCategory: Array<GiftCategory>;
    /** get count of GiftCategory */
    findManyGiftCategoryCount: Scalars['Int']['output'];
    /** list of Interest node */
    findManyInterest: Array<Interest>;
    findManyInterestCategory: Array<InterestCategory>;
    /** count of Interest */
    findManyInterestCount: Scalars['Int']['output'];
    /** get available languages */
    findManyLanguage: Array<Language>;
    findManyMatch: Array<Match>;
    findManyMatchCount: Scalars['Int']['output'];
    findManyMessage: Array<Message>;
    findManyMessageCount?: Maybe<Scalars['Int']['output']>;
    findManyNotification: Array<Notification>;
    findManyNotificationCount: Scalars['Int']['output'];
    findManyOffer: Array<Offer>;
    /**
     * Get list of [OptionPoll]({{Types.OptionPoll}}) for user languageCode,
     *                 **OptionPoll is a feature and not available for all projects**
     */
    findManyOptionPoll: Array<OptionPoll>;
    findManyPicture: Array<Picture>;
    /**
     * get list of all [PredefinedMessage]({{Types.PredefinedMessage}}),
     *             **[PredefinedMessage]({{Types.PredefinedMessage}}) is
     *             a feature and not available for all projects**
     */
    findManyPredefinedMessage: Array<PredefinedMessage>;
    findManyProfile: Array<Profile>;
    findManyProfileCount: Scalars['Int']['output'];
    /** get list of all [ProfileText]({{Types.ProfileText}}) node */
    findManyProfileText: Array<ProfileText>;
    findManyProvider: Array<Provider>;
    findManySupportTicket: Array<SupportTicket>;
    findManyTheme: Array<Theme>;
    findManyThemeCount: Scalars['Int']['output'];
    findManyThemeImage: Array<ThemeImage>;
    findManyTranslation: Array<Translation>;
    findManyTranslationCount: Scalars['Int']['output'];
    findManyVisit: Array<Visit>;
    findManyVisitCount: Scalars['Int']['output'];
    findManyVoting: Array<Voting>;
    findManyVotingCount: Scalars['Int']['output'];
    /** get one conversation for login user */
    findOneConversation?: Maybe<Conversation>;
    /** get one own ConversationProfile node */
    findOneConversationProfile?: Maybe<ConversationProfile>;
    /** get one DeactivatedPush node fo login user */
    findOneDeactivatedPush?: Maybe<DeactivatedPush>;
    findOneEyeCatcher?: Maybe<EyeCatcher>;
    /** get one Favorite for login user */
    findOneFavorite?: Maybe<Favorite>;
    /** get one own Friendship */
    findOneFriendship?: Maybe<Friendship>;
    /** get one Gift */
    findOneGift?: Maybe<Gift>;
    /** get one GiftCategory */
    findOneGiftCategory?: Maybe<GiftCategory>;
    findOneInterestCategory?: Maybe<InterestCategory>;
    findOneOffer?: Maybe<Offer>;
    findOneProfile?: Maybe<Profile>;
    findOneSupportTicket?: Maybe<SupportTicket>;
    findOneTheme?: Maybe<Theme>;
    findOneTransaction: Transaction;
    findOneTranslation?: Maybe<Translation>;
    /** get cost for all types */
    getCosts: Cost;
    getCounties: Array<Scalars['String']['output']>;
    getCountries: Array<Scalars['String']['output']>;
    getMatchFilter?: Maybe<MatchFilter>;
    getNextMatches: NextMatchResult;
    /** get login streak config */
    loginStreakConfig?: Maybe<LoginStreak>;
    matchConfig: MatchConfigResult;
    myProfile: MyProfile;
    randomProfile?: Maybe<Profile>;
    unreadSupportMessageCount: Scalars['Int']['output'];
    userPremiumStatus: Array<UserPremiumStatus>;
};

export type QueryAggregateConversationsArgs = {
    _sum?: InputMaybe<ConversationProfileSumAggregateInputType>;
    where?: InputMaybe<ConversationProfileWhereInput>;
};

export type QueryFindManyAvatarArgs = {
    where?: InputMaybe<AvatarWhereInput>;
};

export type QueryFindManyBlockedArgs = {
    cursor?: InputMaybe<BlockedWhereUniqueInput>;
    orderBy?: InputMaybe<BlockedOrderByInput>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<BlockedWhereInput>;
};

export type QueryFindManyBlockedCountArgs = {
    cursor?: InputMaybe<BlockedWhereUniqueInput>;
    orderBy?: InputMaybe<BlockedOrderByInput>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<BlockedWhereInput>;
};

export type QueryFindManyConversationArgs = {
    cursor?: InputMaybe<ConversationWhereUniqueInput>;
    orderBy?: InputMaybe<ConversationOrderByInput>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ConversationWhereInput>;
};

export type QueryFindManyConversationCountArgs = {
    cursor?: InputMaybe<ConversationWhereUniqueInput>;
    orderBy?: InputMaybe<ConversationOrderByInput>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ConversationWhereInput>;
};

export type QueryFindManyConversationProfileArgs = {
    cursor?: InputMaybe<ConversationProfileWhereUniqueInput>;
    orderBy?: InputMaybe<ConversationProfileOrderByInput>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ConversationProfileWhereInput>;
};

export type QueryFindManyDeactivatedPushArgs = {
    orderBy?: InputMaybe<DeactivatedPushOrderByInput>;
    where?: InputMaybe<DeactivatedPushWhereInput>;
};

export type QueryFindManyEyeCatcherArgs = {
    cursor?: InputMaybe<EyeCatcherWhereUniqueInput>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<EyeCatcherWhereInput>;
};

export type QueryFindManyEyeCatcherCountArgs = {
    cursor?: InputMaybe<EyeCatcherWhereUniqueInput>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<EyeCatcherWhereInput>;
};

export type QueryFindManyFavoriteArgs = {
    cursor?: InputMaybe<FavoriteWhereUniqueInput>;
    orderBy?: InputMaybe<FavoriteOrderByInput>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<FavoriteWhereInput>;
};

export type QueryFindManyFavoriteCountArgs = {
    cursor?: InputMaybe<FavoriteWhereUniqueInput>;
    orderBy?: InputMaybe<FavoriteOrderByInput>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<FavoriteWhereInput>;
};

export type QueryFindManyFriendshipArgs = {
    cursor?: InputMaybe<FriendshipWhereUniqueInput>;
    orderBy?: InputMaybe<FriendshipOrderByInput>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<FriendshipWhereInput>;
};

export type QueryFindManyFriendshipCountArgs = {
    cursor?: InputMaybe<FriendshipWhereUniqueInput>;
    orderBy?: InputMaybe<FriendshipOrderByInput>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<FriendshipWhereInput>;
};

export type QueryFindManyGeolocationArgs = {
    cursor?: InputMaybe<GeolocationWhereUniqueInput>;
    distinct?: InputMaybe<GeolocationDistinctFieldEnum>;
    orderBy?: InputMaybe<GeolocationOrderByInput>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<GeolocationWhereInput>;
};

export type QueryFindManyGeolocationCountArgs = {
    cursor?: InputMaybe<GeolocationWhereUniqueInput>;
    distinct?: InputMaybe<GeolocationDistinctFieldEnum>;
    orderBy?: InputMaybe<GeolocationOrderByInput>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<GeolocationWhereInput>;
};

export type QueryFindManyGiftArgs = {
    cursor?: InputMaybe<GiftWhereUniqueInput>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<GiftWhereInput>;
};

export type QueryFindManyGiftCategoryArgs = {
    cursor?: InputMaybe<GiftCategoryWhereUniqueInput>;
    orderBy?: InputMaybe<GiftCategoryOrderByInput>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<GiftCategoryWhereInput>;
};

export type QueryFindManyGiftCategoryCountArgs = {
    cursor?: InputMaybe<GiftCategoryWhereUniqueInput>;
    orderBy?: InputMaybe<GiftCategoryOrderByInput>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<GiftCategoryWhereInput>;
};

export type QueryFindManyInterestArgs = {
    cursor?: InputMaybe<InterestWhereUniqueInput>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<InterestWhereInput>;
};

export type QueryFindManyInterestCategoryArgs = {
    cursor?: InputMaybe<InterestCategoryWhereUniqueInput>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryFindManyInterestCountArgs = {
    cursor?: InputMaybe<InterestWhereUniqueInput>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<InterestWhereInput>;
};

export type QueryFindManyMatchArgs = {
    cursor?: InputMaybe<MatchWhereUniqueInput>;
    orderBy?: InputMaybe<Array<InputMaybe<MatchOrderByWithRelationInput>>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryFindManyMatchCountArgs = {
    cursor?: InputMaybe<MatchWhereUniqueInput>;
    orderBy?: InputMaybe<MatchOrderByWithRelationInput>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryFindManyMessageArgs = {
    cursor?: InputMaybe<MessageWhereUniqueInput>;
    distinct?: InputMaybe<MessageDistinctFieldEnum>;
    orderBy?: InputMaybe<MessageOrderByInput>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<MessageWhereInput>;
};

export type QueryFindManyMessageCountArgs = {
    cursor?: InputMaybe<MessageWhereUniqueInput>;
    distinct?: InputMaybe<MessageDistinctFieldEnum>;
    orderBy?: InputMaybe<MessageOrderByInput>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<MessageWhereInput>;
};

export type QueryFindManyNotificationArgs = {
    cursor?: InputMaybe<NotificationWhereUniqueInput>;
    orderBy?: InputMaybe<NotificationOrderByInput>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<NotificationWhereInput>;
};

export type QueryFindManyNotificationCountArgs = {
    cursor?: InputMaybe<NotificationWhereUniqueInput>;
    orderBy?: InputMaybe<NotificationOrderByInput>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<NotificationWhereInput>;
};

export type QueryFindManyOfferArgs = {
    cursor?: InputMaybe<OfferWhereUniqueInput>;
    orderBy?: InputMaybe<OfferOrderByInput>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<OfferWhereInput>;
};

export type QueryFindManyPictureArgs = {
    hidden?: InputMaybe<Scalars['Boolean']['input']>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryFindManyProfileArgs = {
    cursor?: InputMaybe<ProfileWhereUniqueInput>;
    orderBy?: InputMaybe<ProfileOrderByInput>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ProfileWhereInputExtended>;
};

export type QueryFindManyProfileCountArgs = {
    cursor?: InputMaybe<ProfileWhereUniqueInput>;
    orderBy?: InputMaybe<ProfileOrderByInput>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ProfileWhereInput>;
};

export type QueryFindManyProviderArgs = {
    cursor?: InputMaybe<ProviderWhereUniqueInput>;
    orderBy?: InputMaybe<ProviderOrderByInput>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ProviderWhereInput>;
};

export type QueryFindManySupportTicketArgs = {
    cursor?: InputMaybe<SupportTicketWhereUniqueInput>;
    orderBy?: InputMaybe<Array<InputMaybe<SupportTicketOrderByInput>>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<SupportTicketWhereInput>;
};

export type QueryFindManyThemeArgs = {
    cursor?: InputMaybe<ThemeWhereUniqueInput>;
    orderBy?: InputMaybe<ThemeOrderByInput>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ThemeWhereInput>;
};

export type QueryFindManyThemeCountArgs = {
    cursor?: InputMaybe<ThemeWhereUniqueInput>;
    orderBy?: InputMaybe<ThemeOrderByInput>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ThemeWhereInput>;
};

export type QueryFindManyThemeImageArgs = {
    cursor?: InputMaybe<ThemeImageWhereUniqueInput>;
    orderBy?: InputMaybe<ThemeImageOrderByInput>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ThemeImageWhereInput>;
};

export type QueryFindManyTranslationArgs = {
    cursor?: InputMaybe<TranslationWhereUniqueInput>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<TranslationWhereInput>;
};

export type QueryFindManyTranslationCountArgs = {
    cursor?: InputMaybe<TranslationWhereUniqueInput>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<TranslationWhereInput>;
};

export type QueryFindManyVisitArgs = {
    cursor?: InputMaybe<VisitWhereUniqueInput>;
    distinct?: InputMaybe<VisitDistinctFieldEnum>;
    orderBy?: InputMaybe<VisitOrderByInput>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<VisitWhereInput>;
};

export type QueryFindManyVisitCountArgs = {
    cursor?: InputMaybe<VisitWhereUniqueInput>;
    distinct?: InputMaybe<VisitDistinctFieldEnum>;
    orderBy?: InputMaybe<VisitOrderByInput>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<VisitWhereInput>;
};

export type QueryFindManyVotingArgs = {
    cursor?: InputMaybe<VotingWhereUniqueInput>;
    orderBy?: InputMaybe<VotingOrderByInput>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<VotingWhereInput>;
};

export type QueryFindManyVotingCountArgs = {
    cursor?: InputMaybe<VotingWhereUniqueInput>;
    orderBy?: InputMaybe<VotingOrderByInput>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<VotingWhereInput>;
};

export type QueryFindOneConversationArgs = {
    where: ConversationWhereUniqueInput;
};

export type QueryFindOneConversationProfileArgs = {
    where: ConversationProfileWhereUniqueInput;
};

export type QueryFindOneDeactivatedPushArgs = {
    where: DeactivatedPushWhereUniqueInput;
};

export type QueryFindOneEyeCatcherArgs = {
    where: EyeCatcherWhereUniqueInput;
};

export type QueryFindOneFavoriteArgs = {
    where: FavoriteWhereUniqueInput;
};

export type QueryFindOneFriendshipArgs = {
    where: FriendshipWhereUniqueInput;
};

export type QueryFindOneGiftArgs = {
    where: GiftWhereUniqueInput;
};

export type QueryFindOneGiftCategoryArgs = {
    where: GiftCategoryWhereUniqueInput;
};

export type QueryFindOneInterestCategoryArgs = {
    where: InterestCategoryWhereUniqueInput;
};

export type QueryFindOneOfferArgs = {
    where: OfferWhereUniqueInput;
};

export type QueryFindOneProfileArgs = {
    where: ProfileWhereUniqueInput;
};

export type QueryFindOneSupportTicketArgs = {
    where: SupportTicketWhereUniqueInput;
};

export type QueryFindOneThemeArgs = {
    where: ThemeWhereUniqueInput;
};

export type QueryFindOneTransactionArgs = {
    where?: InputMaybe<TransactionWhereUniqueInput>;
};

export type QueryFindOneTranslationArgs = {
    where: TranslationWhereUniqueInput;
};

export type QueryLoginStreakConfigArgs = {
    languageCode?: InputMaybe<Scalars['String']['input']>;
};

export type QueryRandomProfileArgs = {
    where: ProfileWhereInput;
};

export type RegisterC4FInput = {
    affiliateName?: Scalars['String']['input'];
    /** YYYY-MM-DD */
    birthDate: Scalars['String']['input'];
    c4fId: Scalars['String']['input'];
    /** Client */
    client?: InputMaybe<Scalars['String']['input']>;
    /** Client version */
    clientVersion?: InputMaybe<Scalars['String']['input']>;
    domain?: InputMaybe<Scalars['String']['input']>;
    /** Email */
    email?: InputMaybe<Scalars['String']['input']>;
    /** FlirtText */
    flirtText?: InputMaybe<Scalars['String']['input']>;
    gender?: InputMaybe<Gender>;
    hash: Scalars['String']['input'];
    ip: Scalars['String']['input'];
    /** Language.code */
    language: Scalars['String']['input'];
    /** c4f location object */
    location: LocationInput;
    /** MobileNumber E.164 format */
    mobileNumber?: InputMaybe<Scalars['String']['input']>;
    /** Password */
    password: Scalars['String']['input'];
    /** ProfileName */
    profileName?: InputMaybe<Scalars['String']['input']>;
    /** pushToken */
    pushToken?: InputMaybe<Scalars['String']['input']>;
    searches?: InputMaybe<Gender>;
    /** Theme */
    theme?: InputMaybe<Scalars['String']['input']>;
    /** IANA String, Android: TimeZone tz = TimeZone.getTimeZone("America/Los_Angeles, iOS: var localTimeZoneIdentifier: String { return TimeZone.current.identifier }"); */
    timezone?: InputMaybe<Scalars['String']['input']>;
    /** Many leads */
    userLeads?: InputMaybe<UserLeadCreateManyWithoutUserInput>;
    /** Username */
    username: Scalars['String']['input'];
};

export type RegisterDirectInput = {
    affiliateName?: Scalars['String']['input'];
    /** YYYY-MM-DD */
    birthDate: Scalars['String']['input'];
    c4fId?: InputMaybe<Scalars['String']['input']>;
    /** Client */
    client?: InputMaybe<Scalars['String']['input']>;
    /** Client version */
    clientVersion?: InputMaybe<Scalars['String']['input']>;
    /** Country Code */
    country: Scalars['String']['input'];
    /** County */
    county?: InputMaybe<Scalars['String']['input']>;
    domain?: InputMaybe<Scalars['String']['input']>;
    /** Email */
    email?: InputMaybe<Scalars['String']['input']>;
    /** FlirtText */
    flirtText?: InputMaybe<Scalars['String']['input']>;
    gender?: InputMaybe<Gender>;
    hash: Scalars['String']['input'];
    ip: Scalars['String']['input'];
    /** Language.code */
    language: Scalars['String']['input'];
    /** md5 hash of password */
    md5Password: Scalars['String']['input'];
    /** MobileNumber E.164 format */
    mobileNumber?: InputMaybe<Scalars['String']['input']>;
    postcode: Scalars['String']['input'];
    /** ProfileName */
    profileName?: InputMaybe<Scalars['String']['input']>;
    /** pushToken */
    pushToken?: InputMaybe<Scalars['String']['input']>;
    searches?: InputMaybe<Gender>;
    /** Theme */
    theme?: InputMaybe<Scalars['String']['input']>;
    /** IANA String, Android: TimeZone tz = TimeZone.getTimeZone("America/Los_Angeles, iOS: var localTimeZoneIdentifier: String { return TimeZone.current.identifier }"); */
    timezone?: InputMaybe<Scalars['String']['input']>;
    /** Town */
    town?: InputMaybe<Scalars['String']['input']>;
    /** Many leads */
    userLeads?: InputMaybe<UserLeadCreateManyWithoutUserInput>;
    /** Username */
    username: Scalars['String']['input'];
};

export type RegisterInput = {
    affiliateName?: Scalars['String']['input'];
    /** YYYY-MM-DD */
    birthDate: Scalars['String']['input'];
    /** Client */
    client?: InputMaybe<Scalars['String']['input']>;
    /** Client version */
    clientVersion?: InputMaybe<Scalars['String']['input']>;
    /** Country Code */
    country: Scalars['String']['input'];
    /** County */
    county?: InputMaybe<Scalars['String']['input']>;
    domain?: InputMaybe<Scalars['String']['input']>;
    /** Email */
    email?: InputMaybe<Scalars['String']['input']>;
    /** FlirtText */
    flirtText?: InputMaybe<Scalars['String']['input']>;
    gender?: InputMaybe<Gender>;
    /** Language.code */
    language: Scalars['String']['input'];
    /** MobileNumber E.164 format */
    mobileNumber?: InputMaybe<Scalars['String']['input']>;
    /** Password */
    password: Scalars['String']['input'];
    /** Postcode */
    postcode?: InputMaybe<Scalars['String']['input']>;
    /** ProfileName */
    profileName?: InputMaybe<Scalars['String']['input']>;
    /** pushToken */
    pushToken?: InputMaybe<Scalars['String']['input']>;
    searches?: InputMaybe<Gender>;
    /** Theme */
    theme?: InputMaybe<Scalars['String']['input']>;
    /** IANA String, Android: TimeZone tz = TimeZone.getTimeZone("America/Los_Angeles, iOS: var localTimeZoneIdentifier: String { return TimeZone.current.identifier }"); */
    timezone: Scalars['String']['input'];
    /** Town */
    town?: InputMaybe<Scalars['String']['input']>;
    /** Many leads */
    userLeads?: InputMaybe<UserLeadCreateManyWithoutUserInput>;
    /** Username */
    username: Scalars['String']['input'];
};

/** Result for register */
export type RegisterResult = RegisterResultSuccess | ResultError;

export type RegisterResultSuccess = {
    __typename: 'RegisterResultSuccess';
    coins: Scalars['Int']['output'];
    myProfile: MyProfile;
    role: UserRole;
    token: Scalars['String']['output'];
    userId: Scalars['String']['output'];
};

export type RegisterShortInput = {
    affiliateName?: Scalars['String']['input'];
    /** Client */
    client?: InputMaybe<Scalars['String']['input']>;
    /** Client version */
    clientVersion?: InputMaybe<Scalars['String']['input']>;
    domain?: InputMaybe<Scalars['String']['input']>;
    /** Email */
    email?: InputMaybe<Scalars['String']['input']>;
    /** ISO LanguageCode -> de, en */
    language: Scalars['String']['input'];
    /** MobileNumber E.164 format */
    mobileNumber?: InputMaybe<Scalars['String']['input']>;
    /** Password min(6), max(100) */
    password: Scalars['String']['input'];
    /** pushToken */
    pushToken?: InputMaybe<Scalars['String']['input']>;
    /** IANA String, Android: TimeZone tz = TimeZone.getTimeZone("America/Los_Angeles, iOS: var localTimeZoneIdentifier: String { return TimeZone.current.identifier }"); */
    timezone: Scalars['String']['input'];
    /** Many leads */
    userLeads?: InputMaybe<UserLeadCreateManyWithoutUserInput>;
    /** Username min(3), max(100) */
    username: Scalars['String']['input'];
};

export type RemoveFriendshipInput = {
    /** cuid other Profile */
    otherId: Scalars['String']['input'];
};

export type ResetPasswordInput = {
    newPassword: Scalars['String']['input'];
    oldPassword?: InputMaybe<Scalars['String']['input']>;
    passwordHash?: InputMaybe<Scalars['String']['input']>;
};

export type ResetPasswordResult = ResultError | ResultSuccess;

export type Result = Error | ResultError | ResultSuccess;

export type ResultError = {
    __typename: 'ResultError';
    errors: Array<Error>;
};

export type ResultSuccess = {
    __typename: 'ResultSuccess';
    success: Scalars['Boolean']['output'];
};

export type SelfIdOtherIdCompoundUniqueInput = {
    /** other profileId */
    otherId: Scalars['String']['input'];
    /** own profileId */
    selfId: Scalars['String']['input'];
};

export type SendMatchResult = Error | Match;

/** Result for sendPoke|sendMessage|sendGift */
export type SendMessageResult = CoinsResultSuccess | ResultError;

export type Social = {
    __typename: 'Social';
    providerName: Scalars['String']['output'];
    socialId: Scalars['String']['output'];
};

export type SocialError = {
    __typename: 'SocialError';
    email?: Maybe<Scalars['Boolean']['output']>;
    username?: Maybe<Scalars['Boolean']['output']>;
};

export type SocialLoginInput = {
    affiliateName?: InputMaybe<Scalars['String']['input']>;
    client?: InputMaybe<Scalars['String']['input']>;
    clientVersion?: InputMaybe<Scalars['String']['input']>;
    domain?: InputMaybe<Scalars['String']['input']>;
    email?: InputMaybe<Scalars['String']['input']>;
    language: Scalars['String']['input'];
    socialId?: InputMaybe<Scalars['String']['input']>;
    timezone: Scalars['String']['input'];
    token: Scalars['String']['input'];
    /** Many leads */
    userLeads?: InputMaybe<UserLeadCreateManyWithoutUserInput>;
    username?: InputMaybe<Scalars['String']['input']>;
};

export type SocialLoginResult = LoginResultSuccess | ResultError;

export type SocialWhereUniqueInput = {
    providerName: Scalars['String']['input'];
    userId: Scalars['String']['input'];
};

export const SortOrder = {
    Asc: 'asc',
    Desc: 'desc',
} as const;

export type SortOrder = (typeof SortOrder)[keyof typeof SortOrder];
export type StringFilter = {
    contains?: InputMaybe<Scalars['String']['input']>;
    endsWith?: InputMaybe<Scalars['String']['input']>;
    equals?: InputMaybe<Scalars['String']['input']>;
    gt?: InputMaybe<Scalars['String']['input']>;
    gte?: InputMaybe<Scalars['String']['input']>;
    in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    lt?: InputMaybe<Scalars['String']['input']>;
    lte?: InputMaybe<Scalars['String']['input']>;
    not?: InputMaybe<Scalars['String']['input']>;
    notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type StringNullableFilter = {
    contains?: InputMaybe<Scalars['String']['input']>;
    endsWith?: InputMaybe<Scalars['String']['input']>;
    equals?: InputMaybe<Scalars['String']['input']>;
    gt?: InputMaybe<Scalars['String']['input']>;
    gte?: InputMaybe<Scalars['String']['input']>;
    in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    lt?: InputMaybe<Scalars['String']['input']>;
    lte?: InputMaybe<Scalars['String']['input']>;
    not?: InputMaybe<Scalars['String']['input']>;
    notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type Subscription = {
    __typename: 'Subscription';
    /** for online user to send all events */
    notifications?: Maybe<NotificationSubscriptionPayload>;
};

export const SupportCategory = {
    Bug: 'Bug',
    Other: 'Other',
    Payment: 'Payment',
    UserComplain: 'UserComplain',
} as const;

export type SupportCategory =
    (typeof SupportCategory)[keyof typeof SupportCategory];
export type SupportMessage = {
    __typename: 'SupportMessage';
    createdAt: Scalars['DateTime']['output'];
    read: Scalars['Boolean']['output'];
    sender: SupportMessageSender;
    supportMessageId: Scalars['String']['output'];
    supportTicket: SupportTicket;
    supportTicketId: Scalars['String']['output'];
    text: Scalars['String']['output'];
    updatedAt: Scalars['DateTime']['output'];
};

export type SupportMessageCreateInput = {
    category?: InputMaybe<SupportCategory>;
    status?: InputMaybe<SupportTicketStatus>;
    supportTicketId?: InputMaybe<Scalars['String']['input']>;
    text?: InputMaybe<Scalars['String']['input']>;
};

export type SupportMessageOrderByInput = {
    createdAt?: InputMaybe<SortOrder>;
    supportMessageId?: InputMaybe<SortOrder>;
    supportTicketId?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export const SupportMessageSender = {
    Support: 'Support',
    System: 'System',
    User: 'User',
} as const;

export type SupportMessageSender =
    (typeof SupportMessageSender)[keyof typeof SupportMessageSender];
export type SupportMessageWhereInput = {
    createdAt?: InputMaybe<DateTimeFilter>;
    supportMessageId?: InputMaybe<StringFilter>;
    supportTicketId?: InputMaybe<Scalars['String']['input']>;
    updatedAt?: InputMaybe<DateTimeFilter>;
};

export type SupportMessageWhereUniqueInput = {
    supportMessageId: Scalars['String']['input'];
};

export type SupportTicket = {
    __typename: 'SupportTicket';
    category: SupportCategory;
    createdAt: Scalars['DateTime']['output'];
    status: SupportTicketStatus;
    supportMessages: Array<SupportMessage>;
    supportTicketId: Scalars['String']['output'];
    ticketNumber: Scalars['Int']['output'];
    updatedAt: Scalars['DateTime']['output'];
};

export type SupportTicketSupportMessagesArgs = {
    cursor?: InputMaybe<SupportMessageWhereUniqueInput>;
    orderBy?: InputMaybe<Array<InputMaybe<SupportMessageOrderByInput>>>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<SupportMessageWhereInput>;
};

export type SupportTicketOrderByInput = {
    status?: InputMaybe<SortOrder>;
    supportTicketId?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export const SupportTicketStatus = {
    Answered: 'Answered',
    Closed: 'Closed',
    Open: 'Open',
    Pending: 'Pending',
} as const;

export type SupportTicketStatus =
    (typeof SupportTicketStatus)[keyof typeof SupportTicketStatus];
export type SupportTicketWhereInput = {
    createdAt?: InputMaybe<DateTimeFilter>;
    status?: InputMaybe<EnumSupportTicketStatusFilter>;
    supportTicketId?: InputMaybe<StringFilter>;
    updatedAt?: InputMaybe<DateTimeFilter>;
};

export type SupportTicketWhereUniqueInput = {
    supportTicketId: Scalars['String']['input'];
};

export type Theme = {
    __typename: 'Theme';
    images: Array<ThemeImage>;
    name: Scalars['String']['output'];
    themeId: Scalars['String']['output'];
};

export type ThemeImagesArgs = {
    cursor?: InputMaybe<ThemeImageWhereUniqueInput>;
    distinct?: InputMaybe<ThemeImageDistinctFieldEnum>;
    orderBy?: InputMaybe<ThemeImageOrderByInput>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<ThemeImageWhereInput>;
};

export type ThemeImage = {
    __typename: 'ThemeImage';
    label: Scalars['String']['output'];
    /** relative theme image path */
    path: Scalars['String']['output'];
    theme: Theme;
    themeImageId: Scalars['String']['output'];
    themeName: Scalars['String']['output'];
};

export type ThemeImagePathArgs = {
    relative?: InputMaybe<Scalars['Boolean']['input']>;
};

export const ThemeImageDistinctFieldEnum = {
    Label: 'label',
    Path: 'path',
    ThemeImageId: 'themeImageId',
    ThemeName: 'themeName',
} as const;

export type ThemeImageDistinctFieldEnum =
    (typeof ThemeImageDistinctFieldEnum)[keyof typeof ThemeImageDistinctFieldEnum];
export type ThemeImageOrderByInput = {
    label?: InputMaybe<SortOrder>;
    path?: InputMaybe<SortOrder>;
    themeImageId?: InputMaybe<SortOrder>;
    themeName?: InputMaybe<SortOrder>;
};

export type ThemeImageWhereInput = {
    AND?: InputMaybe<Array<InputMaybe<ThemeImageWhereInput>>>;
    NOT?: InputMaybe<Array<InputMaybe<ThemeImageWhereInput>>>;
    OR?: InputMaybe<Array<InputMaybe<ThemeImageWhereInput>>>;
    theme?: InputMaybe<ThemeWhereInput>;
    themeImageId?: InputMaybe<StringFilter>;
    themeName?: InputMaybe<StringFilter>;
};

export type ThemeImageWhereUniqueInput = {
    themeImageId: Scalars['String']['input'];
};

export type ThemeOrderByInput = {
    createdAt?: InputMaybe<SortOrder>;
    name?: InputMaybe<SortOrder>;
    updatedAt?: InputMaybe<SortOrder>;
};

export type ThemeWhereInput = {
    AND?: InputMaybe<Array<InputMaybe<ThemeWhereInput>>>;
    NOT?: InputMaybe<Array<InputMaybe<ThemeWhereInput>>>;
    OR?: InputMaybe<Array<InputMaybe<ThemeWhereInput>>>;
    name?: InputMaybe<StringFilter>;
};

export type ThemeWhereUniqueInput = {
    name: Scalars['String']['input'];
};

export type Transaction = {
    __typename: 'Transaction';
    bonus?: Maybe<Scalars['Int']['output']>;
    coins: Scalars['Int']['output'];
    cost: Scalars['Float']['output'];
    currency: Scalars['String']['output'];
    provider: Provider;
    providerName: Scalars['String']['output'];
    transactionId: Scalars['String']['output'];
    user: User;
    userId: Scalars['String']['output'];
};

export type TransactionInput = {
    Offer: OfferWhereUniqueInput;
    reference?: InputMaybe<Scalars['String']['input']>;
};

/** Result for createBilling */
export type TransactionResult =
    | ResultError
    | TransactionResultPending
    | TransactionResultSuccess;

export type TransactionResultData = BankData;

export type TransactionResultPending = {
    __typename: 'TransactionResultPending';
    /** Custom data object for frontend */
    data?: Maybe<TransactionResultData>;
    extTransactionId?: Maybe<Scalars['String']['output']>;
    offer?: Maybe<Offer>;
    provider?: Maybe<Scalars['String']['output']>;
    redirectUrl?: Maybe<Scalars['String']['output']>;
    transactionId: Scalars['String']['output'];
    verify?: Maybe<Scalars['Boolean']['output']>;
};

export type TransactionResultSuccess = {
    __typename: 'TransactionResultSuccess';
    coins: CoinsResultSuccess;
    extTransactionId?: Maybe<Scalars['String']['output']>;
    paymentMethod?: Maybe<Scalars['String']['output']>;
    provider?: Maybe<Scalars['String']['output']>;
    transactionCountry?: Maybe<Scalars['String']['output']>;
    transactionId: Scalars['String']['output'];
};

export type TransactionWhereUniqueInput = {
    reference?: InputMaybe<Scalars['String']['input']>;
    token?: InputMaybe<Scalars['String']['input']>;
    transactionId?: InputMaybe<Scalars['String']['input']>;
};

export type Translation = {
    __typename: 'Translation';
    /** cuid for avatar, Avatar is a feature and not available for all projects */
    avatarId?: Maybe<Scalars['String']['output']>;
    complainTypeId?: Maybe<Scalars['String']['output']>;
    flagId?: Maybe<Scalars['String']['output']>;
    flagValueId?: Maybe<Scalars['String']['output']>;
    giftCategoryId?: Maybe<Scalars['String']['output']>;
    giftId?: Maybe<Scalars['String']['output']>;
    /** identifier cuid */
    id: Scalars['String']['output'];
    interestCategoryId?: Maybe<Scalars['String']['output']>;
    interestId?: Maybe<Scalars['String']['output']>;
    languageCode: Scalars['String']['output'];
    /**
     * cuid of [PredefinedMessage]({{Types.PredefinedMessage}}),
     *             **[PredefinedMessage]({{Types.PredefinedMessage}}) is a feature and
     *             not available for all projects**
     */
    predefinedMessageId?: Maybe<Scalars['String']['output']>;
    /** cuid of ProfileText */
    profileTextId?: Maybe<Scalars['String']['output']>;
    projectName: Scalars['String']['output'];
    translation: Scalars['String']['output'];
    translationId: Scalars['String']['output'];
    translationView: TranslationView;
};

export const TranslationView = {
    Edit: 'Edit',
    Show: 'Show',
} as const;

export type TranslationView =
    (typeof TranslationView)[keyof typeof TranslationView];
export type TranslationWhereInput = {
    languageCode?: InputMaybe<StringFilter>;
    translationId?: InputMaybe<StringFilter>;
    translationView?: InputMaybe<TranslationView>;
};

export type TranslationWhereUniqueInput = {
    translationId: Scalars['String']['input'];
};

export type UpdateGalleryImageInput = {
    imageId: Scalars['String']['input'];
    private: Scalars['Boolean']['input'];
};

export type UpdateMyProfileInput = {
    /** cuid for avatar, Avatar is a feature and not available for all projects */
    avatarId?: InputMaybe<Scalars['String']['input']>;
    birthDate?: InputMaybe<Scalars['String']['input']>;
    country?: InputMaybe<Scalars['String']['input']>;
    county?: InputMaybe<Scalars['String']['input']>;
    /** cuid of ProfileText */
    defaultTextId?: InputMaybe<Scalars['String']['input']>;
    flirtText?: InputMaybe<Scalars['String']['input']>;
    gender?: InputMaybe<Gender>;
    hidden?: InputMaybe<Scalars['Boolean']['input']>;
    postcode?: InputMaybe<Scalars['String']['input']>;
    profileFlags?: InputMaybe<ProfileFlagUpdateManyWithoutProfileNestedInput>;
    profileInterests?: InputMaybe<Array<InterestWhereUniqueInput>>;
    searches?: InputMaybe<Gender>;
    theme?: InputMaybe<ThemeWhereUniqueInput>;
    town?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateMyProfileResult = MyProfile | ResultError;

export type UpdateProfileImageInput = {
    imageId: Scalars['String']['input'];
};

export type UpdateTokenInput = {
    pushToken: Scalars['String']['input'];
};

export type UpdateTokenResultSuccess = {
    __typename: 'UpdateTokenResultSuccess';
    success?: Maybe<Scalars['Boolean']['output']>;
};

export type UploadGalleryImageInput = {
    /** base64 string of image file, please use crop to 1000x1000! */
    base64: Scalars['String']['input'];
};

export type UploadPictureInput = {
    base64: Scalars['String']['input'];
};

export type UploadPictureResult = Error | Picture;

export type User = {
    __typename: 'User';
    Notification?: Maybe<Array<Maybe<Notification>>>;
    client?: Maybe<Scalars['String']['output']>;
    clientVersion?: Maybe<Scalars['String']['output']>;
    coins: Scalars['Int']['output'];
    createdAt: Scalars['DateTime']['output'];
    deactivatedPushes?: Maybe<Array<Maybe<DeactivatedPush>>>;
    deleteToken: Scalars['String']['output'];
    email?: Maybe<Scalars['String']['output']>;
    emailValidated: Scalars['Boolean']['output'];
    flirtTextCompleted: Scalars['Boolean']['output'];
    imageCompleted: Scalars['Boolean']['output'];
    latitude?: Maybe<Scalars['String']['output']>;
    loginStreak: Scalars['Int']['output'];
    longitude?: Maybe<Scalars['String']['output']>;
    mobileNumber?: Maybe<Scalars['String']['output']>;
    mobileNumberValidated: Scalars['Boolean']['output'];
    profile: Profile;
    profileFlagsCompleted: Scalars['Boolean']['output'];
    profileId: Scalars['String']['output'];
    role: Scalars['String']['output'];
    sendMarketingEmail: Scalars['Boolean']['output'];
    sendSMS: Scalars['Boolean']['output'];
    sendTransactionalEmail: Scalars['Boolean']['output'];
    socials?: Maybe<Array<Social>>;
    userId: Scalars['String']['output'];
    userPremiumStatus: Array<UserPremiumStatus>;
    username: Scalars['String']['output'];
};

export type UserNotificationArgs = {
    cursor?: InputMaybe<NotificationWhereUniqueInput>;
    distinct?: InputMaybe<NotificationDistinctFieldEnum>;
    orderBy?: InputMaybe<NotificationOrderByInput>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<NotificationWhereInput>;
};

export type UserDeactivatedPushesArgs = {
    cursor?: InputMaybe<DeactivatedPushWhereUniqueInput>;
    distinct?: InputMaybe<DeactivatedPushDistinctFieldEnum>;
    orderBy?: InputMaybe<DeactivatedPushOrderByInput>;
    skip?: InputMaybe<Scalars['Int']['input']>;
    take?: InputMaybe<Scalars['Int']['input']>;
    where?: InputMaybe<DeactivatedPushWhereInput>;
};

export type UserComplain = {
    __typename: 'UserComplain';
    complainType: ComplainType;
    complainTypeName: Scalars['String']['output'];
    name?: Maybe<Scalars['String']['output']>;
    target: Profile;
    targetId: Scalars['String']['output'];
    text?: Maybe<Scalars['String']['output']>;
};

export type UserComplainCreateInput = {
    complainType: ComplainTypeCreateOneWithoutUserComplainInput;
    /** switch by type: pictureId|imageId|conversationId */
    id?: InputMaybe<Scalars['String']['input']>;
    name?: InputMaybe<Scalars['String']['input']>;
    /** Profile */
    target: ProfileCreateOneWithoutUserComplainInput;
    text?: InputMaybe<Scalars['String']['input']>;
    type?: InputMaybe<ComplainTypeType>;
};

export const UserComplainDistinctFieldEnum = {
    ComplainTypeName: 'complainTypeName',
    CreatedAt: 'createdAt',
    LanguageCode: 'languageCode',
    Name: 'name',
    ReporterId: 'reporterId',
    TargetId: 'targetId',
    Text: 'text',
    UserComplainId: 'userComplainId',
} as const;

export type UserComplainDistinctFieldEnum =
    (typeof UserComplainDistinctFieldEnum)[keyof typeof UserComplainDistinctFieldEnum];
export type UserCoupon = {
    __typename: 'UserCoupon';
    coupon: Coupon;
    couponCode: Scalars['String']['output'];
    user: User;
    userId: Scalars['String']['output'];
};

export type UserIdSettingCompoundUniqueInput = {
    setting: PushSetting;
    userId: Scalars['String']['input'];
};

export type UserLead = {
    __typename: 'UserLead';
    leadId: Scalars['String']['output'];
    leadName: Scalars['String']['output'];
    value: Scalars['String']['output'];
};

export type UserLeadCreateManyWithoutUserInput = {
    create: Array<UserLeadCreateWithoutUserInput>;
};

export type UserLeadCreateWithoutUserInput = {
    lead: LeadCreateOneWithoutUserLeadInput;
    value: Scalars['String']['input'];
};

export type UserPremiumStatus = {
    __typename: 'UserPremiumStatus';
    createdAt: Scalars['DateTime']['output'];
    profilePremiumStatusId: Scalars['String']['output'];
    status: ProfileStatus;
    userId: Scalars['String']['output'];
    validTo: Scalars['DateTime']['output'];
};

export const UserRole = {
    Blocked: 'Blocked',
    Deleted: 'Deleted',
    Guest: 'Guest',
    Incomplete: 'Incomplete',
    Lead: 'Lead',
    Member: 'Member',
    Premium: 'Premium',
} as const;

export type UserRole = (typeof UserRole)[keyof typeof UserRole];
export type UserUpdateInput = {
    deactivatedPushes?: InputMaybe<DeactivatedPushUpdateManyWithoutUserInput>;
    lastAction?: InputMaybe<Scalars['String']['input']>;
    latitude?: InputMaybe<Scalars['String']['input']>;
    longitude?: InputMaybe<Scalars['String']['input']>;
    pushToken?: InputMaybe<Scalars['String']['input']>;
    sendMarketingEmail?: InputMaybe<Scalars['Boolean']['input']>;
    sendSms?: InputMaybe<Scalars['Boolean']['input']>;
    sendTransactionalEmail?: InputMaybe<Scalars['Boolean']['input']>;
    timezone?: InputMaybe<Scalars['String']['input']>;
};

export type UserWhereUniqueInput = {
    userId?: InputMaybe<Scalars['String']['input']>;
};

export type ValidateEmailInput = {
    /** Email */
    email: Scalars['String']['input'];
};

export type ValidateMobileNumberInput = {
    /** MobileNumber E.164 format */
    mobileNumber: Scalars['String']['input'];
};

/** Result for validate */
export type ValidateResult = ResultError | ValidateResultSuccess;

export type ValidateResultSuccess = {
    __typename: 'ValidateResultSuccess';
    success?: Maybe<Scalars['Boolean']['output']>;
};

export type ValidateUsernameInput = {
    /** Username */
    username: Scalars['String']['input'];
};

export type VerifyEmailInput = {
    hash: Scalars['String']['input'];
};

export const VerifyStatus = {
    Default: 'Default',
    Pending: 'Pending',
    Verified: 'Verified',
} as const;

export type VerifyStatus = (typeof VerifyStatus)[keyof typeof VerifyStatus];
export type Visit = {
    __typename: 'Visit';
    createdAt: Scalars['DateTime']['output'];
    other: Profile;
    otherId: Scalars['String']['output'];
    self: Profile;
    selfId: Scalars['String']['output'];
    visitId: Scalars['String']['output'];
};

export const VisitDistinctFieldEnum = {
    OtherId: 'otherId',
    SelfId: 'selfId',
} as const;

export type VisitDistinctFieldEnum =
    (typeof VisitDistinctFieldEnum)[keyof typeof VisitDistinctFieldEnum];
export type VisitOrderByInput = {
    createdAt?: InputMaybe<SortOrder>;
    visitId?: InputMaybe<SortOrder>;
    visitorId?: InputMaybe<SortOrder>;
};

export type VisitProfileResult = {
    __typename: 'VisitProfileResult';
    other?: Maybe<Profile>;
    otherId?: Maybe<Scalars['String']['output']>;
    success: Scalars['Boolean']['output'];
};

export type VisitWhereInput = {
    AND?: InputMaybe<Array<InputMaybe<VisitWhereInput>>>;
    NOT?: InputMaybe<Array<InputMaybe<VisitWhereInput>>>;
    OR?: InputMaybe<Array<InputMaybe<VisitWhereInput>>>;
    createdAt?: InputMaybe<DateTimeFilter>;
    other?: InputMaybe<ProfileWhereInput>;
    otherId?: InputMaybe<StringFilter>;
    selfId?: InputMaybe<StringFilter>;
    visitId?: InputMaybe<StringFilter>;
};

export type VisitWhereUniqueInput = {
    visitId: Scalars['String']['input'];
};

export type Voting = {
    __typename: 'Voting';
    profile: Profile;
    profileId: Scalars['String']['output'];
    votes?: Maybe<Scalars['Int']['output']>;
    votingId: Scalars['String']['output'];
};

export type VotingCreateInput = {
    profile: ProfileCreateOneWithoutVotingInput;
};

export type VotingOrderByInput = {
    profileId?: InputMaybe<SortOrder>;
    votes?: InputMaybe<SortOrder>;
    votingId?: InputMaybe<SortOrder>;
};

export type VotingWhereInput = {
    AND?: InputMaybe<Array<InputMaybe<VotingWhereInput>>>;
    NOT?: InputMaybe<Array<InputMaybe<VotingWhereInput>>>;
    OR?: InputMaybe<Array<InputMaybe<VotingWhereInput>>>;
    profile?: InputMaybe<ProfileWhereInput>;
    profileId?: InputMaybe<StringFilter>;
    votes?: InputMaybe<IntNullableFilter>;
    votingId?: InputMaybe<StringFilter>;
};

export type VotingWhereUniqueInput = {
    profileId?: InputMaybe<Scalars['String']['input']>;
    votingId?: InputMaybe<Scalars['String']['input']>;
};

export type AvatarFragment = {
    __typename: 'Avatar';
    avatarId: string;
    name?: string | null;
    path: string;
    translations: Array<{
        __typename: 'Translation';
        translation: string;
        translationId: string;
        avatarId?: string | null;
        languageCode: string;
    }>;
};

export type BatchPayloadFragment = {
    __typename: 'BatchPayload';
    count: number;
};

export type BlockedFragment = {
    __typename: 'Blocked';
    blockedId: string;
    otherId: string;
    createdAt: Date;
};

export type CoinsResultSuccessFragment = {
    __typename: 'CoinsResultSuccess';
    coins: number;
    spentCoins?: number | null;
    increasedCoins?: number | null;
};

export type ComplainTypeFragment = {
    __typename: 'ComplainType';
    complainTypeId: string;
    name: string;
};

export type ConversationFragment = {
    __typename: 'Conversation';
    conversationId: string;
    blind: boolean;
    free: boolean;
    lastMessageId?: string | null;
    lastAction?: Date | null;
    support: boolean;
};

export type ConversationProfileFragment = {
    __typename: 'ConversationProfile';
    conversationProfileId: string;
    conversationId: string;
    picturesSend: number;
    picturesUnread: number;
    messagesSend: number;
    messagesUnread: number;
    pokesSend: number;
    pokesUnread: number;
};

export type ConversationProfileAggregateFragment = {
    __typename: 'ConversationProfileAggregate';
    send: number;
    unread: number;
    freeMessages: number;
    messagesSend: number;
    pokesSend: number;
    giftsSend: number;
    picturesSend: number;
    messagesUnread: number;
    pokesUnread: number;
    giftsUnread: number;
};

export type CostFragment = {
    __typename: 'Cost';
    eyeCatcher?: { __typename: 'CostNode'; cost: number } | null;
    friendship: { __typename: 'CostNode'; cost: number };
    match?: { __typename: 'CostNode'; cost: number } | null;
    message: { __typename: 'MessageCost'; cost: number; length: number };
    poke: { __typename: 'PokeCost'; cost: number; free?: number | null };
    picture?: { __typename: 'CostNode'; cost: number } | null;
};

export type DailySongFragment = {
    __typename: 'DailySong';
    name: string;
    dailySongId: string;
    path: string;
};

export type DeactivatedPushFragment = {
    __typename: 'DeactivatedPush';
    deactivatedPushId: string;
    setting: PushSetting;
};

export type ErrorFragment = {
    __typename: 'Error';
    errorCode: number;
    errorMessage: ErrorCodes;
};

export type FavoriteFragment = {
    __typename: 'Favorite';
    createdAt: Date;
    favoriteId: string;
    otherId: string;
};

export type FlagFragment = {
    __typename: 'Flag';
    flagId: string;
    max?: number | null;
    maxLength: number;
    min?: number | null;
    minLength: number;
    name: string;
    numberStep?: string | null;
    gender: FlagGender;
    regEx?: string | null;
    type: FlagType;
    translations: Array<{
        __typename: 'Translation';
        translationId: string;
        translation: string;
        languageCode: string;
        giftCategoryId?: string | null;
        giftId?: string | null;
        interestCategoryId?: string | null;
        interestId?: string | null;
        translationView: TranslationView;
    }>;
    flagValues: Array<{
        __typename: 'FlagValue';
        flagId: string;
        flagValueId: string;
        translations: Array<{
            __typename: 'Translation';
            translationId: string;
            translation: string;
            languageCode: string;
            giftCategoryId?: string | null;
            giftId?: string | null;
            interestCategoryId?: string | null;
            interestId?: string | null;
            translationView: TranslationView;
        }>;
    }>;
};

export type FlagProfileFragment = {
    __typename: 'Flag';
    flagId: string;
    name: string;
    translations: Array<{
        __typename: 'Translation';
        translationId: string;
        translation: string;
        languageCode: string;
        giftCategoryId?: string | null;
        giftId?: string | null;
        interestCategoryId?: string | null;
        interestId?: string | null;
        translationView: TranslationView;
    }>;
};

export type FlagValueFragment = {
    __typename: 'FlagValue';
    flagId: string;
    flagValueId: string;
    translations: Array<{
        __typename: 'Translation';
        translationId: string;
        translation: string;
        languageCode: string;
        giftCategoryId?: string | null;
        giftId?: string | null;
        interestCategoryId?: string | null;
        interestId?: string | null;
        translationView: TranslationView;
    }>;
};

export type FriendshipFragment = {
    __typename: 'Friendship';
    friendshipId: string;
    otherId: string;
    status: FriendshipStatus;
    updatedAt: Date;
};

export type GeolocationFragment = {
    __typename: 'Geolocation';
    geolocationId: string;
    country: string;
    postcode: string;
    location: string;
    state?: string | null;
    province?: string | null;
    community?: string | null;
    latitude: string;
    longitude: string;
};

export type GiftFragment = {
    __typename: 'Gift';
    giftId: string;
    name: string;
    cost: number;
    path: string;
    translations: Array<{
        __typename: 'Translation';
        translationId: string;
        translation: string;
        languageCode: string;
        giftCategoryId?: string | null;
        giftId?: string | null;
        interestCategoryId?: string | null;
        interestId?: string | null;
        translationView: TranslationView;
    }>;
};

export type GiftCategoryFragment = {
    __typename: 'GiftCategory';
    giftCategoryId: string;
    name: string;
    translations: Array<{
        __typename: 'Translation';
        translationId: string;
        translation: string;
        languageCode: string;
        giftCategoryId?: string | null;
        giftId?: string | null;
        interestCategoryId?: string | null;
        interestId?: string | null;
        translationView: TranslationView;
    }>;
};

export type ImageFragment = {
    __typename: 'Image';
    imageId: string;
    profileId: string;
    path: string;
    main: boolean;
    private: boolean;
};

export type InterestFragment = {
    __typename: 'Interest';
    interestId: string;
    name: string;
    class?: string | null;
    path?: string | null;
    categoryId: string;
    translations: Array<{
        __typename: 'Translation';
        translationId: string;
        translation: string;
        languageCode: string;
        giftCategoryId?: string | null;
        giftId?: string | null;
        interestCategoryId?: string | null;
        interestId?: string | null;
        translationView: TranslationView;
    }>;
};

export type InterestCategoryFragment = {
    __typename: 'InterestCategory';
    interestCategoryId: string;
    name: string;
    translations: Array<{
        __typename: 'Translation';
        translationId: string;
        translation: string;
        languageCode: string;
        giftCategoryId?: string | null;
        giftId?: string | null;
        interestCategoryId?: string | null;
        interestId?: string | null;
        translationView: TranslationView;
    }>;
};

export type LanguageFragment = {
    __typename: 'Language';
    code: string;
    name: string;
};

export type LoginResultSuccessFragment = {
    __typename: 'LoginResultSuccess';
    userId: string;
    token: string;
    role: UserRole;
    coins: number;
};

export type LoginStreakFragment = {
    __typename: 'LoginStreak';
    defaultCoins: number;
    afterCapCoins: number;
    days: Array<{
        __typename: 'LoginStreakDay';
        day: number;
        coins: number;
        description?: string | null;
    }>;
};

export type MatchFragment = {
    __typename: 'Match';
    matchId: string;
    ownerId: string;
    playedAt?: Date | null;
    profileId: string;
    type: MatchType;
    profile: {
        __typename: 'Profile';
        acceptPicture: boolean;
        country: string;
        county: string;
        flirtText: string;
        gender: Gender;
        languageCode: string;
        profileId: string;
        profileName: string;
        searches: Gender;
        shownLocation: string;
        zodiacSign?: string | null;
        age: number;
        premiumStatus: Array<ProfileStatus>;
        images: Array<{
            __typename: 'Image';
            imageId: string;
            profileId: string;
            path: string;
            main: boolean;
            private: boolean;
        }>;
    };
};

export type MatchFilterFragment = {
    __typename: 'MatchFilter';
    matchFilterId: string;
    userId: string;
    updatedAt: Date;
    ageFrom: number;
    ageTo: number;
    radius?: number | null;
};

export type MessageFragment = {
    __typename: 'Message';
    senderId: string;
    text?: string | null;
    updatedAt: Date;
    coins: number;
    createdAt: Date;
    giftId?: string | null;
    messageId: string;
    model: MessageType;
    pictureId?: string | null;
    path?: string | null;
};

export type MyImageFragment = {
    __typename: 'Image';
    verified: boolean;
    userChanged: Date;
    imageId: string;
    profileId: string;
    path: string;
    main: boolean;
    private: boolean;
};

export type MyProfileFragment = {
    __typename: 'MyProfile';
    acceptPicture: boolean;
    country: string;
    county: string;
    flirtText: string;
    gender: Gender;
    languageCode: string;
    profileId: string;
    profileName: string;
    searches: Gender;
    shownLocation: string;
    themeName?: string | null;
    birthDate?: string | null;
    completed: boolean;
    zodiacSign?: string | null;
    premiumStatus: Array<ProfileStatus>;
};

export type NotificationFragment = {
    __typename: 'Notification';
    notificationId: string;
    target?: string | null;
    type: NotificationType;
    read: boolean;
    updatedAt: Date;
    createdAt: Date;
};

export type OfferFragment = {
    __typename: 'Offer';
    offerId: string;
    name: string;
    cost: number;
    coins: number;
    bonus: number;
    extra: string;
    currency: string;
    providerName: string;
    periodUnit: PeriodUnitOffer;
    profileStatus?: ProfileStatus | null;
    statusPeriod: number;
};

export type OptionPollFragment = {
    __typename: 'OptionPoll';
    optionPollId: string;
    name: string;
    text: string;
    position: number;
    languageCode: string;
};

export type OptionPollAnswerFragment = {
    __typename: 'OptionPollAnswer';
    optionPollAnswerId: string;
    text: string;
    optionPollId: string;
    languageCode: string;
    votes: string;
    path?: string | null;
};

export type PictureFragment = {
    __typename: 'Picture';
    pictureId: string;
    path: string;
    ownerId: string;
    verified: boolean;
    hidden: boolean;
};

export type PredefinedMessageFragment = {
    __typename: 'PredefinedMessage';
    path?: string | null;
    predefinedMessageId: string;
    translations: Array<{
        __typename: 'Translation';
        translation: string;
        translationId: string;
        predefinedMessageId?: string | null;
        languageCode: string;
    }>;
};

export type ProfileFragment = {
    __typename: 'Profile';
    acceptPicture: boolean;
    country: string;
    county: string;
    flirtText: string;
    gender: Gender;
    languageCode: string;
    profileId: string;
    profileName: string;
    searches: Gender;
    shownLocation: string;
    zodiacSign?: string | null;
    age: number;
    premiumStatus: Array<ProfileStatus>;
};

export type ProfileFlagFragment = {
    __typename: 'ProfileFlag';
    profileFlagId: string;
    flagValueId?: string | null;
    value?: string | null;
    flag: {
        __typename: 'Flag';
        flagId: string;
        name: string;
        translations: Array<{
            __typename: 'Translation';
            translationId: string;
            translation: string;
            languageCode: string;
            giftCategoryId?: string | null;
            giftId?: string | null;
            interestCategoryId?: string | null;
            interestId?: string | null;
            translationView: TranslationView;
        }>;
    };
    flagValue?: {
        __typename: 'FlagValue';
        flagId: string;
        flagValueId: string;
        translations: Array<{
            __typename: 'Translation';
            translationId: string;
            translation: string;
            languageCode: string;
            giftCategoryId?: string | null;
            giftId?: string | null;
            interestCategoryId?: string | null;
            interestId?: string | null;
            translationView: TranslationView;
        }>;
    } | null;
};

export type ProfileInterestFragment = {
    __typename: 'ProfileInterest';
    profileInterestId: string;
    profileId: string;
    interestName: string;
};

export type ProfileOptionPollFragment = {
    __typename: 'ProfileOptionPoll';
    optionPollAnswerId: string;
    optionPollId: string;
    profileId: string;
    profileOptionPollId: string;
    createdAt: Date;
};

export type ProfileTextFragment = {
    __typename: 'ProfileText';
    profileTextId: string;
    translations: Array<{
        __typename: 'Translation';
        translationId: string;
        profileTextId?: string | null;
        languageCode: string;
        translation: string;
    }>;
};

export type ProviderFragment = {
    __typename: 'Provider';
    providerId: string;
    name: string;
    logo: string;
    title: string;
    description?: string | null;
    currency: string;
};

export type RegisterResultSuccessFragment = {
    __typename: 'RegisterResultSuccess';
    userId: string;
    token: string;
    role: UserRole;
    coins: number;
};

export type ResultErrorFragment = {
    __typename: 'ResultError';
    errors: Array<{
        __typename: 'Error';
        errorCode: number;
        errorMessage: ErrorCodes;
    }>;
};

export type ResultSuccessFragment = {
    __typename: 'ResultSuccess';
    success: boolean;
};

export type SupportMessageFragment = {
    __typename: 'SupportMessage';
    supportMessageId: string;
    text: string;
    createdAt: Date;
    updatedAt: Date;
    sender: SupportMessageSender;
    supportTicketId: string;
    read: boolean;
};

export type SupportTicketFragment = {
    __typename: 'SupportTicket';
    supportTicketId: string;
    status: SupportTicketStatus;
    createdAt: Date;
    updatedAt: Date;
    category: SupportCategory;
    ticketNumber: number;
};

export type ThemeFragment = { __typename: 'Theme'; name: string };

export type ThemeImageFragment = {
    __typename: 'ThemeImage';
    label: string;
    path: string;
    themeImageId: string;
    themeName: string;
};

export type TransactionFragment = {
    __typename: 'Transaction';
    transactionId: string;
    coins: number;
    currency: string;
    providerName: string;
    cost: number;
};

export type TransactionResultPendingFragment = {
    __typename: 'TransactionResultPending';
    redirectUrl?: string | null;
    transactionId: string;
    extTransactionId?: string | null;
    provider?: string | null;
    offer?: {
        __typename: 'Offer';
        offerId: string;
        name: string;
        cost: number;
        coins: number;
        bonus: number;
        extra: string;
        currency: string;
        providerName: string;
        periodUnit: PeriodUnitOffer;
        profileStatus?: ProfileStatus | null;
        statusPeriod: number;
    } | null;
    data?: {
        __typename: 'BankData';
        iban: string;
        beneficiary: string;
        bic: string;
        bank?: string | null;
    } | null;
};

export type TransactionResultSuccessFragment = {
    __typename: 'TransactionResultSuccess';
    transactionId: string;
    coins: {
        __typename: 'CoinsResultSuccess';
        coins: number;
        increasedCoins?: number | null;
    };
};

export type TranslationFragment = {
    __typename: 'Translation';
    translationId: string;
    translation: string;
    languageCode: string;
    giftCategoryId?: string | null;
    giftId?: string | null;
    interestCategoryId?: string | null;
    interestId?: string | null;
    translationView: TranslationView;
};

export type UserFragment = {
    __typename: 'User';
    role: string;
    username: string;
    sendMarketingEmail: boolean;
    sendTransactionalEmail: boolean;
    sendSMS: boolean;
    imageCompleted: boolean;
    flirtTextCompleted: boolean;
    profileFlagsCompleted: boolean;
    emailValidated: boolean;
    mobileNumberValidated: boolean;
    email?: string | null;
    mobileNumber?: string | null;
    deleteToken: string;
    loginStreak: number;
};

export type UserComplainFragment = {
    __typename: 'UserComplain';
    complainTypeName: string;
    name?: string | null;
    targetId: string;
    text?: string | null;
};

export type VisitFragment = {
    __typename: 'Visit';
    visitId: string;
    otherId: string;
    createdAt: Date;
};

export type DisableAllPushMutationVariables = Exact<{ [key: string]: never }>;

export type DisableAllPushMutation = {
    __typename: 'Mutation';
    activateAllDeactivatedPush: { __typename: 'BatchPayload'; count: number };
};

export type AddFavoriteMutationVariables = Exact<{
    a_Data: ProfileWhereUniqueInput;
}>;

export type AddFavoriteMutation = {
    __typename: 'Mutation';
    addFavorite?: {
        __typename: 'Favorite';
        createdAt: Date;
        favoriteId: string;
        otherId: string;
    } | null;
};

export type AddFriendMutationVariables = Exact<{
    a_Data: ProfileWhereUniqueInput;
}>;

export type AddFriendMutation = {
    __typename: 'Mutation';
    addFriendship?:
        | {
              __typename: 'CoinsResultSuccess';
              coins: number;
              spentCoins?: number | null;
              increasedCoins?: number | null;
          }
        | {
              __typename: 'ResultError';
              errors: Array<{
                  __typename: 'Error';
                  errorCode: number;
                  errorMessage: ErrorCodes;
              }>;
          }
        | null;
};

export type BlockProfileMutationVariables = Exact<{
    b_Data: BlockProfileInput;
}>;

export type BlockProfileMutation = {
    __typename: 'Mutation';
    blockProfile?: { __typename: 'ResultSuccess'; success: boolean } | null;
};

export type BuyMoreMatchesMutationVariables = Exact<{ [key: string]: never }>;

export type BuyMoreMatchesMutation = {
    __typename: 'Mutation';
    buyMoreMatches:
        | { __typename: 'Error'; errorCode: number; errorMessage: ErrorCodes }
        | {
              __typename: 'NextMatchResultSuccess';
              matches: Array<{
                  __typename: 'Match';
                  matchId: string;
                  ownerId: string;
                  playedAt?: Date | null;
                  profileId: string;
                  type: MatchType;
                  profile: {
                      __typename: 'Profile';
                      acceptPicture: boolean;
                      country: string;
                      county: string;
                      flirtText: string;
                      gender: Gender;
                      languageCode: string;
                      profileId: string;
                      profileName: string;
                      searches: Gender;
                      shownLocation: string;
                      zodiacSign?: string | null;
                      age: number;
                      premiumStatus: Array<ProfileStatus>;
                      images: Array<{
                          __typename: 'Image';
                          imageId: string;
                          profileId: string;
                          path: string;
                          main: boolean;
                          private: boolean;
                      }>;
                  };
              }>;
          };
};

export type ChangePushMutationVariables = Exact<{
    c_Data: DeactivatedPushChangeInput;
}>;

export type ChangePushMutation = {
    __typename: 'Mutation';
    changeOneDeactivatedPush: {
        __typename: 'DeactivatedPush';
        deactivatedPushId: string;
        setting: PushSetting;
    };
};

export type ChangeFriendshipMutationVariables = Exact<{
    c_Data: ChangeFriendshipInput;
}>;

export type ChangeFriendshipMutation = {
    __typename: 'Mutation';
    changeStatusFriendship?: {
        __typename: 'ResultSuccess';
        success: boolean;
    } | null;
};

export type ContactSupportMutationVariables = Exact<{
    c_Data: ContactSupportInput;
}>;

export type ContactSupportMutation = {
    __typename: 'Mutation';
    contactSupport: { __typename: 'ResultSuccess'; success: boolean };
};

export type TransactionMutationVariables = Exact<{
    t_Data: TransactionInput;
}>;

export type TransactionMutation = {
    __typename: 'Mutation';
    createTransaction?:
        | {
              __typename: 'ResultError';
              errors: Array<{
                  __typename: 'Error';
                  errorCode: number;
                  errorMessage: ErrorCodes;
              }>;
          }
        | {
              __typename: 'TransactionResultPending';
              redirectUrl?: string | null;
              transactionId: string;
              extTransactionId?: string | null;
              provider?: string | null;
              offer?: {
                  __typename: 'Offer';
                  offerId: string;
                  name: string;
                  cost: number;
                  coins: number;
                  bonus: number;
                  extra: string;
                  currency: string;
                  providerName: string;
                  periodUnit: PeriodUnitOffer;
                  profileStatus?: ProfileStatus | null;
                  statusPeriod: number;
              } | null;
              data?: {
                  __typename: 'BankData';
                  iban: string;
                  beneficiary: string;
                  bic: string;
                  bank?: string | null;
              } | null;
          }
        | {
              __typename: 'TransactionResultSuccess';
              transactionId: string;
              coins: {
                  __typename: 'CoinsResultSuccess';
                  coins: number;
                  increasedCoins?: number | null;
              };
          }
        | null;
};

export type DeleteAccountMutationVariables = Exact<{
    d_Data: DeleteAccountInput;
}>;

export type DeleteAccountMutation = {
    __typename: 'Mutation';
    deleteAccount:
        | {
              __typename: 'ResultError';
              errors: Array<{
                  __typename: 'Error';
                  errorCode: number;
                  errorMessage: ErrorCodes;
              }>;
          }
        | { __typename: 'ResultSuccess'; success: boolean };
};

export type EnableAllPushMutationVariables = Exact<{ [key: string]: never }>;

export type EnableAllPushMutation = {
    __typename: 'Mutation';
    deleteAllDeactivatedPush: { __typename: 'BatchPayload'; count: number };
};

export type DeleteGalleryImageMutationVariables = Exact<{
    d_Data: DeleteGalleryImageInput;
}>;

export type DeleteGalleryImageMutation = {
    __typename: 'Mutation';
    deleteGalleryImage?: {
        __typename: 'ResultSuccess';
        success: boolean;
    } | null;
};

export type FacebookLoginMutationVariables = Exact<{
    f_Data: SocialLoginInput;
    withF_DeactivatedPushes?: InputMaybe<Scalars['Boolean']['input']>;
    withF_Cost?: InputMaybe<Scalars['Boolean']['input']>;
    withF_FreePokes?: InputMaybe<Scalars['Boolean']['input']>;
    withF_M_Age?: InputMaybe<Scalars['Boolean']['input']>;
    withF_M_FurtherInformation?: InputMaybe<Scalars['Boolean']['input']>;
    withF_M_Images?: InputMaybe<Scalars['Boolean']['input']>;
    withF_M_Avatar?: InputMaybe<Scalars['Boolean']['input']>;
    withF_M_User?: InputMaybe<Scalars['Boolean']['input']>;
    withF_M_ProfileInterests?: InputMaybe<Scalars['Boolean']['input']>;
    withF_M_P_Interest?: InputMaybe<Scalars['Boolean']['input']>;
    withF_User?: InputMaybe<Scalars['Boolean']['input']>;
    f_M_ImagesCursor?: InputMaybe<ImageWhereUniqueInput>;
    f_M_ImagesDistinct?: InputMaybe<ImageDistinctFieldEnum>;
    f_M_ImagesOrderBy?: InputMaybe<
        Array<InputMaybe<ImageOrderByInput>> | InputMaybe<ImageOrderByInput>
    >;
    f_M_ImagesSkip?: InputMaybe<Scalars['Int']['input']>;
    f_M_ImagesTake?: InputMaybe<Scalars['Int']['input']>;
    f_M_ImagesWhere?: InputMaybe<ImageWhereInput>;
    withF_M_Theme?: InputMaybe<Scalars['Boolean']['input']>;
    withF_M_T_Images?: InputMaybe<Scalars['Boolean']['input']>;
    f_M_T_ImagesWhere?: InputMaybe<ThemeImageWhereInput>;
    withF_M_ProfileFlags?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type FacebookLoginMutation = {
    __typename: 'Mutation';
    facebookLogin:
        | {
              __typename: 'LoginResultSuccess';
              freePokes?: number;
              userId: string;
              token: string;
              role: UserRole;
              coins: number;
              deactivatedPushes?: Array<{
                  __typename: 'DeactivatedPush';
                  deactivatedPushId: string;
                  setting: PushSetting;
              } | null>;
              myProfile: {
                  __typename: 'MyProfile';
                  defaultText?: string | null;
                  avatarPath?: string | null;
                  age?: number;
                  furtherInformation?: string | null;
                  acceptPicture: boolean;
                  country: string;
                  county: string;
                  flirtText: string;
                  gender: Gender;
                  languageCode: string;
                  profileId: string;
                  profileName: string;
                  searches: Gender;
                  shownLocation: string;
                  themeName?: string | null;
                  birthDate?: string | null;
                  completed: boolean;
                  zodiacSign?: string | null;
                  premiumStatus: Array<ProfileStatus>;
                  profileFlags?: Array<{
                      __typename: 'ProfileFlag';
                      profileFlagId: string;
                      flagValueId?: string | null;
                      value?: string | null;
                      flag: {
                          __typename: 'Flag';
                          flagId: string;
                          name: string;
                          translations: Array<{
                              __typename: 'Translation';
                              translationId: string;
                              translation: string;
                              languageCode: string;
                              giftCategoryId?: string | null;
                              giftId?: string | null;
                              interestCategoryId?: string | null;
                              interestId?: string | null;
                              translationView: TranslationView;
                          }>;
                      };
                      flagValue?: {
                          __typename: 'FlagValue';
                          flagId: string;
                          flagValueId: string;
                          translations: Array<{
                              __typename: 'Translation';
                              translationId: string;
                              translation: string;
                              languageCode: string;
                              giftCategoryId?: string | null;
                              giftId?: string | null;
                              interestCategoryId?: string | null;
                              interestId?: string | null;
                              translationView: TranslationView;
                          }>;
                      } | null;
                  }>;
                  avatar?: {
                      __typename: 'Avatar';
                      avatarId: string;
                      name?: string | null;
                      path: string;
                      translations: Array<{
                          __typename: 'Translation';
                          translation: string;
                          translationId: string;
                          avatarId?: string | null;
                          languageCode: string;
                      }>;
                  } | null;
                  user?: {
                      __typename: 'User';
                      role: string;
                      username: string;
                      sendMarketingEmail: boolean;
                      sendTransactionalEmail: boolean;
                      sendSMS: boolean;
                      imageCompleted: boolean;
                      flirtTextCompleted: boolean;
                      profileFlagsCompleted: boolean;
                      emailValidated: boolean;
                      mobileNumberValidated: boolean;
                      email?: string | null;
                      mobileNumber?: string | null;
                      deleteToken: string;
                      loginStreak: number;
                  };
                  images?: Array<{
                      __typename: 'Image';
                      verified: boolean;
                      userChanged: Date;
                      imageId: string;
                      profileId: string;
                      path: string;
                      main: boolean;
                      private: boolean;
                  }>;
                  profileInterests?: Array<{
                      __typename: 'ProfileInterest';
                      profileInterestId: string;
                      profileId: string;
                      interestName: string;
                      interest?: {
                          __typename: 'Interest';
                          interestId: string;
                          name: string;
                          class?: string | null;
                          path?: string | null;
                          categoryId: string;
                          translations: Array<{
                              __typename: 'Translation';
                              translationId: string;
                              translation: string;
                              languageCode: string;
                              giftCategoryId?: string | null;
                              giftId?: string | null;
                              interestCategoryId?: string | null;
                              interestId?: string | null;
                              translationView: TranslationView;
                          }>;
                      };
                  }>;
                  theme?: {
                      __typename: 'Theme';
                      name: string;
                      images?: Array<{
                          __typename: 'ThemeImage';
                          label: string;
                          path: string;
                          themeImageId: string;
                          themeName: string;
                      }>;
                  } | null;
              };
              cost?: {
                  __typename: 'Cost';
                  eyeCatcher?: { __typename: 'CostNode'; cost: number } | null;
                  friendship: { __typename: 'CostNode'; cost: number };
                  match?: { __typename: 'CostNode'; cost: number } | null;
                  message: {
                      __typename: 'MessageCost';
                      cost: number;
                      length: number;
                  };
                  poke: {
                      __typename: 'PokeCost';
                      cost: number;
                      free?: number | null;
                  };
                  picture?: { __typename: 'CostNode'; cost: number } | null;
              };
              user?: {
                  __typename: 'User';
                  role: string;
                  username: string;
                  sendMarketingEmail: boolean;
                  sendTransactionalEmail: boolean;
                  sendSMS: boolean;
                  imageCompleted: boolean;
                  flirtTextCompleted: boolean;
                  profileFlagsCompleted: boolean;
                  emailValidated: boolean;
                  mobileNumberValidated: boolean;
                  email?: string | null;
                  mobileNumber?: string | null;
                  deleteToken: string;
                  loginStreak: number;
              };
          }
        | {
              __typename: 'ResultError';
              errors: Array<{
                  __typename: 'Error';
                  errorCode: number;
                  errorMessage: ErrorCodes;
              }>;
          };
};

export type ForgottenPasswordMutationVariables = Exact<{
    f_Email?: InputMaybe<Scalars['String']['input']>;
    f_Username?: InputMaybe<Scalars['String']['input']>;
}>;

export type ForgottenPasswordMutation = {
    __typename: 'Mutation';
    forgottenPassword: { __typename: 'ResultSuccess'; success: boolean };
};

export type GoogleLoginMutationVariables = Exact<{
    g_Data: SocialLoginInput;
    withG_DeactivatedPushes?: InputMaybe<Scalars['Boolean']['input']>;
    withG_Cost?: InputMaybe<Scalars['Boolean']['input']>;
    withG_FreePokes?: InputMaybe<Scalars['Boolean']['input']>;
    withG_M_Age?: InputMaybe<Scalars['Boolean']['input']>;
    withG_M_FurtherInformation?: InputMaybe<Scalars['Boolean']['input']>;
    withG_M_Images?: InputMaybe<Scalars['Boolean']['input']>;
    withG_M_Avatar?: InputMaybe<Scalars['Boolean']['input']>;
    withG_M_User?: InputMaybe<Scalars['Boolean']['input']>;
    withG_M_ProfileInterests?: InputMaybe<Scalars['Boolean']['input']>;
    withG_M_P_Interest?: InputMaybe<Scalars['Boolean']['input']>;
    withG_User?: InputMaybe<Scalars['Boolean']['input']>;
    g_M_ImagesCursor?: InputMaybe<ImageWhereUniqueInput>;
    g_M_ImagesDistinct?: InputMaybe<ImageDistinctFieldEnum>;
    g_M_ImagesOrderBy?: InputMaybe<
        Array<InputMaybe<ImageOrderByInput>> | InputMaybe<ImageOrderByInput>
    >;
    g_M_ImagesSkip?: InputMaybe<Scalars['Int']['input']>;
    g_M_ImagesTake?: InputMaybe<Scalars['Int']['input']>;
    g_M_ImagesWhere?: InputMaybe<ImageWhereInput>;
    withG_M_Theme?: InputMaybe<Scalars['Boolean']['input']>;
    withG_M_T_Images?: InputMaybe<Scalars['Boolean']['input']>;
    g_M_T_ImagesWhere?: InputMaybe<ThemeImageWhereInput>;
    withG_M_ProfileFlags?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type GoogleLoginMutation = {
    __typename: 'Mutation';
    googleLogin:
        | {
              __typename: 'LoginResultSuccess';
              freePokes?: number;
              userId: string;
              token: string;
              role: UserRole;
              coins: number;
              deactivatedPushes?: Array<{
                  __typename: 'DeactivatedPush';
                  deactivatedPushId: string;
                  setting: PushSetting;
              } | null>;
              myProfile: {
                  __typename: 'MyProfile';
                  defaultText?: string | null;
                  avatarPath?: string | null;
                  age?: number;
                  furtherInformation?: string | null;
                  acceptPicture: boolean;
                  country: string;
                  county: string;
                  flirtText: string;
                  gender: Gender;
                  languageCode: string;
                  profileId: string;
                  profileName: string;
                  searches: Gender;
                  shownLocation: string;
                  themeName?: string | null;
                  birthDate?: string | null;
                  completed: boolean;
                  zodiacSign?: string | null;
                  premiumStatus: Array<ProfileStatus>;
                  profileFlags?: Array<{
                      __typename: 'ProfileFlag';
                      profileFlagId: string;
                      flagValueId?: string | null;
                      value?: string | null;
                      flag: {
                          __typename: 'Flag';
                          flagId: string;
                          name: string;
                          translations: Array<{
                              __typename: 'Translation';
                              translationId: string;
                              translation: string;
                              languageCode: string;
                              giftCategoryId?: string | null;
                              giftId?: string | null;
                              interestCategoryId?: string | null;
                              interestId?: string | null;
                              translationView: TranslationView;
                          }>;
                      };
                      flagValue?: {
                          __typename: 'FlagValue';
                          flagId: string;
                          flagValueId: string;
                          translations: Array<{
                              __typename: 'Translation';
                              translationId: string;
                              translation: string;
                              languageCode: string;
                              giftCategoryId?: string | null;
                              giftId?: string | null;
                              interestCategoryId?: string | null;
                              interestId?: string | null;
                              translationView: TranslationView;
                          }>;
                      } | null;
                  }>;
                  avatar?: {
                      __typename: 'Avatar';
                      avatarId: string;
                      name?: string | null;
                      path: string;
                      translations: Array<{
                          __typename: 'Translation';
                          translation: string;
                          translationId: string;
                          avatarId?: string | null;
                          languageCode: string;
                      }>;
                  } | null;
                  user?: {
                      __typename: 'User';
                      role: string;
                      username: string;
                      sendMarketingEmail: boolean;
                      sendTransactionalEmail: boolean;
                      sendSMS: boolean;
                      imageCompleted: boolean;
                      flirtTextCompleted: boolean;
                      profileFlagsCompleted: boolean;
                      emailValidated: boolean;
                      mobileNumberValidated: boolean;
                      email?: string | null;
                      mobileNumber?: string | null;
                      deleteToken: string;
                      loginStreak: number;
                  };
                  images?: Array<{
                      __typename: 'Image';
                      verified: boolean;
                      userChanged: Date;
                      imageId: string;
                      profileId: string;
                      path: string;
                      main: boolean;
                      private: boolean;
                  }>;
                  profileInterests?: Array<{
                      __typename: 'ProfileInterest';
                      profileInterestId: string;
                      profileId: string;
                      interestName: string;
                      interest?: {
                          __typename: 'Interest';
                          interestId: string;
                          name: string;
                          class?: string | null;
                          path?: string | null;
                          categoryId: string;
                          translations: Array<{
                              __typename: 'Translation';
                              translationId: string;
                              translation: string;
                              languageCode: string;
                              giftCategoryId?: string | null;
                              giftId?: string | null;
                              interestCategoryId?: string | null;
                              interestId?: string | null;
                              translationView: TranslationView;
                          }>;
                      };
                  }>;
                  theme?: {
                      __typename: 'Theme';
                      name: string;
                      images?: Array<{
                          __typename: 'ThemeImage';
                          label: string;
                          path: string;
                          themeImageId: string;
                          themeName: string;
                      }>;
                  } | null;
              };
              cost?: {
                  __typename: 'Cost';
                  eyeCatcher?: { __typename: 'CostNode'; cost: number } | null;
                  friendship: { __typename: 'CostNode'; cost: number };
                  match?: { __typename: 'CostNode'; cost: number } | null;
                  message: {
                      __typename: 'MessageCost';
                      cost: number;
                      length: number;
                  };
                  poke: {
                      __typename: 'PokeCost';
                      cost: number;
                      free?: number | null;
                  };
                  picture?: { __typename: 'CostNode'; cost: number } | null;
              };
              user?: {
                  __typename: 'User';
                  role: string;
                  username: string;
                  sendMarketingEmail: boolean;
                  sendTransactionalEmail: boolean;
                  sendSMS: boolean;
                  imageCompleted: boolean;
                  flirtTextCompleted: boolean;
                  profileFlagsCompleted: boolean;
                  emailValidated: boolean;
                  mobileNumberValidated: boolean;
                  email?: string | null;
                  mobileNumber?: string | null;
                  deleteToken: string;
                  loginStreak: number;
              };
          }
        | {
              __typename: 'ResultError';
              errors: Array<{
                  __typename: 'Error';
                  errorCode: number;
                  errorMessage: ErrorCodes;
              }>;
          };
};

export type HideConversationMutationVariables = Exact<{
    r_ConversationId: Scalars['String']['input'];
    r_Hide?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type HideConversationMutation = {
    __typename: 'Mutation';
    hideConversation?: { __typename: 'ResultSuccess'; success: boolean } | null;
};

export type LikeProfileMutationVariables = Exact<{
    l_Data: LikeProfileInput;
}>;

export type LikeProfileMutation = {
    __typename: 'Mutation';
    likeProfile?: { __typename: 'ResultSuccess'; success: boolean } | null;
};

export type LoginMutationVariables = Exact<{
    l_Username: Scalars['String']['input'];
    l_Password: Scalars['String']['input'];
    l_Timezone?: InputMaybe<Scalars['String']['input']>;
    withL_DeactivatedPushes?: InputMaybe<Scalars['Boolean']['input']>;
    withL_Cost?: InputMaybe<Scalars['Boolean']['input']>;
    withL_FreePokes?: InputMaybe<Scalars['Boolean']['input']>;
    withL_M_Age?: InputMaybe<Scalars['Boolean']['input']>;
    withL_M_FurtherInformation?: InputMaybe<Scalars['Boolean']['input']>;
    withL_M_Images?: InputMaybe<Scalars['Boolean']['input']>;
    withL_User?: InputMaybe<Scalars['Boolean']['input']>;
    l_M_ImagesCursor?: InputMaybe<ImageWhereUniqueInput>;
    l_M_ImagesDistinct?: InputMaybe<ImageDistinctFieldEnum>;
    l_M_ImagesOrderBy?: InputMaybe<
        Array<InputMaybe<ImageOrderByInput>> | InputMaybe<ImageOrderByInput>
    >;
    l_M_ImagesSkip?: InputMaybe<Scalars['Int']['input']>;
    l_M_ImagesTake?: InputMaybe<Scalars['Int']['input']>;
    l_M_ImagesWhere?: InputMaybe<ImageWhereInput>;
    withL_M_Theme?: InputMaybe<Scalars['Boolean']['input']>;
    withL_M_T_Images?: InputMaybe<Scalars['Boolean']['input']>;
    l_M_T_ImagesWhere?: InputMaybe<ThemeImageWhereInput>;
    withL_M_ProfileInterests?: InputMaybe<Scalars['Boolean']['input']>;
    withL_M_P_Interest?: InputMaybe<Scalars['Boolean']['input']>;
    withL_M_User?: InputMaybe<Scalars['Boolean']['input']>;
    withL_M_Avatar?: InputMaybe<Scalars['Boolean']['input']>;
    withL_M_ProfileFlags?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type LoginMutation = {
    __typename: 'Mutation';
    login:
        | {
              __typename: 'LoginResultSuccess';
              freePokes?: number;
              userId: string;
              token: string;
              role: UserRole;
              coins: number;
              deactivatedPushes?: Array<{
                  __typename: 'DeactivatedPush';
                  deactivatedPushId: string;
                  setting: PushSetting;
              } | null>;
              myProfile: {
                  __typename: 'MyProfile';
                  defaultText?: string | null;
                  avatarPath?: string | null;
                  age?: number;
                  furtherInformation?: string | null;
                  acceptPicture: boolean;
                  country: string;
                  county: string;
                  flirtText: string;
                  gender: Gender;
                  languageCode: string;
                  profileId: string;
                  profileName: string;
                  searches: Gender;
                  shownLocation: string;
                  themeName?: string | null;
                  birthDate?: string | null;
                  completed: boolean;
                  zodiacSign?: string | null;
                  premiumStatus: Array<ProfileStatus>;
                  avatar?: {
                      __typename: 'Avatar';
                      avatarId: string;
                      name?: string | null;
                      path: string;
                      translations: Array<{
                          __typename: 'Translation';
                          translation: string;
                          translationId: string;
                          avatarId?: string | null;
                          languageCode: string;
                      }>;
                  } | null;
                  user?: {
                      __typename: 'User';
                      role: string;
                      username: string;
                      sendMarketingEmail: boolean;
                      sendTransactionalEmail: boolean;
                      sendSMS: boolean;
                      imageCompleted: boolean;
                      flirtTextCompleted: boolean;
                      profileFlagsCompleted: boolean;
                      emailValidated: boolean;
                      mobileNumberValidated: boolean;
                      email?: string | null;
                      mobileNumber?: string | null;
                      deleteToken: string;
                      loginStreak: number;
                  };
                  images?: Array<{
                      __typename: 'Image';
                      verified: boolean;
                      userChanged: Date;
                      imageId: string;
                      profileId: string;
                      path: string;
                      main: boolean;
                      private: boolean;
                  }>;
                  profileInterests?: Array<{
                      __typename: 'ProfileInterest';
                      profileInterestId: string;
                      profileId: string;
                      interestName: string;
                      interest?: {
                          __typename: 'Interest';
                          interestId: string;
                          name: string;
                          class?: string | null;
                          path?: string | null;
                          categoryId: string;
                          translations: Array<{
                              __typename: 'Translation';
                              translationId: string;
                              translation: string;
                              languageCode: string;
                              giftCategoryId?: string | null;
                              giftId?: string | null;
                              interestCategoryId?: string | null;
                              interestId?: string | null;
                              translationView: TranslationView;
                          }>;
                      };
                  }>;
                  profileFlags?: Array<{
                      __typename: 'ProfileFlag';
                      profileFlagId: string;
                      flagValueId?: string | null;
                      value?: string | null;
                      flag: {
                          __typename: 'Flag';
                          flagId: string;
                          name: string;
                          translations: Array<{
                              __typename: 'Translation';
                              translationId: string;
                              translation: string;
                              languageCode: string;
                              giftCategoryId?: string | null;
                              giftId?: string | null;
                              interestCategoryId?: string | null;
                              interestId?: string | null;
                              translationView: TranslationView;
                          }>;
                      };
                      flagValue?: {
                          __typename: 'FlagValue';
                          flagId: string;
                          flagValueId: string;
                          translations: Array<{
                              __typename: 'Translation';
                              translationId: string;
                              translation: string;
                              languageCode: string;
                              giftCategoryId?: string | null;
                              giftId?: string | null;
                              interestCategoryId?: string | null;
                              interestId?: string | null;
                              translationView: TranslationView;
                          }>;
                      } | null;
                  }>;
                  theme?: {
                      __typename: 'Theme';
                      name: string;
                      images?: Array<{
                          __typename: 'ThemeImage';
                          label: string;
                          path: string;
                          themeImageId: string;
                          themeName: string;
                      }>;
                  } | null;
              };
              cost?: {
                  __typename: 'Cost';
                  eyeCatcher?: { __typename: 'CostNode'; cost: number } | null;
                  friendship: { __typename: 'CostNode'; cost: number };
                  match?: { __typename: 'CostNode'; cost: number } | null;
                  message: {
                      __typename: 'MessageCost';
                      cost: number;
                      length: number;
                  };
                  poke: {
                      __typename: 'PokeCost';
                      cost: number;
                      free?: number | null;
                  };
                  picture?: { __typename: 'CostNode'; cost: number } | null;
              };
              user?: {
                  __typename: 'User';
                  role: string;
                  username: string;
                  sendMarketingEmail: boolean;
                  sendTransactionalEmail: boolean;
                  sendSMS: boolean;
                  imageCompleted: boolean;
                  flirtTextCompleted: boolean;
                  profileFlagsCompleted: boolean;
                  emailValidated: boolean;
                  mobileNumberValidated: boolean;
                  email?: string | null;
                  mobileNumber?: string | null;
                  deleteToken: string;
                  loginStreak: number;
              };
          }
        | {
              __typename: 'ResultError';
              errors: Array<{
                  __typename: 'Error';
                  errorCode: number;
                  errorMessage: ErrorCodes;
              }>;
          };
};

export type LoginByMd5MutationVariables = Exact<{
    l_Data: LoginMd5Input;
    withL_DeactivatedPushes?: InputMaybe<Scalars['Boolean']['input']>;
    withL_Cost?: InputMaybe<Scalars['Boolean']['input']>;
    withL_FreePokes?: InputMaybe<Scalars['Boolean']['input']>;
    withL_M_Age?: InputMaybe<Scalars['Boolean']['input']>;
    withL_M_FurtherInformation?: InputMaybe<Scalars['Boolean']['input']>;
    withL_M_Images?: InputMaybe<Scalars['Boolean']['input']>;
    withL_User?: InputMaybe<Scalars['Boolean']['input']>;
    l_M_ImagesCursor?: InputMaybe<ImageWhereUniqueInput>;
    l_M_ImagesDistinct?: InputMaybe<ImageDistinctFieldEnum>;
    l_M_ImagesOrderBy?: InputMaybe<
        Array<InputMaybe<ImageOrderByInput>> | InputMaybe<ImageOrderByInput>
    >;
    l_M_ImagesSkip?: InputMaybe<Scalars['Int']['input']>;
    l_M_ImagesTake?: InputMaybe<Scalars['Int']['input']>;
    l_M_ImagesWhere?: InputMaybe<ImageWhereInput>;
    withL_M_Theme?: InputMaybe<Scalars['Boolean']['input']>;
    withL_M_T_Images?: InputMaybe<Scalars['Boolean']['input']>;
    l_M_T_ImagesWhere?: InputMaybe<ThemeImageWhereInput>;
    withL_M_ProfileInterests?: InputMaybe<Scalars['Boolean']['input']>;
    withL_M_P_Interest?: InputMaybe<Scalars['Boolean']['input']>;
    withL_M_User?: InputMaybe<Scalars['Boolean']['input']>;
    withL_M_Avatar?: InputMaybe<Scalars['Boolean']['input']>;
    withL_M_ProfileFlags?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type LoginByMd5Mutation = {
    __typename: 'Mutation';
    loginByMD5:
        | {
              __typename: 'LoginResultSuccess';
              freePokes?: number;
              userId: string;
              token: string;
              role: UserRole;
              coins: number;
              deactivatedPushes?: Array<{
                  __typename: 'DeactivatedPush';
                  deactivatedPushId: string;
                  setting: PushSetting;
              } | null>;
              myProfile: {
                  __typename: 'MyProfile';
                  defaultText?: string | null;
                  avatarPath?: string | null;
                  age?: number;
                  furtherInformation?: string | null;
                  acceptPicture: boolean;
                  country: string;
                  county: string;
                  flirtText: string;
                  gender: Gender;
                  languageCode: string;
                  profileId: string;
                  profileName: string;
                  searches: Gender;
                  shownLocation: string;
                  themeName?: string | null;
                  birthDate?: string | null;
                  completed: boolean;
                  zodiacSign?: string | null;
                  premiumStatus: Array<ProfileStatus>;
                  profileFlags?: Array<{
                      __typename: 'ProfileFlag';
                      profileFlagId: string;
                      flagValueId?: string | null;
                      value?: string | null;
                      flag: {
                          __typename: 'Flag';
                          flagId: string;
                          name: string;
                          translations: Array<{
                              __typename: 'Translation';
                              translationId: string;
                              translation: string;
                              languageCode: string;
                              giftCategoryId?: string | null;
                              giftId?: string | null;
                              interestCategoryId?: string | null;
                              interestId?: string | null;
                              translationView: TranslationView;
                          }>;
                      };
                      flagValue?: {
                          __typename: 'FlagValue';
                          flagId: string;
                          flagValueId: string;
                          translations: Array<{
                              __typename: 'Translation';
                              translationId: string;
                              translation: string;
                              languageCode: string;
                              giftCategoryId?: string | null;
                              giftId?: string | null;
                              interestCategoryId?: string | null;
                              interestId?: string | null;
                              translationView: TranslationView;
                          }>;
                      } | null;
                  }>;
                  avatar?: {
                      __typename: 'Avatar';
                      avatarId: string;
                      name?: string | null;
                      path: string;
                      translations: Array<{
                          __typename: 'Translation';
                          translation: string;
                          translationId: string;
                          avatarId?: string | null;
                          languageCode: string;
                      }>;
                  } | null;
                  user?: {
                      __typename: 'User';
                      role: string;
                      username: string;
                      sendMarketingEmail: boolean;
                      sendTransactionalEmail: boolean;
                      sendSMS: boolean;
                      imageCompleted: boolean;
                      flirtTextCompleted: boolean;
                      profileFlagsCompleted: boolean;
                      emailValidated: boolean;
                      mobileNumberValidated: boolean;
                      email?: string | null;
                      mobileNumber?: string | null;
                      deleteToken: string;
                      loginStreak: number;
                  };
                  images?: Array<{
                      __typename: 'Image';
                      verified: boolean;
                      userChanged: Date;
                      imageId: string;
                      profileId: string;
                      path: string;
                      main: boolean;
                      private: boolean;
                  }>;
                  profileInterests?: Array<{
                      __typename: 'ProfileInterest';
                      profileInterestId: string;
                      profileId: string;
                      interestName: string;
                      interest?: {
                          __typename: 'Interest';
                          interestId: string;
                          name: string;
                          class?: string | null;
                          path?: string | null;
                          categoryId: string;
                          translations: Array<{
                              __typename: 'Translation';
                              translationId: string;
                              translation: string;
                              languageCode: string;
                              giftCategoryId?: string | null;
                              giftId?: string | null;
                              interestCategoryId?: string | null;
                              interestId?: string | null;
                              translationView: TranslationView;
                          }>;
                      };
                  }>;
                  theme?: {
                      __typename: 'Theme';
                      name: string;
                      images?: Array<{
                          __typename: 'ThemeImage';
                          label: string;
                          path: string;
                          themeImageId: string;
                          themeName: string;
                      }>;
                  } | null;
              };
              cost?: {
                  __typename: 'Cost';
                  eyeCatcher?: { __typename: 'CostNode'; cost: number } | null;
                  friendship: { __typename: 'CostNode'; cost: number };
                  match?: { __typename: 'CostNode'; cost: number } | null;
                  message: {
                      __typename: 'MessageCost';
                      cost: number;
                      length: number;
                  };
                  poke: {
                      __typename: 'PokeCost';
                      cost: number;
                      free?: number | null;
                  };
                  picture?: { __typename: 'CostNode'; cost: number } | null;
              };
              user?: {
                  __typename: 'User';
                  role: string;
                  username: string;
                  sendMarketingEmail: boolean;
                  sendTransactionalEmail: boolean;
                  sendSMS: boolean;
                  imageCompleted: boolean;
                  flirtTextCompleted: boolean;
                  profileFlagsCompleted: boolean;
                  emailValidated: boolean;
                  mobileNumberValidated: boolean;
                  email?: string | null;
                  mobileNumber?: string | null;
                  deleteToken: string;
                  loginStreak: number;
              };
          }
        | {
              __typename: 'ResultError';
              errors: Array<{
                  __typename: 'Error';
                  errorCode: number;
                  errorMessage: ErrorCodes;
              }>;
          };
};

export type LoginByTokenMutationVariables = Exact<{
    l_Token: Scalars['String']['input'];
    l_Timezone: Scalars['String']['input'];
    withL_DeactivatedPushes?: InputMaybe<Scalars['Boolean']['input']>;
    withL_Cost?: InputMaybe<Scalars['Boolean']['input']>;
    withL_FreePokes?: InputMaybe<Scalars['Boolean']['input']>;
    withL_M_Age?: InputMaybe<Scalars['Boolean']['input']>;
    withL_M_FurtherInformation?: InputMaybe<Scalars['Boolean']['input']>;
    withL_M_Images?: InputMaybe<Scalars['Boolean']['input']>;
    withL_User?: InputMaybe<Scalars['Boolean']['input']>;
    l_M_ImagesCursor?: InputMaybe<ImageWhereUniqueInput>;
    l_M_ImagesDistinct?: InputMaybe<ImageDistinctFieldEnum>;
    l_M_ImagesOrderBy?: InputMaybe<
        Array<InputMaybe<ImageOrderByInput>> | InputMaybe<ImageOrderByInput>
    >;
    l_M_ImagesSkip?: InputMaybe<Scalars['Int']['input']>;
    l_M_ImagesTake?: InputMaybe<Scalars['Int']['input']>;
    l_M_ImagesWhere?: InputMaybe<ImageWhereInput>;
    withL_M_Theme?: InputMaybe<Scalars['Boolean']['input']>;
    withL_M_T_Images?: InputMaybe<Scalars['Boolean']['input']>;
    l_M_T_ImagesWhere?: InputMaybe<ThemeImageWhereInput>;
    withL_M_ProfileInterests?: InputMaybe<Scalars['Boolean']['input']>;
    withL_M_P_Interest?: InputMaybe<Scalars['Boolean']['input']>;
    withL_M_User?: InputMaybe<Scalars['Boolean']['input']>;
    withL_M_Avatar?: InputMaybe<Scalars['Boolean']['input']>;
    withL_M_ProfileFlags?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type LoginByTokenMutation = {
    __typename: 'Mutation';
    loginByToken:
        | {
              __typename: 'LoginResultSuccess';
              freePokes?: number;
              userId: string;
              token: string;
              role: UserRole;
              coins: number;
              deactivatedPushes?: Array<{
                  __typename: 'DeactivatedPush';
                  deactivatedPushId: string;
                  setting: PushSetting;
              } | null>;
              myProfile: {
                  __typename: 'MyProfile';
                  defaultText?: string | null;
                  avatarPath?: string | null;
                  age?: number;
                  furtherInformation?: string | null;
                  acceptPicture: boolean;
                  country: string;
                  county: string;
                  flirtText: string;
                  gender: Gender;
                  languageCode: string;
                  profileId: string;
                  profileName: string;
                  searches: Gender;
                  shownLocation: string;
                  themeName?: string | null;
                  birthDate?: string | null;
                  completed: boolean;
                  zodiacSign?: string | null;
                  premiumStatus: Array<ProfileStatus>;
                  profileFlags?: Array<{
                      __typename: 'ProfileFlag';
                      profileFlagId: string;
                      flagValueId?: string | null;
                      value?: string | null;
                      flag: {
                          __typename: 'Flag';
                          flagId: string;
                          name: string;
                          translations: Array<{
                              __typename: 'Translation';
                              translationId: string;
                              translation: string;
                              languageCode: string;
                              giftCategoryId?: string | null;
                              giftId?: string | null;
                              interestCategoryId?: string | null;
                              interestId?: string | null;
                              translationView: TranslationView;
                          }>;
                      };
                      flagValue?: {
                          __typename: 'FlagValue';
                          flagId: string;
                          flagValueId: string;
                          translations: Array<{
                              __typename: 'Translation';
                              translationId: string;
                              translation: string;
                              languageCode: string;
                              giftCategoryId?: string | null;
                              giftId?: string | null;
                              interestCategoryId?: string | null;
                              interestId?: string | null;
                              translationView: TranslationView;
                          }>;
                      } | null;
                  }>;
                  avatar?: {
                      __typename: 'Avatar';
                      avatarId: string;
                      name?: string | null;
                      path: string;
                      translations: Array<{
                          __typename: 'Translation';
                          translation: string;
                          translationId: string;
                          avatarId?: string | null;
                          languageCode: string;
                      }>;
                  } | null;
                  user?: {
                      __typename: 'User';
                      role: string;
                      username: string;
                      sendMarketingEmail: boolean;
                      sendTransactionalEmail: boolean;
                      sendSMS: boolean;
                      imageCompleted: boolean;
                      flirtTextCompleted: boolean;
                      profileFlagsCompleted: boolean;
                      emailValidated: boolean;
                      mobileNumberValidated: boolean;
                      email?: string | null;
                      mobileNumber?: string | null;
                      deleteToken: string;
                      loginStreak: number;
                  };
                  images?: Array<{
                      __typename: 'Image';
                      verified: boolean;
                      userChanged: Date;
                      imageId: string;
                      profileId: string;
                      path: string;
                      main: boolean;
                      private: boolean;
                  }>;
                  profileInterests?: Array<{
                      __typename: 'ProfileInterest';
                      profileInterestId: string;
                      profileId: string;
                      interestName: string;
                      interest?: {
                          __typename: 'Interest';
                          interestId: string;
                          name: string;
                          class?: string | null;
                          path?: string | null;
                          categoryId: string;
                          translations: Array<{
                              __typename: 'Translation';
                              translationId: string;
                              translation: string;
                              languageCode: string;
                              giftCategoryId?: string | null;
                              giftId?: string | null;
                              interestCategoryId?: string | null;
                              interestId?: string | null;
                              translationView: TranslationView;
                          }>;
                      };
                  }>;
                  theme?: {
                      __typename: 'Theme';
                      name: string;
                      images?: Array<{
                          __typename: 'ThemeImage';
                          label: string;
                          path: string;
                          themeImageId: string;
                          themeName: string;
                      }>;
                  } | null;
              };
              cost?: {
                  __typename: 'Cost';
                  eyeCatcher?: { __typename: 'CostNode'; cost: number } | null;
                  friendship: { __typename: 'CostNode'; cost: number };
                  match?: { __typename: 'CostNode'; cost: number } | null;
                  message: {
                      __typename: 'MessageCost';
                      cost: number;
                      length: number;
                  };
                  poke: {
                      __typename: 'PokeCost';
                      cost: number;
                      free?: number | null;
                  };
                  picture?: { __typename: 'CostNode'; cost: number } | null;
              };
              user?: {
                  __typename: 'User';
                  role: string;
                  username: string;
                  sendMarketingEmail: boolean;
                  sendTransactionalEmail: boolean;
                  sendSMS: boolean;
                  imageCompleted: boolean;
                  flirtTextCompleted: boolean;
                  profileFlagsCompleted: boolean;
                  emailValidated: boolean;
                  mobileNumberValidated: boolean;
                  email?: string | null;
                  mobileNumber?: string | null;
                  deleteToken: string;
                  loginStreak: number;
              };
          }
        | {
              __typename: 'ResultError';
              errors: Array<{
                  __typename: 'Error';
                  errorCode: number;
                  errorMessage: ErrorCodes;
              }>;
          };
};

export type ChangeMatchFilterMutationVariables = Exact<{
    c_Data: MatchFilterUpdateInput;
}>;

export type ChangeMatchFilterMutation = {
    __typename: 'Mutation';
    changeMatchFilter:
        | { __typename: 'Error'; errorCode: number; errorMessage: ErrorCodes }
        | {
              __typename: 'MatchFilter';
              matchFilterId: string;
              userId: string;
              updatedAt: Date;
              ageFrom: number;
              ageTo: number;
              radius?: number | null;
          };
};

export type MobileNumberValidationMutationVariables = Exact<{
    m_Data: MobileNumberValidationInput;
}>;

export type MobileNumberValidationMutation = {
    __typename: 'Mutation';
    mobileNumberValidation:
        | { __typename: 'Error' }
        | {
              __typename: 'ResultError';
              errors: Array<{
                  __typename: 'Error';
                  errorCode: number;
                  errorMessage: ErrorCodes;
              }>;
          }
        | { __typename: 'ResultSuccess'; success: boolean };
};

export type OptionPollAnswerMutationVariables = Exact<{
    o_Data: OptionPollAnswerInput;
}>;

export type OptionPollAnswerMutation = {
    __typename: 'Mutation';
    optionPollAnswer?: {
        __typename: 'ProfileOptionPoll';
        optionPollAnswerId: string;
        optionPollId: string;
        profileId: string;
        profileOptionPollId: string;
        createdAt: Date;
    } | null;
};

export type ReadConversationMutationVariables = Exact<{
    r_ConversationId: Scalars['String']['input'];
}>;

export type ReadConversationMutation = {
    __typename: 'Mutation';
    readConversation?: { __typename: 'ResultSuccess'; success: boolean } | null;
};

export type ReadNotificationsMutationVariables = Exact<{
    r_Where: Array<NotificationWhereUniqueInput> | NotificationWhereUniqueInput;
}>;

export type ReadNotificationsMutation = {
    __typename: 'Mutation';
    readManyNotification?: { __typename: 'BatchPayload'; count: number } | null;
};

export type ReadSupportMessageMutationVariables = Exact<{
    r_Where: SupportMessageWhereUniqueInput;
    withR_SupportTicket?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type ReadSupportMessageMutation = {
    __typename: 'Mutation';
    readSupportMessage: {
        __typename: 'SupportMessage';
        supportMessageId: string;
        text: string;
        createdAt: Date;
        updatedAt: Date;
        sender: SupportMessageSender;
        supportTicketId: string;
        read: boolean;
        supportTicket?: {
            __typename: 'SupportTicket';
            supportTicketId: string;
            status: SupportTicketStatus;
            createdAt: Date;
            updatedAt: Date;
            category: SupportCategory;
            ticketNumber: number;
        };
    };
};

export type RedeemCouponMutationVariables = Exact<{
    r_Data: CouponWhereUniqueInput;
}>;

export type RedeemCouponMutation = {
    __typename: 'Mutation';
    redeemCoupon?:
        | {
              __typename: 'CoinsResultSuccess';
              coins: number;
              spentCoins?: number | null;
              increasedCoins?: number | null;
          }
        | {
              __typename: 'ResultError';
              errors: Array<{
                  __typename: 'Error';
                  errorCode: number;
                  errorMessage: ErrorCodes;
              }>;
          }
        | null;
};

export type RegisterMutationVariables = Exact<{
    r_Data: RegisterInput;
    withR_M_Age?: InputMaybe<Scalars['Boolean']['input']>;
    withR_M_FurtherInformation?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type RegisterMutation = {
    __typename: 'Mutation';
    register:
        | {
              __typename: 'RegisterResultSuccess';
              userId: string;
              token: string;
              role: UserRole;
              coins: number;
              myProfile: {
                  __typename: 'MyProfile';
                  age?: number;
                  furtherInformation?: string | null;
                  acceptPicture: boolean;
                  country: string;
                  county: string;
                  flirtText: string;
                  gender: Gender;
                  languageCode: string;
                  profileId: string;
                  profileName: string;
                  searches: Gender;
                  shownLocation: string;
                  themeName?: string | null;
                  birthDate?: string | null;
                  completed: boolean;
                  zodiacSign?: string | null;
                  premiumStatus: Array<ProfileStatus>;
              };
          }
        | {
              __typename: 'ResultError';
              errors: Array<{
                  __typename: 'Error';
                  errorCode: number;
                  errorMessage: ErrorCodes;
              }>;
          };
};

export type RemoveFavoriteMutationVariables = Exact<{
    r_Data: FavoriteWhereUniqueInput;
}>;

export type RemoveFavoriteMutation = {
    __typename: 'Mutation';
    removeFavorite?: {
        __typename: 'Favorite';
        createdAt: Date;
        favoriteId: string;
        otherId: string;
    } | null;
};

export type RemoveFriendMutationVariables = Exact<{
    r_Data: RemoveFriendshipInput;
}>;

export type RemoveFriendMutation = {
    __typename: 'Mutation';
    removeFriendship?: { __typename: 'ResultSuccess'; success: boolean } | null;
};

export type ResetPasswordMutationVariables = Exact<{
    r_Data: ResetPasswordInput;
}>;

export type ResetPasswordMutation = {
    __typename: 'Mutation';
    resetPassword:
        | {
              __typename: 'ResultError';
              errors: Array<{
                  __typename: 'Error';
                  errorCode: number;
                  errorMessage: ErrorCodes;
              }>;
          }
        | { __typename: 'ResultSuccess'; success: boolean };
};

export type SendGiftMutationVariables = Exact<{
    s_Data: GiftInput;
}>;

export type SendGiftMutation = {
    __typename: 'Mutation';
    sendGift?:
        | {
              __typename: 'CoinsResultSuccess';
              coins: number;
              spentCoins?: number | null;
              increasedCoins?: number | null;
          }
        | {
              __typename: 'ResultError';
              errors: Array<{
                  __typename: 'Error';
                  errorCode: number;
                  errorMessage: ErrorCodes;
              }>;
          }
        | null;
};

export type SendMatchMutationVariables = Exact<{
    s_Where: MatchWhereUniqueInput;
    s_Type: MatchType;
}>;

export type SendMatchMutation = {
    __typename: 'Mutation';
    sendMatch:
        | { __typename: 'Error'; errorCode: number; errorMessage: ErrorCodes }
        | {
              __typename: 'Match';
              matchId: string;
              ownerId: string;
              playedAt?: Date | null;
              profileId: string;
              type: MatchType;
              profile: {
                  __typename: 'Profile';
                  acceptPicture: boolean;
                  country: string;
                  county: string;
                  flirtText: string;
                  gender: Gender;
                  languageCode: string;
                  profileId: string;
                  profileName: string;
                  searches: Gender;
                  shownLocation: string;
                  zodiacSign?: string | null;
                  age: number;
                  premiumStatus: Array<ProfileStatus>;
                  images: Array<{
                      __typename: 'Image';
                      imageId: string;
                      profileId: string;
                      path: string;
                      main: boolean;
                      private: boolean;
                  }>;
              };
          };
};

export type SendMessageMutationVariables = Exact<{
    s_Data: MessageInput;
}>;

export type SendMessageMutation = {
    __typename: 'Mutation';
    sendMessage?:
        | {
              __typename: 'CoinsResultSuccess';
              coins: number;
              spentCoins?: number | null;
              increasedCoins?: number | null;
          }
        | {
              __typename: 'ResultError';
              errors: Array<{
                  __typename: 'Error';
                  errorCode: number;
                  errorMessage: ErrorCodes;
              }>;
          }
        | null;
};

export type SendPictureMutationVariables = Exact<{
    s_Data: PictureInput;
}>;

export type SendPictureMutation = {
    __typename: 'Mutation';
    sendPicture?:
        | {
              __typename: 'CoinsResultSuccess';
              coins: number;
              spentCoins?: number | null;
              increasedCoins?: number | null;
          }
        | {
              __typename: 'ResultError';
              errors: Array<{
                  __typename: 'Error';
                  errorCode: number;
                  errorMessage: ErrorCodes;
              }>;
          }
        | null;
};

export type SendPokeMutationVariables = Exact<{
    s_Data: PokeInput;
}>;

export type SendPokeMutation = {
    __typename: 'Mutation';
    sendPoke?:
        | {
              __typename: 'CoinsResultSuccess';
              coins: number;
              spentCoins?: number | null;
              increasedCoins?: number | null;
          }
        | {
              __typename: 'ResultError';
              errors: Array<{
                  __typename: 'Error';
                  errorCode: number;
                  errorMessage: ErrorCodes;
              }>;
          }
        | null;
};

export type SendPredefinedMessageMutationVariables = Exact<{
    s_Data: PredefinedMessageInput;
}>;

export type SendPredefinedMessageMutation = {
    __typename: 'Mutation';
    sendPredefinedMessage:
        | {
              __typename: 'CoinsResultSuccess';
              coins: number;
              spentCoins?: number | null;
              increasedCoins?: number | null;
          }
        | {
              __typename: 'ResultError';
              errors: Array<{
                  __typename: 'Error';
                  errorCode: number;
                  errorMessage: ErrorCodes;
              }>;
          };
};

export type SendSupportMessageMutationVariables = Exact<{
    s_Data: SupportMessageCreateInput;
    withS_SupportTicket?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type SendSupportMessageMutation = {
    __typename: 'Mutation';
    sendSupportMessage: {
        __typename: 'SupportMessage';
        supportMessageId: string;
        text: string;
        createdAt: Date;
        updatedAt: Date;
        sender: SupportMessageSender;
        supportTicketId: string;
        read: boolean;
        supportTicket?: {
            __typename: 'SupportTicket';
            supportTicketId: string;
            status: SupportTicketStatus;
            createdAt: Date;
            updatedAt: Date;
            category: SupportCategory;
            ticketNumber: number;
        };
    };
};

export type UnblockProfileMutationVariables = Exact<{
    u_Data: MyBlockedWhereUniqueInput;
}>;

export type UnblockProfileMutation = {
    __typename: 'Mutation';
    unblockProfile?: { __typename: 'ResultSuccess'; success: boolean } | null;
};

export type UpdateEmailMutationVariables = Exact<{
    u_Data: ValidateEmailInput;
}>;

export type UpdateEmailMutation = {
    __typename: 'Mutation';
    updateEmail:
        | {
              __typename: 'ResultError';
              errors: Array<{
                  __typename: 'Error';
                  errorCode: number;
                  errorMessage: ErrorCodes;
              }>;
          }
        | { __typename: 'ValidateResultSuccess'; success?: boolean | null };
};

export type UpdateGalleryImageMutationVariables = Exact<{
    u_Data: UpdateGalleryImageInput;
}>;

export type UpdateGalleryImageMutation = {
    __typename: 'Mutation';
    updateGalleryImage?: {
        __typename: 'ResultSuccess';
        success: boolean;
    } | null;
};

export type UpdateMobileNumberMutationVariables = Exact<{
    u_Data: ValidateMobileNumberInput;
}>;

export type UpdateMobileNumberMutation = {
    __typename: 'Mutation';
    updateMobileNumber:
        | {
              __typename: 'ResultError';
              errors: Array<{
                  __typename: 'Error';
                  errorCode: number;
                  errorMessage: ErrorCodes;
              }>;
          }
        | { __typename: 'ValidateResultSuccess'; success?: boolean | null };
};

export type UpdateMyProfileMutationVariables = Exact<{
    u_Data: UpdateMyProfileInput;
    withU_M_User?: InputMaybe<Scalars['Boolean']['input']>;
    withU_M_Age?: InputMaybe<Scalars['Boolean']['input']>;
    withU_M_FurtherInformation?: InputMaybe<Scalars['Boolean']['input']>;
    withU_M_Images?: InputMaybe<Scalars['Boolean']['input']>;
    withU_M_ProfileFlags?: InputMaybe<Scalars['Boolean']['input']>;
    withU_M_ProfileInterests?: InputMaybe<Scalars['Boolean']['input']>;
    withU_M_P_Interest?: InputMaybe<Scalars['Boolean']['input']>;
    u_M_ImagesCursor?: InputMaybe<ImageWhereUniqueInput>;
    u_M_ImagesDistinct?: InputMaybe<ImageDistinctFieldEnum>;
    u_M_ImagesOrderBy?: InputMaybe<
        Array<InputMaybe<ImageOrderByInput>> | InputMaybe<ImageOrderByInput>
    >;
    u_M_ImagesSkip?: InputMaybe<Scalars['Int']['input']>;
    u_M_ImagesTake?: InputMaybe<Scalars['Int']['input']>;
    u_M_ImagesWhere?: InputMaybe<ImageWhereInput>;
    withU_M_Theme?: InputMaybe<Scalars['Boolean']['input']>;
    withU_M_T_Images?: InputMaybe<Scalars['Boolean']['input']>;
    u_M_T_ImagesWhere?: InputMaybe<ThemeImageWhereInput>;
    withU_M_Avatar?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type UpdateMyProfileMutation = {
    __typename: 'Mutation';
    updateMyProfile?:
        | {
              __typename: 'MyProfile';
              defaultText?: string | null;
              avatarPath?: string | null;
              age?: number;
              furtherInformation?: string | null;
              acceptPicture: boolean;
              country: string;
              county: string;
              flirtText: string;
              gender: Gender;
              languageCode: string;
              profileId: string;
              profileName: string;
              searches: Gender;
              shownLocation: string;
              themeName?: string | null;
              birthDate?: string | null;
              completed: boolean;
              zodiacSign?: string | null;
              premiumStatus: Array<ProfileStatus>;
              avatar?: {
                  __typename: 'Avatar';
                  avatarId: string;
                  name?: string | null;
                  path: string;
                  translations: Array<{
                      __typename: 'Translation';
                      translation: string;
                      translationId: string;
                      avatarId?: string | null;
                      languageCode: string;
                  }>;
              } | null;
              user?: {
                  __typename: 'User';
                  role: string;
                  username: string;
                  sendMarketingEmail: boolean;
                  sendTransactionalEmail: boolean;
                  sendSMS: boolean;
                  imageCompleted: boolean;
                  flirtTextCompleted: boolean;
                  profileFlagsCompleted: boolean;
                  emailValidated: boolean;
                  mobileNumberValidated: boolean;
                  email?: string | null;
                  mobileNumber?: string | null;
                  deleteToken: string;
                  loginStreak: number;
              };
              images?: Array<{
                  __typename: 'Image';
                  verified: boolean;
                  userChanged: Date;
                  imageId: string;
                  profileId: string;
                  path: string;
                  main: boolean;
                  private: boolean;
              }>;
              profileFlags?: Array<{
                  __typename: 'ProfileFlag';
                  profileFlagId: string;
                  flagValueId?: string | null;
                  value?: string | null;
                  flag: {
                      __typename: 'Flag';
                      flagId: string;
                      name: string;
                      translations: Array<{
                          __typename: 'Translation';
                          translationId: string;
                          translation: string;
                          languageCode: string;
                          giftCategoryId?: string | null;
                          giftId?: string | null;
                          interestCategoryId?: string | null;
                          interestId?: string | null;
                          translationView: TranslationView;
                      }>;
                  };
                  flagValue?: {
                      __typename: 'FlagValue';
                      flagId: string;
                      flagValueId: string;
                      translations: Array<{
                          __typename: 'Translation';
                          translationId: string;
                          translation: string;
                          languageCode: string;
                          giftCategoryId?: string | null;
                          giftId?: string | null;
                          interestCategoryId?: string | null;
                          interestId?: string | null;
                          translationView: TranslationView;
                      }>;
                  } | null;
              }>;
              profileInterests?: Array<{
                  __typename: 'ProfileInterest';
                  profileInterestId: string;
                  profileId: string;
                  interestName: string;
                  interest?: {
                      __typename: 'Interest';
                      interestId: string;
                      name: string;
                      class?: string | null;
                      path?: string | null;
                      categoryId: string;
                      translations: Array<{
                          __typename: 'Translation';
                          translationId: string;
                          translation: string;
                          languageCode: string;
                          giftCategoryId?: string | null;
                          giftId?: string | null;
                          interestCategoryId?: string | null;
                          interestId?: string | null;
                          translationView: TranslationView;
                      }>;
                  };
              }>;
              theme?: {
                  __typename: 'Theme';
                  name: string;
                  images?: Array<{
                      __typename: 'ThemeImage';
                      label: string;
                      path: string;
                      themeImageId: string;
                      themeName: string;
                  }>;
              } | null;
          }
        | {
              __typename: 'ResultError';
              errors: Array<{
                  __typename: 'Error';
                  errorCode: number;
                  errorMessage: ErrorCodes;
              }>;
          }
        | null;
};

export type UpdatePictureMutationVariables = Exact<{
    u_Data: PictureUpdateInput;
    u_Where: PictureWhereUniqueInput;
}>;

export type UpdatePictureMutation = {
    __typename: 'Mutation';
    updatePicture:
        | { __typename: 'Error'; errorCode: number; errorMessage: ErrorCodes }
        | {
              __typename: 'Picture';
              pictureId: string;
              path: string;
              ownerId: string;
              verified: boolean;
              hidden: boolean;
          };
};

export type UpdateProfileImageMutationVariables = Exact<{
    u_Data: UpdateProfileImageInput;
}>;

export type UpdateProfileImageMutation = {
    __typename: 'Mutation';
    updateProfileImage?: {
        __typename: 'ResultSuccess';
        success: boolean;
    } | null;
};

export type UpdateUserMutationVariables = Exact<{
    u_Data: UserUpdateInput;
}>;

export type UpdateUserMutation = {
    __typename: 'Mutation';
    updateOneUser: {
        __typename: 'User';
        role: string;
        username: string;
        sendMarketingEmail: boolean;
        sendTransactionalEmail: boolean;
        sendSMS: boolean;
        imageCompleted: boolean;
        flirtTextCompleted: boolean;
        profileFlagsCompleted: boolean;
        emailValidated: boolean;
        mobileNumberValidated: boolean;
        email?: string | null;
        mobileNumber?: string | null;
        deleteToken: string;
        loginStreak: number;
    };
};

export type UploadImageMutationVariables = Exact<{
    u_Data: UploadGalleryImageInput;
}>;

export type UploadImageMutation = {
    __typename: 'Mutation';
    uploadGalleryImage?: {
        __typename: 'Image';
        imageId: string;
        profileId: string;
        path: string;
        main: boolean;
        private: boolean;
    } | null;
};

export type UploadPictureMutationVariables = Exact<{
    u_Data: UploadPictureInput;
}>;

export type UploadPictureMutation = {
    __typename: 'Mutation';
    uploadPicture:
        | { __typename: 'Error'; errorCode: number; errorMessage: ErrorCodes }
        | {
              __typename: 'Picture';
              pictureId: string;
              path: string;
              ownerId: string;
              verified: boolean;
              hidden: boolean;
          };
};

export type UserComplainMutationVariables = Exact<{
    u_Data: UserComplainCreateInput;
}>;

export type UserComplainMutation = {
    __typename: 'Mutation';
    createOneUserComplain: {
        __typename: 'UserComplain';
        complainTypeName: string;
        name?: string | null;
        targetId: string;
        text?: string | null;
    };
};

export type EmailMutationVariables = Exact<{
    e_Data: ValidateEmailInput;
}>;

export type EmailMutation = {
    __typename: 'Mutation';
    validateEmail:
        | {
              __typename: 'ResultError';
              errors: Array<{
                  __typename: 'Error';
                  errorCode: number;
                  errorMessage: ErrorCodes;
              }>;
          }
        | { __typename: 'ValidateResultSuccess'; success?: boolean | null };
};

export type ValidateMobileNumberMutationVariables = Exact<{
    v_Data: ValidateMobileNumberInput;
}>;

export type ValidateMobileNumberMutation = {
    __typename: 'Mutation';
    validateMobileNumber:
        | {
              __typename: 'ResultError';
              errors: Array<{
                  __typename: 'Error';
                  errorCode: number;
                  errorMessage: ErrorCodes;
              }>;
          }
        | { __typename: 'ValidateResultSuccess'; success?: boolean | null };
};

export type UsernameMutationVariables = Exact<{
    u_Data: ValidateUsernameInput;
}>;

export type UsernameMutation = {
    __typename: 'Mutation';
    validateUsername:
        | {
              __typename: 'ResultError';
              errors: Array<{
                  __typename: 'Error';
                  errorCode: number;
                  errorMessage: ErrorCodes;
              }>;
          }
        | { __typename: 'ValidateResultSuccess'; success?: boolean | null };
};

export type VisitProfileMutationVariables = Exact<{
    v_Data: ProfileWhereUniqueInput;
    withV_Other?: InputMaybe<Scalars['Boolean']['input']>;
    v_O_ImagesWhere?: InputMaybe<ImageWhereInput>;
    v_O_ImagesOrderBy?: InputMaybe<
        Array<InputMaybe<ImageOrderByInput>> | InputMaybe<ImageOrderByInput>
    >;
    v_O_ImagesCursor?: InputMaybe<ImageWhereUniqueInput>;
    v_O_ImagesTake?: InputMaybe<Scalars['Int']['input']>;
    v_O_ImagesSkip?: InputMaybe<Scalars['Int']['input']>;
    v_O_ImagesDistinct?: InputMaybe<ImageDistinctFieldEnum>;
    withV_O_Images?: InputMaybe<Scalars['Boolean']['input']>;
    withV_O_Age?: InputMaybe<Scalars['Boolean']['input']>;
    withV_O_ProfileFlags?: InputMaybe<Scalars['Boolean']['input']>;
    withV_O_ProfileInterests?: InputMaybe<Scalars['Boolean']['input']>;
    withV_O_P_Interest?: InputMaybe<Scalars['Boolean']['input']>;
    withV_O_Blocked?: InputMaybe<Scalars['Boolean']['input']>;
    withV_O_Favorite?: InputMaybe<Scalars['Boolean']['input']>;
    withV_O_FriendshipStatus?: InputMaybe<Scalars['Boolean']['input']>;
    withV_O_Avatar?: InputMaybe<Scalars['Boolean']['input']>;
    withV_O_Theme?: InputMaybe<Scalars['Boolean']['input']>;
    withV_O_T_Images?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type VisitProfileMutation = {
    __typename: 'Mutation';
    visitProfile?: {
        __typename: 'VisitProfileResult';
        otherId?: string | null;
        success: boolean;
        other?: {
            __typename: 'Profile';
            defaultText?: string | null;
            avatarPath?: string | null;
            age: number;
            furtherInformation?: string | null;
            blocked?: boolean;
            favorite?: boolean;
            friendshipStatus?: string | null;
            acceptPicture: boolean;
            country: string;
            county: string;
            flirtText: string;
            gender: Gender;
            languageCode: string;
            profileId: string;
            profileName: string;
            searches: Gender;
            shownLocation: string;
            zodiacSign?: string | null;
            premiumStatus: Array<ProfileStatus>;
            theme?: {
                __typename: 'Theme';
                name: string;
                images?: Array<{
                    __typename: 'ThemeImage';
                    label: string;
                    path: string;
                    themeImageId: string;
                    themeName: string;
                }>;
            } | null;
            avatar?: {
                __typename: 'Avatar';
                avatarId: string;
                name?: string | null;
                path: string;
                translations: Array<{
                    __typename: 'Translation';
                    translation: string;
                    translationId: string;
                    avatarId?: string | null;
                    languageCode: string;
                }>;
            } | null;
            images?: Array<{
                __typename: 'Image';
                imageId: string;
                profileId: string;
                path: string;
                main: boolean;
                private: boolean;
            }>;
            profileFlags?: Array<{
                __typename: 'ProfileFlag';
                profileFlagId: string;
                flagValueId?: string | null;
                value?: string | null;
                flag: {
                    __typename: 'Flag';
                    flagId: string;
                    name: string;
                    translations: Array<{
                        __typename: 'Translation';
                        translationId: string;
                        translation: string;
                        languageCode: string;
                        giftCategoryId?: string | null;
                        giftId?: string | null;
                        interestCategoryId?: string | null;
                        interestId?: string | null;
                        translationView: TranslationView;
                    }>;
                };
                flagValue?: {
                    __typename: 'FlagValue';
                    flagId: string;
                    flagValueId: string;
                    translations: Array<{
                        __typename: 'Translation';
                        translationId: string;
                        translation: string;
                        languageCode: string;
                        giftCategoryId?: string | null;
                        giftId?: string | null;
                        interestCategoryId?: string | null;
                        interestId?: string | null;
                        translationView: TranslationView;
                    }>;
                } | null;
            }>;
            profileInterests?: Array<{
                __typename: 'ProfileInterest';
                profileInterestId: string;
                profileId: string;
                interestName: string;
                interest?: {
                    __typename: 'Interest';
                    interestId: string;
                    name: string;
                    class?: string | null;
                    path?: string | null;
                    categoryId: string;
                    translations: Array<{
                        __typename: 'Translation';
                        translationId: string;
                        translation: string;
                        languageCode: string;
                        giftCategoryId?: string | null;
                        giftId?: string | null;
                        interestCategoryId?: string | null;
                        interestId?: string | null;
                        translationView: TranslationView;
                    }>;
                };
            }>;
        } | null;
    } | null;
};

export type AggregateConversationsQueryVariables = Exact<{
    a_Where?: InputMaybe<ConversationProfileWhereInput>;
    a__sum?: InputMaybe<ConversationProfileSumAggregateInputType>;
    withA__Sum?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type AggregateConversationsQuery = {
    __typename: 'Query';
    aggregateConversations?: {
        __typename: 'AggregateConversationsResult';
        _sum?: {
            __typename: 'ConversationProfileAggregate';
            send: number;
            unread: number;
            freeMessages: number;
            messagesSend: number;
            pokesSend: number;
            giftsSend: number;
            picturesSend: number;
            messagesUnread: number;
            pokesUnread: number;
            giftsUnread: number;
        } | null;
    } | null;
};

export type AvatarsQueryVariables = Exact<{
    a_Where?: InputMaybe<AvatarWhereInput>;
}>;

export type AvatarsQuery = {
    __typename: 'Query';
    findManyAvatar: Array<{
        __typename: 'Avatar';
        avatarId: string;
        name?: string | null;
        path: string;
        translations: Array<{
            __typename: 'Translation';
            translation: string;
            translationId: string;
            avatarId?: string | null;
            languageCode: string;
        }>;
    }>;
};

export type BlockedQueryVariables = Exact<{
    b_Where?: InputMaybe<BlockedWhereInput>;
    b_OrderBy?: InputMaybe<BlockedOrderByInput>;
    b_Cursor?: InputMaybe<BlockedWhereUniqueInput>;
    b_Skip?: InputMaybe<Scalars['Int']['input']>;
    b_Take?: InputMaybe<Scalars['Int']['input']>;
    withB_Other?: InputMaybe<Scalars['Boolean']['input']>;
    withB_O_Age?: InputMaybe<Scalars['Boolean']['input']>;
    withB_O_Theme?: InputMaybe<Scalars['Boolean']['input']>;
    b_O_ImagesWhere?: InputMaybe<ImageWhereInput>;
    b_O_ImagesOrderBy?: InputMaybe<
        Array<InputMaybe<ImageOrderByInput>> | InputMaybe<ImageOrderByInput>
    >;
    b_O_ImagesCursor?: InputMaybe<ImageWhereUniqueInput>;
    b_O_ImagesTake?: InputMaybe<Scalars['Int']['input']>;
    b_O_ImagesSkip?: InputMaybe<Scalars['Int']['input']>;
    b_O_ImagesDistinct?: InputMaybe<ImageDistinctFieldEnum>;
    withB_O_Images?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type BlockedQuery = {
    __typename: 'Query';
    findManyBlocked: Array<{
        __typename: 'Blocked';
        blockedId: string;
        otherId: string;
        createdAt: Date;
        other?: {
            __typename: 'Profile';
            age: number;
            acceptPicture: boolean;
            country: string;
            county: string;
            flirtText: string;
            gender: Gender;
            languageCode: string;
            profileId: string;
            profileName: string;
            searches: Gender;
            shownLocation: string;
            zodiacSign?: string | null;
            premiumStatus: Array<ProfileStatus>;
            theme?: { __typename: 'Theme'; name: string } | null;
            images?: Array<{
                __typename: 'Image';
                imageId: string;
                profileId: string;
                path: string;
                main: boolean;
                private: boolean;
            }>;
        };
    }>;
};

export type BlockedCountQueryVariables = Exact<{
    b_Where?: InputMaybe<BlockedWhereInput>;
    b_OrderBy?: InputMaybe<BlockedOrderByInput>;
    b_Cursor?: InputMaybe<BlockedWhereUniqueInput>;
    b_Skip?: InputMaybe<Scalars['Int']['input']>;
    b_Take?: InputMaybe<Scalars['Int']['input']>;
}>;

export type BlockedCountQuery = {
    __typename: 'Query';
    findManyBlockedCount: number;
};

export type CoinsQueryVariables = Exact<{ [key: string]: never }>;

export type CoinsQuery = { __typename: 'Query'; coins?: number | null };

export type ComplainTypesQueryVariables = Exact<{
    withC_Translations?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type ComplainTypesQuery = {
    __typename: 'Query';
    findManyComplainType: Array<{
        __typename: 'ComplainType';
        complainTypeId: string;
        name: string;
        translations?: Array<{
            __typename: 'Translation';
            translationId: string;
            translation: string;
            languageCode: string;
            giftCategoryId?: string | null;
            giftId?: string | null;
            interestCategoryId?: string | null;
            interestId?: string | null;
            translationView: TranslationView;
        }>;
    }>;
};

export type ConfigQueryVariables = Exact<{ [key: string]: never }>;

export type ConfigQuery = {
    __typename: 'Query';
    config: {
        __typename: 'Config';
        profileFlagsBonus: number;
        firstFlirtTextBonus: number;
        firstImageBonus: number;
        activateBonus: number;
        dailyLoginBonus: number;
        mobileNumberBonus: number;
        cost: {
            __typename: 'Cost';
            eyeCatcher?: { __typename: 'CostNode'; cost: number } | null;
            friendship: { __typename: 'CostNode'; cost: number };
            match?: { __typename: 'CostNode'; cost: number } | null;
            message: {
                __typename: 'MessageCost';
                cost: number;
                length: number;
            };
            poke: {
                __typename: 'PokeCost';
                cost: number;
                free?: number | null;
            };
            picture?: { __typename: 'CostNode'; cost: number } | null;
        };
    };
};

export type ConversationQueryVariables = Exact<{
    ownProfileId?: InputMaybe<Scalars['String']['input']>;
    c_Where: ConversationWhereUniqueInput;
    c_MessagesWhere?: InputMaybe<MessageWhereInput>;
    c_MessagesOrderBy?: InputMaybe<MessageOrderByInput>;
    c_MessagesCursor?: InputMaybe<MessageWhereUniqueInput>;
    c_MessagesTake?: InputMaybe<Scalars['Int']['input']>;
    c_MessagesSkip?: InputMaybe<Scalars['Int']['input']>;
    withC_Messages?: InputMaybe<Scalars['Boolean']['input']>;
    withC_M_Sender?: InputMaybe<Scalars['Boolean']['input']>;
    withC_M_Gift?: InputMaybe<Scalars['Boolean']['input']>;
    withC_M_Picture?: InputMaybe<Scalars['Boolean']['input']>;
    withC_Profiles?: InputMaybe<Scalars['Boolean']['input']>;
    withC_OwnProfile?: InputMaybe<Scalars['Boolean']['input']>;
    withC_P_Profile?: InputMaybe<Scalars['Boolean']['input']>;
    withC_MessageCost?: InputMaybe<Scalars['Boolean']['input']>;
    withC_MessageLength?: InputMaybe<Scalars['Boolean']['input']>;
    withC_P_P_Images?: InputMaybe<Scalars['Boolean']['input']>;
    withC_LastMessage?: InputMaybe<Scalars['Boolean']['input']>;
    withC_L_Sender?: InputMaybe<Scalars['Boolean']['input']>;
    withC_L_Gift?: InputMaybe<Scalars['Boolean']['input']>;
    withC_L_Picture?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type ConversationQuery = {
    __typename: 'Query';
    findOneConversation?: {
        __typename: 'Conversation';
        messageCost?: number;
        messageLength?: number;
        conversationId: string;
        blind: boolean;
        free: boolean;
        lastMessageId?: string | null;
        lastAction?: Date | null;
        support: boolean;
        messages?: Array<{
            __typename: 'Message';
            senderId: string;
            text?: string | null;
            updatedAt: Date;
            coins: number;
            createdAt: Date;
            giftId?: string | null;
            messageId: string;
            model: MessageType;
            pictureId?: string | null;
            path?: string | null;
            sender?: {
                __typename: 'Profile';
                acceptPicture: boolean;
                country: string;
                county: string;
                flirtText: string;
                gender: Gender;
                languageCode: string;
                profileId: string;
                profileName: string;
                searches: Gender;
                shownLocation: string;
                zodiacSign?: string | null;
                age: number;
                premiumStatus: Array<ProfileStatus>;
            };
            gift?: {
                __typename: 'Gift';
                giftId: string;
                name: string;
                cost: number;
                path: string;
                translations: Array<{
                    __typename: 'Translation';
                    translationId: string;
                    translation: string;
                    languageCode: string;
                    giftCategoryId?: string | null;
                    giftId?: string | null;
                    interestCategoryId?: string | null;
                    interestId?: string | null;
                    translationView: TranslationView;
                }>;
            } | null;
            picture?: {
                __typename: 'Picture';
                pictureId: string;
                path: string;
                ownerId: string;
                verified: boolean;
                hidden: boolean;
            } | null;
        }>;
        profiles?: Array<{
            __typename: 'ConversationProfile';
            profile?: {
                __typename: 'Profile';
                acceptPicture: boolean;
                country: string;
                county: string;
                flirtText: string;
                gender: Gender;
                languageCode: string;
                profileId: string;
                profileName: string;
                searches: Gender;
                shownLocation: string;
                zodiacSign?: string | null;
                age: number;
                premiumStatus: Array<ProfileStatus>;
                images?: Array<{
                    __typename: 'Image';
                    imageId: string;
                    profileId: string;
                    path: string;
                    main: boolean;
                    private: boolean;
                }>;
            };
        }>;
        ownProfile?: Array<{
            __typename: 'ConversationProfile';
            freeMessages: number;
            messagesUnread: number;
            pokesUnread: number;
            giftsUnread: number;
            picturesUnread: number;
            messagesSend: number;
            picturesSend: number;
            giftsSend: number;
            pokesSend: number;
            conversationProfileId: string;
            conversationId: string;
            profile?: {
                __typename: 'Profile';
                acceptPicture: boolean;
                country: string;
                county: string;
                flirtText: string;
                gender: Gender;
                languageCode: string;
                profileId: string;
                profileName: string;
                searches: Gender;
                shownLocation: string;
                zodiacSign?: string | null;
                age: number;
                premiumStatus: Array<ProfileStatus>;
                images?: Array<{
                    __typename: 'Image';
                    imageId: string;
                    profileId: string;
                    path: string;
                    main: boolean;
                    private: boolean;
                }>;
            };
        }>;
        lastMessage?: {
            __typename: 'Message';
            senderId: string;
            text?: string | null;
            updatedAt: Date;
            coins: number;
            createdAt: Date;
            giftId?: string | null;
            messageId: string;
            model: MessageType;
            pictureId?: string | null;
            path?: string | null;
            sender?: {
                __typename: 'Profile';
                acceptPicture: boolean;
                country: string;
                county: string;
                flirtText: string;
                gender: Gender;
                languageCode: string;
                profileId: string;
                profileName: string;
                searches: Gender;
                shownLocation: string;
                zodiacSign?: string | null;
                age: number;
                premiumStatus: Array<ProfileStatus>;
            };
            gift?: {
                __typename: 'Gift';
                giftId: string;
                name: string;
                cost: number;
                path: string;
                translations: Array<{
                    __typename: 'Translation';
                    translationId: string;
                    translation: string;
                    languageCode: string;
                    giftCategoryId?: string | null;
                    giftId?: string | null;
                    interestCategoryId?: string | null;
                    interestId?: string | null;
                    translationView: TranslationView;
                }>;
            } | null;
            picture?: {
                __typename: 'Picture';
                pictureId: string;
                path: string;
                ownerId: string;
                verified: boolean;
                hidden: boolean;
            } | null;
        } | null;
    } | null;
};

export type ConversationsQueryVariables = Exact<{
    ownProfileId: Scalars['String']['input'];
    c_Take?: InputMaybe<Scalars['Int']['input']>;
    c_Skip?: InputMaybe<Scalars['Int']['input']>;
    c_Cursor?: InputMaybe<ConversationWhereUniqueInput>;
    c_OrderBy?: InputMaybe<ConversationOrderByInput>;
    c_Where?: InputMaybe<ConversationWhereInput>;
    withC_Profiles?: InputMaybe<Scalars['Boolean']['input']>;
    withC_OwnProfile?: InputMaybe<Scalars['Boolean']['input']>;
    withC_P_P_Images?: InputMaybe<Scalars['Boolean']['input']>;
    withC_O_Profile?: InputMaybe<Scalars['Boolean']['input']>;
    withC_LastMessage?: InputMaybe<Scalars['Boolean']['input']>;
    withC_MessageCost?: InputMaybe<Scalars['Boolean']['input']>;
    withC_MessageLength?: InputMaybe<Scalars['Boolean']['input']>;
    withC_L_Gift?: InputMaybe<Scalars['Boolean']['input']>;
    withC_L_Picture?: InputMaybe<Scalars['Boolean']['input']>;
    withC_L_Sender?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type ConversationsQuery = {
    __typename: 'Query';
    findManyConversation: Array<{
        __typename: 'Conversation';
        messageCost?: number;
        messageLength?: number;
        conversationId: string;
        blind: boolean;
        free: boolean;
        lastMessageId?: string | null;
        lastAction?: Date | null;
        support: boolean;
        profiles?: Array<{
            __typename: 'ConversationProfile';
            profile: {
                __typename: 'Profile';
                acceptPicture: boolean;
                country: string;
                county: string;
                flirtText: string;
                gender: Gender;
                languageCode: string;
                profileId: string;
                profileName: string;
                searches: Gender;
                shownLocation: string;
                zodiacSign?: string | null;
                age: number;
                premiumStatus: Array<ProfileStatus>;
                images?: Array<{
                    __typename: 'Image';
                    imageId: string;
                    profileId: string;
                    path: string;
                    main: boolean;
                    private: boolean;
                }>;
            };
        }>;
        ownProfile?: Array<{
            __typename: 'ConversationProfile';
            freeMessages: number;
            messagesUnread: number;
            pokesUnread: number;
            giftsUnread: number;
            picturesUnread: number;
            messagesSend: number;
            picturesSend: number;
            giftsSend: number;
            pokesSend: number;
            conversationProfileId: string;
            conversationId: string;
            profile?: {
                __typename: 'Profile';
                acceptPicture: boolean;
                country: string;
                county: string;
                flirtText: string;
                gender: Gender;
                languageCode: string;
                profileId: string;
                profileName: string;
                searches: Gender;
                shownLocation: string;
                zodiacSign?: string | null;
                age: number;
                premiumStatus: Array<ProfileStatus>;
                images?: Array<{
                    __typename: 'Image';
                    imageId: string;
                    profileId: string;
                    path: string;
                    main: boolean;
                    private: boolean;
                }>;
            };
        }>;
        lastMessage?: {
            __typename: 'Message';
            senderId: string;
            text?: string | null;
            updatedAt: Date;
            coins: number;
            createdAt: Date;
            giftId?: string | null;
            messageId: string;
            model: MessageType;
            pictureId?: string | null;
            path?: string | null;
            gift?: {
                __typename: 'Gift';
                giftId: string;
                name: string;
                cost: number;
                path: string;
                translations: Array<{
                    __typename: 'Translation';
                    translationId: string;
                    translation: string;
                    languageCode: string;
                    giftCategoryId?: string | null;
                    giftId?: string | null;
                    interestCategoryId?: string | null;
                    interestId?: string | null;
                    translationView: TranslationView;
                }>;
            } | null;
            picture?: {
                __typename: 'Picture';
                pictureId: string;
                path: string;
                ownerId: string;
                verified: boolean;
                hidden: boolean;
            } | null;
            sender?: {
                __typename: 'Profile';
                acceptPicture: boolean;
                country: string;
                county: string;
                flirtText: string;
                gender: Gender;
                languageCode: string;
                profileId: string;
                profileName: string;
                searches: Gender;
                shownLocation: string;
                zodiacSign?: string | null;
                age: number;
                premiumStatus: Array<ProfileStatus>;
            };
        } | null;
    }>;
};

export type CostQueryVariables = Exact<{ [key: string]: never }>;

export type CostQuery = {
    __typename: 'Query';
    getCosts: {
        __typename: 'Cost';
        predefinedMessage?: { __typename: 'CostNode'; cost: number } | null;
        eyeCatcher?: { __typename: 'CostNode'; cost: number } | null;
        friendship: { __typename: 'CostNode'; cost: number };
        match?: { __typename: 'CostNode'; cost: number } | null;
        message: { __typename: 'MessageCost'; cost: number; length: number };
        poke: { __typename: 'PokeCost'; cost: number; free?: number | null };
        picture?: { __typename: 'CostNode'; cost: number } | null;
    };
};

export type CountiesQueryVariables = Exact<{ [key: string]: never }>;

export type CountiesQuery = { __typename: 'Query'; getCounties: Array<string> };

export type CountriesQueryVariables = Exact<{ [key: string]: never }>;

export type CountriesQuery = {
    __typename: 'Query';
    getCountries: Array<string>;
};

export type DailySongsQueryVariables = Exact<{ [key: string]: never }>;

export type DailySongsQuery = {
    __typename: 'Query';
    findManyDailySong: Array<{
        __typename: 'DailySong';
        name: string;
        dailySongId: string;
        path: string;
    }>;
};

export type DeactivatedPushesQueryVariables = Exact<{
    d_Where?: InputMaybe<DeactivatedPushWhereInput>;
    d_OrderBy?: InputMaybe<DeactivatedPushOrderByInput>;
}>;

export type DeactivatedPushesQuery = {
    __typename: 'Query';
    findManyDeactivatedPush: Array<{
        __typename: 'DeactivatedPush';
        deactivatedPushId: string;
        setting: PushSetting;
    }>;
};

export type FavoritesQueryVariables = Exact<{
    f_Where?: InputMaybe<FavoriteWhereInput>;
    f_OrderBy?: InputMaybe<FavoriteOrderByInput>;
    f_Cursor?: InputMaybe<FavoriteWhereUniqueInput>;
    f_Skip?: InputMaybe<Scalars['Int']['input']>;
    f_Take?: InputMaybe<Scalars['Int']['input']>;
    withF_Other?: InputMaybe<Scalars['Boolean']['input']>;
    withF_O_Age?: InputMaybe<Scalars['Boolean']['input']>;
    withF_O_Theme?: InputMaybe<Scalars['Boolean']['input']>;
    withF_O_Images?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type FavoritesQuery = {
    __typename: 'Query';
    findManyFavorite: Array<{
        __typename: 'Favorite';
        createdAt: Date;
        favoriteId: string;
        otherId: string;
        other?: {
            __typename: 'Profile';
            age: number;
            acceptPicture: boolean;
            country: string;
            county: string;
            flirtText: string;
            gender: Gender;
            languageCode: string;
            profileId: string;
            profileName: string;
            searches: Gender;
            shownLocation: string;
            zodiacSign?: string | null;
            premiumStatus: Array<ProfileStatus>;
            theme?: { __typename: 'Theme'; name: string } | null;
            images?: Array<{
                __typename: 'Image';
                imageId: string;
                profileId: string;
                path: string;
                main: boolean;
                private: boolean;
            }>;
        };
    }>;
};

export type FavoritesCountQueryVariables = Exact<{
    f_Where?: InputMaybe<FavoriteWhereInput>;
    f_OrderBy?: InputMaybe<FavoriteOrderByInput>;
    f_Cursor?: InputMaybe<FavoriteWhereUniqueInput>;
    f_Skip?: InputMaybe<Scalars['Int']['input']>;
    f_Take?: InputMaybe<Scalars['Int']['input']>;
}>;

export type FavoritesCountQuery = {
    __typename: 'Query';
    findManyFavoriteCount: number;
};

export type FlagsQueryVariables = Exact<{ [key: string]: never }>;

export type FlagsQuery = {
    __typename: 'Query';
    findManyFlag: Array<{
        __typename: 'Flag';
        flagId: string;
        max?: number | null;
        maxLength: number;
        min?: number | null;
        minLength: number;
        name: string;
        numberStep?: string | null;
        gender: FlagGender;
        regEx?: string | null;
        type: FlagType;
        translations: Array<{
            __typename: 'Translation';
            translationId: string;
            translation: string;
            languageCode: string;
            giftCategoryId?: string | null;
            giftId?: string | null;
            interestCategoryId?: string | null;
            interestId?: string | null;
            translationView: TranslationView;
        }>;
        flagValues: Array<{
            __typename: 'FlagValue';
            flagId: string;
            flagValueId: string;
            translations: Array<{
                __typename: 'Translation';
                translationId: string;
                translation: string;
                languageCode: string;
                giftCategoryId?: string | null;
                giftId?: string | null;
                interestCategoryId?: string | null;
                interestId?: string | null;
                translationView: TranslationView;
            }>;
        }>;
    }>;
};

export type FriendshipsQueryVariables = Exact<{
    f_Where?: InputMaybe<FriendshipWhereInput>;
    f_OrderBy?: InputMaybe<FriendshipOrderByInput>;
    f_Cursor?: InputMaybe<FriendshipWhereUniqueInput>;
    f_Skip?: InputMaybe<Scalars['Int']['input']>;
    f_Take?: InputMaybe<Scalars['Int']['input']>;
    withF_Other?: InputMaybe<Scalars['Boolean']['input']>;
    withF_O_Age?: InputMaybe<Scalars['Boolean']['input']>;
    withF_O_Theme?: InputMaybe<Scalars['Boolean']['input']>;
    withF_O_Images?: InputMaybe<Scalars['Boolean']['input']>;
    withF_O_Favorite?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type FriendshipsQuery = {
    __typename: 'Query';
    findManyFriendship: Array<{
        __typename: 'Friendship';
        friendshipId: string;
        otherId: string;
        status: FriendshipStatus;
        updatedAt: Date;
        other?: {
            __typename: 'Profile';
            age: number;
            favorite?: boolean;
            acceptPicture: boolean;
            country: string;
            county: string;
            flirtText: string;
            gender: Gender;
            languageCode: string;
            profileId: string;
            profileName: string;
            searches: Gender;
            shownLocation: string;
            zodiacSign?: string | null;
            premiumStatus: Array<ProfileStatus>;
            theme?: { __typename: 'Theme'; name: string } | null;
            images?: Array<{
                __typename: 'Image';
                imageId: string;
                profileId: string;
                path: string;
                main: boolean;
                private: boolean;
            }>;
        };
    }>;
};

export type FriendshipsCountQueryVariables = Exact<{
    f_Where?: InputMaybe<FriendshipWhereInput>;
    f_OrderBy?: InputMaybe<FriendshipOrderByInput>;
    f_Cursor?: InputMaybe<FriendshipWhereUniqueInput>;
    f_Skip?: InputMaybe<Scalars['Int']['input']>;
    f_Take?: InputMaybe<Scalars['Int']['input']>;
}>;

export type FriendshipsCountQuery = {
    __typename: 'Query';
    findManyFriendshipCount: number;
};

export type GeolocationsQueryVariables = Exact<{
    g_Where: GeolocationWhereInput;
    g_OrderBy?: InputMaybe<GeolocationOrderByInput>;
    g_Cursor?: InputMaybe<GeolocationWhereUniqueInput>;
    g_Skip?: InputMaybe<Scalars['Int']['input']>;
    g_take?: InputMaybe<Scalars['Int']['input']>;
}>;

export type GeolocationsQuery = {
    __typename: 'Query';
    findManyGeolocation: Array<{
        __typename: 'Geolocation';
        geolocationId: string;
        country: string;
        postcode: string;
        location: string;
        state?: string | null;
        province?: string | null;
        community?: string | null;
        latitude: string;
        longitude: string;
    }>;
};

export type GetNextMatchesQueryVariables = Exact<{ [key: string]: never }>;

export type GetNextMatchesQuery = {
    __typename: 'Query';
    getNextMatches:
        | { __typename: 'Error'; errorCode: number; errorMessage: ErrorCodes }
        | {
              __typename: 'NextMatchResultSuccess';
              matches: Array<{
                  __typename: 'Match';
                  matchId: string;
                  ownerId: string;
                  playedAt?: Date | null;
                  profileId: string;
                  type: MatchType;
                  profile: {
                      __typename: 'Profile';
                      acceptPicture: boolean;
                      country: string;
                      county: string;
                      flirtText: string;
                      gender: Gender;
                      languageCode: string;
                      profileId: string;
                      profileName: string;
                      searches: Gender;
                      shownLocation: string;
                      zodiacSign?: string | null;
                      age: number;
                      premiumStatus: Array<ProfileStatus>;
                      images: Array<{
                          __typename: 'Image';
                          imageId: string;
                          profileId: string;
                          path: string;
                          main: boolean;
                          private: boolean;
                      }>;
                  };
              }>;
          };
};

export type GiftQueryVariables = Exact<{
    g_Where: GiftWhereUniqueInput;
    withG_Translations?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type GiftQuery = {
    __typename: 'Query';
    findOneGift?: {
        __typename: 'Gift';
        giftId: string;
        name: string;
        cost: number;
        path: string;
        translations?: Array<{
            __typename: 'Translation';
            translationId: string;
            translation: string;
            languageCode: string;
            giftCategoryId?: string | null;
            giftId?: string | null;
            interestCategoryId?: string | null;
            interestId?: string | null;
            translationView: TranslationView;
        }>;
    } | null;
};

export type GiftCategoriesQueryVariables = Exact<{
    g_Where?: InputMaybe<GiftCategoryWhereInput>;
    g_OrderBy?: InputMaybe<GiftCategoryOrderByInput>;
    g_Cursor?: InputMaybe<GiftCategoryWhereUniqueInput>;
    g_Skip?: InputMaybe<Scalars['Int']['input']>;
    g_Take?: InputMaybe<Scalars['Int']['input']>;
    withG_Gifts?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type GiftCategoriesQuery = {
    __typename: 'Query';
    findManyGiftCategory: Array<{
        __typename: 'GiftCategory';
        giftCategoryId: string;
        name: string;
        gifts?: Array<{
            __typename: 'Gift';
            giftId: string;
            name: string;
            cost: number;
            path: string;
            translations: Array<{
                __typename: 'Translation';
                translationId: string;
                translation: string;
                languageCode: string;
                giftCategoryId?: string | null;
                giftId?: string | null;
                interestCategoryId?: string | null;
                interestId?: string | null;
                translationView: TranslationView;
            }>;
        }>;
        translations: Array<{
            __typename: 'Translation';
            translationId: string;
            translation: string;
            languageCode: string;
            giftCategoryId?: string | null;
            giftId?: string | null;
            interestCategoryId?: string | null;
            interestId?: string | null;
            translationView: TranslationView;
        }>;
    }>;
};

export type GiftsQueryVariables = Exact<{
    g_Where?: InputMaybe<GiftWhereInput>;
    g_Cursor?: InputMaybe<GiftWhereUniqueInput>;
    g_Skip?: InputMaybe<Scalars['Int']['input']>;
    g_Take?: InputMaybe<Scalars['Int']['input']>;
}>;

export type GiftsQuery = {
    __typename: 'Query';
    findManyGift: Array<{
        __typename: 'Gift';
        giftId: string;
        name: string;
        cost: number;
        path: string;
        translations: Array<{
            __typename: 'Translation';
            translationId: string;
            translation: string;
            languageCode: string;
            giftCategoryId?: string | null;
            giftId?: string | null;
            interestCategoryId?: string | null;
            interestId?: string | null;
            translationView: TranslationView;
        }>;
    }>;
};

export type InterestCategoriesQueryVariables = Exact<{
    i_Cursor?: InputMaybe<InterestCategoryWhereUniqueInput>;
    i_Skip?: InputMaybe<Scalars['Int']['input']>;
    i_Take?: InputMaybe<Scalars['Int']['input']>;
    withI_Interests?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type InterestCategoriesQuery = {
    __typename: 'Query';
    findManyInterestCategory: Array<{
        __typename: 'InterestCategory';
        interestCategoryId: string;
        name: string;
        translations: Array<{
            __typename: 'Translation';
            translationId: string;
            translation: string;
            languageCode: string;
            giftCategoryId?: string | null;
            giftId?: string | null;
            interestCategoryId?: string | null;
            interestId?: string | null;
            translationView: TranslationView;
        }>;
        interests?: Array<{
            __typename: 'Interest';
            interestId: string;
            name: string;
            class?: string | null;
            path?: string | null;
            categoryId: string;
            translations: Array<{
                __typename: 'Translation';
                translationId: string;
                translation: string;
                languageCode: string;
                giftCategoryId?: string | null;
                giftId?: string | null;
                interestCategoryId?: string | null;
                interestId?: string | null;
                translationView: TranslationView;
            }>;
        }>;
    }>;
};

export type LanguagesQueryVariables = Exact<{ [key: string]: never }>;

export type LanguagesQuery = {
    __typename: 'Query';
    findManyLanguage: Array<{
        __typename: 'Language';
        code: string;
        name: string;
    }>;
};

export type LoginStreakConfigQueryVariables = Exact<{
    m_LanguageCode?: InputMaybe<Scalars['String']['input']>;
}>;

export type LoginStreakConfigQuery = {
    __typename: 'Query';
    loginStreakConfig?: {
        __typename: 'LoginStreak';
        defaultCoins: number;
        afterCapCoins: number;
        days: Array<{
            __typename: 'LoginStreakDay';
            day: number;
            coins: number;
            description?: string | null;
        }>;
    } | null;
};

export type MatchConfigQueryVariables = Exact<{ [key: string]: never }>;

export type MatchConfigQuery = {
    __typename: 'Query';
    matchConfig:
        | { __typename: 'Error'; errorCode: number; errorMessage: ErrorCodes }
        | {
              __typename: 'MatchConfigResultSuccess';
              limit: number;
              played: number;
              freeMessages: number;
              cost: number;
              buyMore: boolean;
          };
};

export type MatchCountQueryVariables = Exact<{
    m_Cursor?: InputMaybe<MatchWhereUniqueInput>;
    m_Skip?: InputMaybe<Scalars['Int']['input']>;
    m_Take?: InputMaybe<Scalars['Int']['input']>;
}>;

export type MatchCountQuery = {
    __typename: 'Query';
    findManyMatchCount: number;
};

export type MatchFilterQueryVariables = Exact<{ [key: string]: never }>;

export type MatchFilterQuery = {
    __typename: 'Query';
    getMatchFilter?: {
        __typename: 'MatchFilter';
        matchFilterId: string;
        userId: string;
        updatedAt: Date;
        ageFrom: number;
        ageTo: number;
        radius?: number | null;
    } | null;
};

export type MatchesQueryVariables = Exact<{
    m_Cursor?: InputMaybe<MatchWhereUniqueInput>;
    m_OrderBy?: InputMaybe<
        | Array<InputMaybe<MatchOrderByWithRelationInput>>
        | InputMaybe<MatchOrderByWithRelationInput>
    >;
    m_Skip?: InputMaybe<Scalars['Int']['input']>;
    m_Take?: InputMaybe<Scalars['Int']['input']>;
}>;

export type MatchesQuery = {
    __typename: 'Query';
    findManyMatch: Array<{
        __typename: 'Match';
        matchId: string;
        ownerId: string;
        playedAt?: Date | null;
        profileId: string;
        type: MatchType;
        profile: {
            __typename: 'Profile';
            acceptPicture: boolean;
            country: string;
            county: string;
            flirtText: string;
            gender: Gender;
            languageCode: string;
            profileId: string;
            profileName: string;
            searches: Gender;
            shownLocation: string;
            zodiacSign?: string | null;
            age: number;
            premiumStatus: Array<ProfileStatus>;
            images: Array<{
                __typename: 'Image';
                imageId: string;
                profileId: string;
                path: string;
                main: boolean;
                private: boolean;
            }>;
        };
    }>;
};

export type MessageCountQueryVariables = Exact<{
    m_Where?: InputMaybe<MessageWhereInput>;
    m_OrderBy?: InputMaybe<MessageOrderByInput>;
    m_Cursor?: InputMaybe<MessageWhereUniqueInput>;
    m_Skip?: InputMaybe<Scalars['Int']['input']>;
    m_Take?: InputMaybe<Scalars['Int']['input']>;
}>;

export type MessageCountQuery = {
    __typename: 'Query';
    findManyMessageCount?: number | null;
};

export type MessagesQueryVariables = Exact<{
    m_Where?: InputMaybe<MessageWhereInput>;
    m_OrderBy?: InputMaybe<MessageOrderByInput>;
    m_Cursor?: InputMaybe<MessageWhereUniqueInput>;
    m_Skip?: InputMaybe<Scalars['Int']['input']>;
    m_Take?: InputMaybe<Scalars['Int']['input']>;
    withM_Sender?: InputMaybe<Scalars['Boolean']['input']>;
    withM_S_Age?: InputMaybe<Scalars['Boolean']['input']>;
    withM_Picture?: InputMaybe<Scalars['Boolean']['input']>;
    withM_Gift?: InputMaybe<Scalars['Boolean']['input']>;
    withM_Conversation?: InputMaybe<Scalars['Boolean']['input']>;
    withM_C_LastMessage?: InputMaybe<Scalars['Boolean']['input']>;
    withM_C_L_Gift?: InputMaybe<Scalars['Boolean']['input']>;
    withM_C_L_Picture?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type MessagesQuery = {
    __typename: 'Query';
    findManyMessage: Array<{
        __typename: 'Message';
        senderId: string;
        text?: string | null;
        updatedAt: Date;
        coins: number;
        createdAt: Date;
        giftId?: string | null;
        messageId: string;
        model: MessageType;
        pictureId?: string | null;
        path?: string | null;
        sender?: {
            __typename: 'Profile';
            age: number;
            acceptPicture: boolean;
            country: string;
            county: string;
            flirtText: string;
            gender: Gender;
            languageCode: string;
            profileId: string;
            profileName: string;
            searches: Gender;
            shownLocation: string;
            zodiacSign?: string | null;
            premiumStatus: Array<ProfileStatus>;
        };
        picture?: {
            __typename: 'Picture';
            pictureId: string;
            path: string;
            ownerId: string;
            verified: boolean;
            hidden: boolean;
        } | null;
        gift?: {
            __typename: 'Gift';
            giftId: string;
            name: string;
            cost: number;
            path: string;
            translations: Array<{
                __typename: 'Translation';
                translationId: string;
                translation: string;
                languageCode: string;
                giftCategoryId?: string | null;
                giftId?: string | null;
                interestCategoryId?: string | null;
                interestId?: string | null;
                translationView: TranslationView;
            }>;
        } | null;
        conversation?: {
            __typename: 'Conversation';
            conversationId: string;
            blind: boolean;
            free: boolean;
            lastMessageId?: string | null;
            lastAction?: Date | null;
            support: boolean;
            lastMessage?: {
                __typename: 'Message';
                senderId: string;
                text?: string | null;
                updatedAt: Date;
                coins: number;
                createdAt: Date;
                giftId?: string | null;
                messageId: string;
                model: MessageType;
                pictureId?: string | null;
                path?: string | null;
                gift?: {
                    __typename: 'Gift';
                    giftId: string;
                    name: string;
                    cost: number;
                    path: string;
                    translations: Array<{
                        __typename: 'Translation';
                        translationId: string;
                        translation: string;
                        languageCode: string;
                        giftCategoryId?: string | null;
                        giftId?: string | null;
                        interestCategoryId?: string | null;
                        interestId?: string | null;
                        translationView: TranslationView;
                    }>;
                } | null;
                picture?: {
                    __typename: 'Picture';
                    pictureId: string;
                    path: string;
                    ownerId: string;
                    verified: boolean;
                    hidden: boolean;
                } | null;
            } | null;
        };
    }>;
};

export type MyProfileQueryVariables = Exact<{
    withM_Age?: InputMaybe<Scalars['Boolean']['input']>;
    withM_User?: InputMaybe<Scalars['Boolean']['input']>;
    m_ImagesWhere?: InputMaybe<ImageWhereInput>;
    m_ImagesOrderBy?: InputMaybe<
        Array<InputMaybe<ImageOrderByInput>> | InputMaybe<ImageOrderByInput>
    >;
    m_ImagesCursor?: InputMaybe<ImageWhereUniqueInput>;
    m_ImagesTake?: InputMaybe<Scalars['Int']['input']>;
    m_ImagesSkip?: InputMaybe<Scalars['Int']['input']>;
    m_ImagesDistinct?: InputMaybe<ImageDistinctFieldEnum>;
    withM_Images?: InputMaybe<Scalars['Boolean']['input']>;
    withM_ProfileInterests?: InputMaybe<Scalars['Boolean']['input']>;
    withM_ProfileFlags?: InputMaybe<Scalars['Boolean']['input']>;
    withM_P_Interest?: InputMaybe<Scalars['Boolean']['input']>;
    withM_Theme?: InputMaybe<Scalars['Boolean']['input']>;
    withM_T_Images?: InputMaybe<Scalars['Boolean']['input']>;
    m_T_ImagesWhere?: InputMaybe<ThemeImageWhereInput>;
    withM_Avatar?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type MyProfileQuery = {
    __typename: 'Query';
    myProfile: {
        __typename: 'MyProfile';
        defaultText?: string | null;
        avatarPath?: string | null;
        age?: number;
        furtherInformation?: string | null;
        acceptPicture: boolean;
        country: string;
        county: string;
        flirtText: string;
        gender: Gender;
        languageCode: string;
        profileId: string;
        profileName: string;
        searches: Gender;
        shownLocation: string;
        themeName?: string | null;
        birthDate?: string | null;
        completed: boolean;
        zodiacSign?: string | null;
        premiumStatus: Array<ProfileStatus>;
        avatar?: {
            __typename: 'Avatar';
            avatarId: string;
            name?: string | null;
            path: string;
            translations: Array<{
                __typename: 'Translation';
                translation: string;
                translationId: string;
                avatarId?: string | null;
                languageCode: string;
            }>;
        } | null;
        user?: {
            __typename: 'User';
            role: string;
            username: string;
            sendMarketingEmail: boolean;
            sendTransactionalEmail: boolean;
            sendSMS: boolean;
            imageCompleted: boolean;
            flirtTextCompleted: boolean;
            profileFlagsCompleted: boolean;
            emailValidated: boolean;
            mobileNumberValidated: boolean;
            email?: string | null;
            mobileNumber?: string | null;
            deleteToken: string;
            loginStreak: number;
        };
        images?: Array<{
            __typename: 'Image';
            verified: boolean;
            userChanged: Date;
            imageId: string;
            profileId: string;
            path: string;
            main: boolean;
            private: boolean;
        }>;
        profileInterests?: Array<{
            __typename: 'ProfileInterest';
            profileInterestId: string;
            profileId: string;
            interestName: string;
            interest?: {
                __typename: 'Interest';
                interestId: string;
                name: string;
                class?: string | null;
                path?: string | null;
                categoryId: string;
                translations: Array<{
                    __typename: 'Translation';
                    translationId: string;
                    translation: string;
                    languageCode: string;
                    giftCategoryId?: string | null;
                    giftId?: string | null;
                    interestCategoryId?: string | null;
                    interestId?: string | null;
                    translationView: TranslationView;
                }>;
            };
        }>;
        profileFlags?: Array<{
            __typename: 'ProfileFlag';
            profileFlagId: string;
            flagValueId?: string | null;
            value?: string | null;
            flag: {
                __typename: 'Flag';
                flagId: string;
                name: string;
                translations: Array<{
                    __typename: 'Translation';
                    translationId: string;
                    translation: string;
                    languageCode: string;
                    giftCategoryId?: string | null;
                    giftId?: string | null;
                    interestCategoryId?: string | null;
                    interestId?: string | null;
                    translationView: TranslationView;
                }>;
            };
            flagValue?: {
                __typename: 'FlagValue';
                flagId: string;
                flagValueId: string;
                translations: Array<{
                    __typename: 'Translation';
                    translationId: string;
                    translation: string;
                    languageCode: string;
                    giftCategoryId?: string | null;
                    giftId?: string | null;
                    interestCategoryId?: string | null;
                    interestId?: string | null;
                    translationView: TranslationView;
                }>;
            } | null;
        }>;
        theme?: {
            __typename: 'Theme';
            name: string;
            images?: Array<{
                __typename: 'ThemeImage';
                label: string;
                path: string;
                themeImageId: string;
                themeName: string;
            }>;
        } | null;
    };
};

export type NotificationCountQueryVariables = Exact<{
    n_Where?: InputMaybe<NotificationWhereInput>;
    n_OrderBy?: InputMaybe<NotificationOrderByInput>;
    n_Cursor?: InputMaybe<NotificationWhereUniqueInput>;
    n_Skip?: InputMaybe<Scalars['Int']['input']>;
    n_Take?: InputMaybe<Scalars['Int']['input']>;
}>;

export type NotificationCountQuery = {
    __typename: 'Query';
    findManyNotificationCount: number;
};

export type NotificationsQueryVariables = Exact<{
    n_Where?: InputMaybe<NotificationWhereInput>;
    n_OrderBy?: InputMaybe<NotificationOrderByInput>;
    n_Cursor?: InputMaybe<NotificationWhereUniqueInput>;
    n_Skip?: InputMaybe<Scalars['Int']['input']>;
    n_Take?: InputMaybe<Scalars['Int']['input']>;
    withN_Profile?: InputMaybe<Scalars['Boolean']['input']>;
    withN_P_Age?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type NotificationsQuery = {
    __typename: 'Query';
    findManyNotification: Array<{
        __typename: 'Notification';
        notificationId: string;
        target?: string | null;
        type: NotificationType;
        read: boolean;
        updatedAt: Date;
        createdAt: Date;
        profile?: {
            __typename: 'Profile';
            profileId: string;
            age?: number;
        } | null;
    }>;
};

export type OffersQueryVariables = Exact<{
    o_Where: OfferWhereInput;
    o_OrderBy?: InputMaybe<OfferOrderByInput>;
    o_Cursor?: InputMaybe<OfferWhereUniqueInput>;
    o_Skip?: InputMaybe<Scalars['Int']['input']>;
    o_Take?: InputMaybe<Scalars['Int']['input']>;
    withO_Provider?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type OffersQuery = {
    __typename: 'Query';
    findManyOffer: Array<{
        __typename: 'Offer';
        offerId: string;
        name: string;
        cost: number;
        coins: number;
        bonus: number;
        extra: string;
        currency: string;
        providerName: string;
        periodUnit: PeriodUnitOffer;
        profileStatus?: ProfileStatus | null;
        statusPeriod: number;
        provider?: {
            __typename: 'Provider';
            providerId: string;
            name: string;
            logo: string;
            title: string;
            description?: string | null;
            currency: string;
        };
    }>;
};

export type OptionPollsQueryVariables = Exact<{ [key: string]: never }>;

export type OptionPollsQuery = {
    __typename: 'Query';
    findManyOptionPoll: Array<{
        __typename: 'OptionPoll';
        optionPollId: string;
        name: string;
        text: string;
        position: number;
        languageCode: string;
        answers: Array<{
            __typename: 'OptionPollAnswer';
            optionPollAnswerId: string;
            text: string;
            optionPollId: string;
            languageCode: string;
            votes: string;
            path?: string | null;
        }>;
        myAnswer?: {
            __typename: 'ProfileOptionPoll';
            optionPollAnswerId: string;
            optionPollId: string;
            profileId: string;
            profileOptionPollId: string;
            createdAt: Date;
        } | null;
    }>;
};

export type PicturesQueryVariables = Exact<{
    p_Take?: InputMaybe<Scalars['Int']['input']>;
    p_Skip?: InputMaybe<Scalars['Int']['input']>;
}>;

export type PicturesQuery = {
    __typename: 'Query';
    findManyPicture: Array<{
        __typename: 'Picture';
        pictureId: string;
        path: string;
        ownerId: string;
        verified: boolean;
        hidden: boolean;
    }>;
};

export type PredefinedMessagesQueryVariables = Exact<{ [key: string]: never }>;

export type PredefinedMessagesQuery = {
    __typename: 'Query';
    findManyPredefinedMessage: Array<{
        __typename: 'PredefinedMessage';
        path?: string | null;
        predefinedMessageId: string;
        translations: Array<{
            __typename: 'Translation';
            translation: string;
            translationId: string;
            predefinedMessageId?: string | null;
            languageCode: string;
        }>;
    }>;
};

export type ProfileQueryVariables = Exact<{
    p_Where: ProfileWhereUniqueInput;
    p_ImagesWhere?: InputMaybe<ImageWhereInput>;
    p_ImagesOrderBy?: InputMaybe<
        Array<InputMaybe<ImageOrderByInput>> | InputMaybe<ImageOrderByInput>
    >;
    p_ImagesCursor?: InputMaybe<ImageWhereUniqueInput>;
    p_ImagesTake?: InputMaybe<Scalars['Int']['input']>;
    p_ImagesSkip?: InputMaybe<Scalars['Int']['input']>;
    p_ImagesDistinct?: InputMaybe<ImageDistinctFieldEnum>;
    withP_Images?: InputMaybe<Scalars['Boolean']['input']>;
    withP_Age?: InputMaybe<Scalars['Boolean']['input']>;
    withP_ProfileFlags?: InputMaybe<Scalars['Boolean']['input']>;
    withP_ProfileInterests?: InputMaybe<Scalars['Boolean']['input']>;
    withP_P_Interest?: InputMaybe<Scalars['Boolean']['input']>;
    withP_Blocked?: InputMaybe<Scalars['Boolean']['input']>;
    withP_Favorite?: InputMaybe<Scalars['Boolean']['input']>;
    withP_FriendshipStatus?: InputMaybe<Scalars['Boolean']['input']>;
    withP_Theme?: InputMaybe<Scalars['Boolean']['input']>;
    withP_T_Images?: InputMaybe<Scalars['Boolean']['input']>;
    withP_Avatar?: InputMaybe<Scalars['Boolean']['input']>;
    withP_DefaultText?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type ProfileQuery = {
    __typename: 'Query';
    findOneProfile?: {
        __typename: 'Profile';
        defaultText?: string | null;
        avatarPath?: string | null;
        age: number;
        furtherInformation?: string | null;
        blocked?: boolean;
        favorite?: boolean;
        friendshipStatus?: string | null;
        acceptPicture: boolean;
        country: string;
        county: string;
        flirtText: string;
        gender: Gender;
        languageCode: string;
        profileId: string;
        profileName: string;
        searches: Gender;
        shownLocation: string;
        zodiacSign?: string | null;
        premiumStatus: Array<ProfileStatus>;
        theme?: {
            __typename: 'Theme';
            name: string;
            images?: Array<{
                __typename: 'ThemeImage';
                label: string;
                path: string;
                themeImageId: string;
                themeName: string;
            }>;
        } | null;
        avatar?: {
            __typename: 'Avatar';
            avatarId: string;
            name?: string | null;
            path: string;
            translations: Array<{
                __typename: 'Translation';
                translation: string;
                translationId: string;
                avatarId?: string | null;
                languageCode: string;
            }>;
        } | null;
        images?: Array<{
            __typename: 'Image';
            imageId: string;
            profileId: string;
            path: string;
            main: boolean;
            private: boolean;
        }>;
        profileFlags?: Array<{
            __typename: 'ProfileFlag';
            profileFlagId: string;
            flagValueId?: string | null;
            value?: string | null;
            flag: {
                __typename: 'Flag';
                flagId: string;
                name: string;
                translations: Array<{
                    __typename: 'Translation';
                    translationId: string;
                    translation: string;
                    languageCode: string;
                    giftCategoryId?: string | null;
                    giftId?: string | null;
                    interestCategoryId?: string | null;
                    interestId?: string | null;
                    translationView: TranslationView;
                }>;
            };
            flagValue?: {
                __typename: 'FlagValue';
                flagId: string;
                flagValueId: string;
                translations: Array<{
                    __typename: 'Translation';
                    translationId: string;
                    translation: string;
                    languageCode: string;
                    giftCategoryId?: string | null;
                    giftId?: string | null;
                    interestCategoryId?: string | null;
                    interestId?: string | null;
                    translationView: TranslationView;
                }>;
            } | null;
        }>;
        profileInterests?: Array<{
            __typename: 'ProfileInterest';
            profileInterestId: string;
            profileId: string;
            interestName: string;
            interest?: {
                __typename: 'Interest';
                interestId: string;
                name: string;
                class?: string | null;
                path?: string | null;
                categoryId: string;
                translations: Array<{
                    __typename: 'Translation';
                    translationId: string;
                    translation: string;
                    languageCode: string;
                    giftCategoryId?: string | null;
                    giftId?: string | null;
                    interestCategoryId?: string | null;
                    interestId?: string | null;
                    translationView: TranslationView;
                }>;
            };
        }>;
    } | null;
};

export type ProfileCountQueryVariables = Exact<{
    p_Where?: InputMaybe<ProfileWhereInput>;
    p_OrderBy?: InputMaybe<ProfileOrderByInput>;
    p_Cursor?: InputMaybe<ProfileWhereUniqueInput>;
    p_Skip?: InputMaybe<Scalars['Int']['input']>;
    p_Take?: InputMaybe<Scalars['Int']['input']>;
}>;

export type ProfileCountQuery = {
    __typename: 'Query';
    findManyProfileCount: number;
};

export type ProfileTextsQueryVariables = Exact<{ [key: string]: never }>;

export type ProfileTextsQuery = {
    __typename: 'Query';
    findManyProfileText: Array<{
        __typename: 'ProfileText';
        profileTextId: string;
        translations: Array<{
            __typename: 'Translation';
            translationId: string;
            profileTextId?: string | null;
            languageCode: string;
            translation: string;
        }>;
    }>;
};

export type ProfilesQueryVariables = Exact<{
    p_Where?: InputMaybe<ProfileWhereInputExtended>;
    p_OrderBy?: InputMaybe<ProfileOrderByInput>;
    p_Cursor?: InputMaybe<ProfileWhereUniqueInput>;
    p_Skip?: InputMaybe<Scalars['Int']['input']>;
    p_Take?: InputMaybe<Scalars['Int']['input']>;
    withP_Age?: InputMaybe<Scalars['Boolean']['input']>;
    withP_Images?: InputMaybe<Scalars['Boolean']['input']>;
    withP_Favorite?: InputMaybe<Scalars['Boolean']['input']>;
    withP_FriendshipStatus?: InputMaybe<Scalars['Boolean']['input']>;
    withP_Avatar?: InputMaybe<Scalars['Boolean']['input']>;
    withP_DefaultText?: InputMaybe<Scalars['Boolean']['input']>;
    withP_Theme?: InputMaybe<Scalars['Boolean']['input']>;
    withP_T_Images?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type ProfilesQuery = {
    __typename: 'Query';
    findManyProfile: Array<{
        __typename: 'Profile';
        defaultText?: string | null;
        avatarPath?: string | null;
        age: number;
        favorite?: boolean;
        friendshipStatus?: string | null;
        acceptPicture: boolean;
        country: string;
        county: string;
        flirtText: string;
        gender: Gender;
        languageCode: string;
        profileId: string;
        profileName: string;
        searches: Gender;
        shownLocation: string;
        zodiacSign?: string | null;
        premiumStatus: Array<ProfileStatus>;
        theme?: {
            __typename: 'Theme';
            name: string;
            images?: Array<{
                __typename: 'ThemeImage';
                label: string;
                path: string;
                themeImageId: string;
                themeName: string;
            }>;
        } | null;
        avatar?: {
            __typename: 'Avatar';
            avatarId: string;
            name?: string | null;
            path: string;
            translations: Array<{
                __typename: 'Translation';
                translation: string;
                translationId: string;
                avatarId?: string | null;
                languageCode: string;
            }>;
        } | null;
        images?: Array<{
            __typename: 'Image';
            imageId: string;
            profileId: string;
            path: string;
            main: boolean;
            private: boolean;
        }>;
    }>;
};

export type ProvidersQueryVariables = Exact<{
    p_Where?: InputMaybe<ProviderWhereInput>;
    p_OrderBy?: InputMaybe<ProviderOrderByInput>;
    p_Cursor?: InputMaybe<ProviderWhereUniqueInput>;
    p_Skip?: InputMaybe<Scalars['Int']['input']>;
    p_Take?: InputMaybe<Scalars['Int']['input']>;
    p_OffersWhere?: InputMaybe<OfferWhereInput>;
    p_OffersOrderBy?: InputMaybe<OfferOrderByInput>;
    p_OffersCursor?: InputMaybe<OfferWhereUniqueInput>;
    p_OffersSkip?: InputMaybe<Scalars['Int']['input']>;
    p_OffersTake?: InputMaybe<Scalars['Int']['input']>;
    p_OffersDistinct?: InputMaybe<OfferDistinctFieldEnum>;
    withP_Offers?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type ProvidersQuery = {
    __typename: 'Query';
    findManyProvider: Array<{
        __typename: 'Provider';
        providerId: string;
        name: string;
        logo: string;
        title: string;
        description?: string | null;
        currency: string;
        offers?: Array<{
            __typename: 'Offer';
            offerId: string;
            name: string;
            cost: number;
            coins: number;
            bonus: number;
            extra: string;
            currency: string;
            providerName: string;
            periodUnit: PeriodUnitOffer;
            profileStatus?: ProfileStatus | null;
            statusPeriod: number;
        }>;
    }>;
};

export type SupportMessageCountQueryVariables = Exact<{ [key: string]: never }>;

export type SupportMessageCountQuery = {
    __typename: 'Query';
    unreadSupportMessageCount: number;
};

export type SupportTicketQueryVariables = Exact<{
    s_Where: SupportTicketWhereUniqueInput;
    withS_SupportMessages?: InputMaybe<Scalars['Boolean']['input']>;
    s_SupportMessagesWhere?: InputMaybe<SupportMessageWhereInput>;
    s_SupportMessagesOrderBy?: InputMaybe<
        | Array<InputMaybe<SupportMessageOrderByInput>>
        | InputMaybe<SupportMessageOrderByInput>
    >;
    s_SupportMessagesCursor?: InputMaybe<SupportMessageWhereUniqueInput>;
    s_SupportMessagesSkip?: InputMaybe<Scalars['Int']['input']>;
    s_SupportMessagesTake?: InputMaybe<Scalars['Int']['input']>;
}>;

export type SupportTicketQuery = {
    __typename: 'Query';
    findOneSupportTicket?: {
        __typename: 'SupportTicket';
        supportTicketId: string;
        status: SupportTicketStatus;
        createdAt: Date;
        updatedAt: Date;
        category: SupportCategory;
        ticketNumber: number;
        supportMessages?: Array<{
            __typename: 'SupportMessage';
            supportMessageId: string;
            text: string;
            createdAt: Date;
            updatedAt: Date;
            sender: SupportMessageSender;
            supportTicketId: string;
            read: boolean;
        }>;
    } | null;
};

export type SupportTicketsQueryVariables = Exact<{
    s_Where?: InputMaybe<SupportTicketWhereInput>;
    s_OrderBy?: InputMaybe<
        | Array<InputMaybe<SupportTicketOrderByInput>>
        | InputMaybe<SupportTicketOrderByInput>
    >;
    s_Cursor?: InputMaybe<SupportTicketWhereUniqueInput>;
    s_Skip?: InputMaybe<Scalars['Int']['input']>;
    s_Take?: InputMaybe<Scalars['Int']['input']>;
    withS_SupportMessages?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type SupportTicketsQuery = {
    __typename: 'Query';
    findManySupportTicket: Array<{
        __typename: 'SupportTicket';
        supportTicketId: string;
        status: SupportTicketStatus;
        createdAt: Date;
        updatedAt: Date;
        category: SupportCategory;
        ticketNumber: number;
        supportMessages?: Array<{
            __typename: 'SupportMessage';
            supportMessageId: string;
            text: string;
            createdAt: Date;
            updatedAt: Date;
            sender: SupportMessageSender;
            supportTicketId: string;
            read: boolean;
        }>;
    }>;
};

export type ThemesQueryVariables = Exact<{ [key: string]: never }>;

export type ThemesQuery = {
    __typename: 'Query';
    findManyTheme: Array<{
        __typename: 'Theme';
        name: string;
        images: Array<{
            __typename: 'ThemeImage';
            label: string;
            path: string;
            themeImageId: string;
            themeName: string;
        }>;
    }>;
};

export type TransactionQueryQueryVariables = Exact<{
    t_Where: TransactionWhereUniqueInput;
}>;

export type TransactionQueryQuery = {
    __typename: 'Query';
    findOneTransaction: {
        __typename: 'Transaction';
        transactionId: string;
        coins: number;
        currency: string;
        providerName: string;
        cost: number;
    };
};

export type TranslationCountQueryVariables = Exact<{
    s_Where?: InputMaybe<TranslationWhereInput>;
    s_Cursor?: InputMaybe<TranslationWhereUniqueInput>;
    s_Skip?: InputMaybe<Scalars['Int']['input']>;
    s_Take?: InputMaybe<Scalars['Int']['input']>;
}>;

export type TranslationCountQuery = {
    __typename: 'Query';
    findManyTranslationCount: number;
};

export type TranslationsQueryVariables = Exact<{
    s_Where?: InputMaybe<TranslationWhereInput>;
    s_Cursor?: InputMaybe<TranslationWhereUniqueInput>;
    s_Skip?: InputMaybe<Scalars['Int']['input']>;
    s_Take?: InputMaybe<Scalars['Int']['input']>;
}>;

export type TranslationsQuery = {
    __typename: 'Query';
    findManyTranslation: Array<{
        __typename: 'Translation';
        avatarId?: string | null;
        profileTextId?: string | null;
        translationId: string;
        translation: string;
        languageCode: string;
        giftCategoryId?: string | null;
        giftId?: string | null;
        interestCategoryId?: string | null;
        interestId?: string | null;
        translationView: TranslationView;
    }>;
};

export type UserPremiumStatusQueryVariables = Exact<{ [key: string]: never }>;

export type UserPremiumStatusQuery = {
    __typename: 'Query';
    userPremiumStatus: Array<{
        __typename: 'UserPremiumStatus';
        createdAt: Date;
        validTo: Date;
        userId: string;
        status: ProfileStatus;
        profilePremiumStatusId: string;
    }>;
};

export type VisitQueryVariables = Exact<{
    v_Where?: InputMaybe<VisitWhereInput>;
    v_OrderBy?: InputMaybe<VisitOrderByInput>;
    v_Cursor?: InputMaybe<VisitWhereUniqueInput>;
    v_Skip?: InputMaybe<Scalars['Int']['input']>;
    v_Take?: InputMaybe<Scalars['Int']['input']>;
    v_ImagesWhere?: InputMaybe<ImageWhereInput>;
    v_ImagesOrderBy?: InputMaybe<
        Array<InputMaybe<ImageOrderByInput>> | InputMaybe<ImageOrderByInput>
    >;
    v_ImagesCursor?: InputMaybe<ImageWhereUniqueInput>;
    v_ImagesTake?: InputMaybe<Scalars['Int']['input']>;
    v_ImagesSkip?: InputMaybe<Scalars['Int']['input']>;
    v_ImagesDistinct?: InputMaybe<ImageDistinctFieldEnum>;
    withV_Other?: InputMaybe<Scalars['Boolean']['input']>;
    withV_O_Images?: InputMaybe<Scalars['Boolean']['input']>;
    withV_O_Age?: InputMaybe<Scalars['Boolean']['input']>;
    withV_O_Theme?: InputMaybe<Scalars['Boolean']['input']>;
    withV_O_ProfileFlags?: InputMaybe<Scalars['Boolean']['input']>;
    withV_O_ProfileInterests?: InputMaybe<Scalars['Boolean']['input']>;
    withV_O_P_Interest?: InputMaybe<Scalars['Boolean']['input']>;
    withV_O_Blocked?: InputMaybe<Scalars['Boolean']['input']>;
    withV_O_Favorite?: InputMaybe<Scalars['Boolean']['input']>;
    withV_O_FriendshipStatus?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type VisitQuery = {
    __typename: 'Query';
    findManyVisit: Array<{
        __typename: 'Visit';
        visitId: string;
        otherId: string;
        createdAt: Date;
        other?: {
            __typename: 'Profile';
            age: number;
            furtherInformation?: string | null;
            blocked?: boolean;
            favorite?: boolean;
            friendshipStatus?: string | null;
            acceptPicture: boolean;
            country: string;
            county: string;
            flirtText: string;
            gender: Gender;
            languageCode: string;
            profileId: string;
            profileName: string;
            searches: Gender;
            shownLocation: string;
            zodiacSign?: string | null;
            premiumStatus: Array<ProfileStatus>;
            images?: Array<{
                __typename: 'Image';
                imageId: string;
                profileId: string;
                path: string;
                main: boolean;
                private: boolean;
            }>;
            theme?: { __typename: 'Theme'; name: string } | null;
            profileFlags?: Array<{
                __typename: 'ProfileFlag';
                profileFlagId: string;
                flagValueId?: string | null;
                value?: string | null;
                flag: {
                    __typename: 'Flag';
                    flagId: string;
                    name: string;
                    translations: Array<{
                        __typename: 'Translation';
                        translationId: string;
                        translation: string;
                        languageCode: string;
                        giftCategoryId?: string | null;
                        giftId?: string | null;
                        interestCategoryId?: string | null;
                        interestId?: string | null;
                        translationView: TranslationView;
                    }>;
                };
                flagValue?: {
                    __typename: 'FlagValue';
                    flagId: string;
                    flagValueId: string;
                    translations: Array<{
                        __typename: 'Translation';
                        translationId: string;
                        translation: string;
                        languageCode: string;
                        giftCategoryId?: string | null;
                        giftId?: string | null;
                        interestCategoryId?: string | null;
                        interestId?: string | null;
                        translationView: TranslationView;
                    }>;
                } | null;
            }>;
            profileInterests?: Array<{
                __typename: 'ProfileInterest';
                profileInterestId: string;
                profileId: string;
                interestName: string;
                interest?: {
                    __typename: 'Interest';
                    interestId: string;
                    name: string;
                    class?: string | null;
                    path?: string | null;
                    categoryId: string;
                    translations: Array<{
                        __typename: 'Translation';
                        translationId: string;
                        translation: string;
                        languageCode: string;
                        giftCategoryId?: string | null;
                        giftId?: string | null;
                        interestCategoryId?: string | null;
                        interestId?: string | null;
                        translationView: TranslationView;
                    }>;
                };
            }>;
        };
    }>;
};

export type VisitCountQueryVariables = Exact<{
    v_Where?: InputMaybe<VisitWhereInput>;
    v_OrderBy?: InputMaybe<VisitOrderByInput>;
    v_Cursor?: InputMaybe<VisitWhereUniqueInput>;
    v_Skip?: InputMaybe<Scalars['Int']['input']>;
    v_Take?: InputMaybe<Scalars['Int']['input']>;
}>;

export type VisitCountQuery = {
    __typename: 'Query';
    findManyVisitCount: number;
};

export type NotificationSubscriptionVariables = Exact<{ [key: string]: never }>;

export type NotificationSubscription = {
    __typename: 'Subscription';
    notifications?:
        | {
              __typename: 'NotificationSubscriptionCoinsAddedPayload';
              coinsChanged: number;
              totalCoins: number;
              type: NotificationType;
          }
        | {
              __typename: 'NotificationSubscriptionFriendshipPayload';
              type: NotificationType;
              friendshipId: string;
              senderId: string;
              senderName: string;
          }
        | {
              __typename: 'NotificationSubscriptionGiftPayload';
              type: NotificationType;
              giftId: string;
              text: string;
              senderId: string;
              senderName: string;
              conversationId: string;
          }
        | {
              __typename: 'NotificationSubscriptionImagePayload';
              imageId: string;
              type: NotificationType;
          }
        | {
              __typename: 'NotificationSubscriptionLikePayload';
              type: NotificationType;
              otherProfileId: string;
          }
        | {
              __typename: 'NotificationSubscriptionMatchPayload';
              type: NotificationType;
              otherProfileId: string;
              matchId: string;
          }
        | {
              __typename: 'NotificationSubscriptionMessagePayload';
              type: NotificationType;
              text: string;
              senderId: string;
              senderName: string;
              conversationId: string;
          }
        | {
              __typename: 'NotificationSubscriptionPaymentPayload';
              type: NotificationType;
              transactionId: string;
              coins: number;
              provider: string;
          }
        | { __typename: 'NotificationSubscriptionPicturePayload' }
        | {
              __typename: 'NotificationSubscriptionPokePayload';
              type: NotificationType;
              senderName: string;
              senderId: string;
              conversationId: string;
          }
        | {
              __typename: 'NotificationSubscriptionProfileTextChangedPayload';
              type: NotificationType;
          }
        | {
              __typename: 'NotificationSubscriptionSupportMessagePayload';
              supportMessageId: string;
              text: string;
              type: NotificationType;
              supportTicketId: string;
          }
        | {
              __typename: 'NotificationSubscriptionVisitPayload';
              type: NotificationType;
              senderId: string;
              senderName: string;
          }
        | null;
};
